import { commandConstants } from 'src/app/constants';

export enum TerrainColorEnum {
  TERRAIN_COLOR = 0,
  TERRAIN_HEIGHT_COLOR = 1,
}

export enum EClassification {
  'TOP SECRET' = 1,
  'SECRET' = 2,
  'CONFIDENTIAL' = 3,
  'RESTRICTED' = 4,
  'PROTECTED' = 5,
  'UNCLASSIFIED' = 6,
}

export enum EEnvironmentalUnitType {
  CIRCLE = 0,
  POLYGON = 1,
}

export enum IntikalEdenTipi {
  Yaya = 0,
  PaletliArac = 1,
  TekerlekliAraziArac = 2,
  TekerlekliArac = 3,
}

export enum EFaydaliYukTipi {
  Systems = 0,
  Supplies,
  Aircraft,
  CommunicationDevice,
  Navalcraft,
  Obstacle,
  Spacecraft,
  Payload,
}

export enum EAracFaydaliYukTipi {
  NavalCraft = 0,
  AirCraft = 1,
}

export enum EIkmalBirim {
  // Ton = 0,
  Liter = 1,
  Piece = 2,
  Kilogram = 3,
  Kilowatt = 4,
}

export enum ETaraflarArasiIliskiler {
  SAME = 0,
  FRIENDLY = 1,
  ALLY = 2,
  ENEMY = 3,
  NEUTRAL = 4,
  SUSPICIOUS = 5,
}

export enum ETaraflarArasiIliskiKontrolü {
  KENDI_TARAFI = 0,
  DOST = 1,
  DOST_VE_TARAFSIZ = 2,
  DUSMAN = 3,
  DUSMAN_VE_TARAFSIZ = 4,
  TARAFSIZ = 5,
}

export enum EMuhimmatGerekliIkmalTipi {
  Decontamination = 0,
  Protect = 1,
}

export enum ENesneTipi {
  TMK = 0,
  HavaAraci = 65,
  DenizAraci = 66,
  UzayAraci = 67,
  Engel = 32,
}

export enum EPistMalzemesi {
  Asphalt = 0,
  Concrete = 1,
  Tarmac = 2,
  Other = 3,
  Mixed = 4,
}

export enum EDugumNoktasiTuru {
  Coordinate = 0,
  Navaid = 1,
  Intersection = 2,
}

export enum EDugumTuru {
  Intersection = 0,
  Bridge = 1,
  Tunnel = 2,
}

export enum EEqualLessGreater {
  Less = 0,
  Equal = 1,
  Greater = 2,
  GreaterAndEqual = 3,
  LessAndEqual = 4,
}

export enum EEqualLessGreaterUnicode {
  '\u003c' = 0,
  '\u003d' = 1,
  '\u003e' = 2,
  '\u2265' = 3,
  '\u2264' = 4,
}

export enum EEqualLessGreaterUnicodeSign {
  Less = '\u003c',
  Equal = '\u003d',
  Greater = '\u003e',
  GreaterAndEqual = '\u2265',
  LessAndEqual = '\u2264',
}

export enum EDenizAraciBatma {
  Location = 0,
  Shape = 1,
}

export enum EAlgilamaDerinlikIrtifa {
  Altitude = 0,
  Depth = 1,
}

export enum EFaaliyet {
  BOS = 0, // Faaliyet ataması yapılmamış // DİKKAT -> Aktif bir etmenin faaliyeti boş olamaz
  ETKISIZ = 1, // Zayiat oranı %100'e ulaşmış etmen faaliyeti
  GUNLUK = 2, // Günlük Faaliyet
  HARP_ESIRI = 3,
  INTIKAL = 4,
  KESIF = 5,
  SAVUNMA = 6,
  EYP_YERLESTIRME = 7, // El Yapımı Patlayıcı Yerleştirme
  GOREREK_ATIS = 8, // Yatık yollu silahlarla yapılan atış
  GORMEYEREK_ATIS = 9, // Eğik yollu silahlarla yapılan atış
  TAARRUZ = 10,
  EYP_TEMIZLIGI = 11, // El Yapımı Patlayıcı Temizliği
  KARA_HAVA_FUZESI_ANGAJMANI = 12, // Karadan havaya füze ateşleyen etmen faaliyeti
  KBRN_DEKONTAMINASYON = 13,
  YAKIN_HAVA_DESTEGI = 14,
  DENIZ_TOPCUSU_DESTEGI = 15,
  NIZAM = 16,
  GERI_CEKILME = 17,
  HAVA_GOREVI = 18, // Sadece hava görevi için kullanılır.
  KAZAZEDE = 19,
  IKMAL = 20, // İkmal verene her zaman atama yapılır, İkmal alan ikmal almak için başka bir yere hareket ediyorsa atanır.
  MAYIN_DOSEME = 21,
  ENGEL = 22,
  MAYIN_TEMIZLEME = 23,
  FUZE = 24, // Füze etmeninin kendi faaliyeti(ateşleyenin değil)
  ISINLANMA = 25,
  TORPIDO_ANGAJMANI = 26, // Torpido ateşleyen etmenin faaliyeti
  ANGAJMAN_KURALI = 27,
  DENIZ_TASIMA = 28,
  MUHABERE = 29,
  KBRN_ATISI = 30,
  BATIYOR = 31,
  ENGEL_DOSEME = 32,
  ENGEL_TEMIZLEME = 33,
  ETMEN_OLUSTURMA = 34,
  IKMAL_YUKLEME = 35,
  DENIZ_KARAKOL_GOREVI = 36,
  SU_ALTI_BOMBA_ANGAJMANI = 37, // Su altı bomba ateşleyen etmenin faaliyeti
  DENIZ_CIKMA_ARAMA = 38,
  DENIZ_DOCK = 39,
  DENIZDE_IKMAL = 40,
  DENIZ_ETMENI_HASARLI = 41, // Intikal içeren bütün emirler reddedilir, bakımdan sonra ya da tamamla emri ile tekrar kabul edebilir.
  DENIZ_ETMENI_CEKME = 42,
  ALTYAPI_INSA = 43,
  YAKIT_SIZDIRMA = 44,
  YAKIT_SIZINTISI = 45,
  TESLIM_OL = 46,
  ESIR_AL = 47,
  ESIR_DEVRET = 48,
  SERBEST_BIRAK = 49,
  DENIZ_CIKMA_ELE_GECIRME = 50,
  DENIZ_CIKMA_KURTARMA = 51,
  ETMEN_SIL = 52,
  ETMEN_BIRLESTIR = 53,
  ETMEN_BOL = 54,
  HAVA_GOREVI_OLUSTUR = 55,
  DENIZ_CIKMA_ESIR_ALMA = 56,
  KARISTIR = 57,
  TORPIDO = 58, // Torpido etmeninin kendi faaliyeti (ateşleyen değil)
  SU_ALTI_BOMBA = 59, // Su altı bomba etmeninin kendi faaliyet (ateşleyen değil)
  KARA_KARA_FUZESI_ANGAJMANI = 60, // Karadan karaya füze ateşleyen etmen faaliyeti
  SEYIR_FUZESI_ANGAJMANI = 61, // Seyir füzesi ateşleyen etmen faaliyeti
  PUSU = 62,
  BASKIN = 63,
  YENI_HACIM = 64,
  BINA_TEMIZLIGI = 65,
  MANIFESTODAN_CIKARMA = 66,
  ARAMA_KURTARMA = 67,
  YORUNGE_ETRAFINDA_DONME = 68,

  BEKLEMEDE = 127, // Etmene atanmaz. Bekleme flag'i true olan etmenlerin faaliyeti, önyüze bu değerle aktarılır.
  TASINIYOR = 128,
  CEKILIYOR = 129,
  GOCUK_ALTINDA = 130,
  KURTARILAN = 131,
  BAKIM = 132,
  KARA_TASIMA = 133,
  KARA_BINDIRILDI = 134,
  SONOBUOY = 135,
  AFETZEDE = 180,
} // End enum Faaliyet

// EHarekatSafhasi
export enum ESubFaaliyet {
  IDLE = 0,

  'MOVE PREPARATION',
  'MOVE EXECUTION',
  'MOVE TERMINATION',

  'ATTACK PREPARATION',
  'TACTICAL MOVEMENT',
  'ATTACK START LANE',
  'ATTACK TO TARGET',
  'ATTACK ENGAGEMENT',
  'ATTACK DEFENSE',
  'TACTICAL RETREAT',

  'DEFENSE AREA MOVEMENT',
  'DEFENSE AREA DEFENDING',
  'RETREAT POINT MOVEMENT', // 13
  'RETREAT POINT DEFENSE',

  'AIR WAITING',
  'AIR MISSION CONTROL',
  'AIR FLIGHT PREPARATION', // 17 HAVA_UCUS_HAZIRLIK
  'AIR READY FOR TAKEOFF', // HAVA_PIST_BASINDA
  'AIR TAKE OFF', // HAVA_KALKIS 19
  'AIR LANDING', // HAVA_INIS
  'AIR FLYING', // HAVA_SEYIR_HALINDE 21
  'AIR AT MISSION', // HAVA_GOREVDE
  'AIR RETURN TO FIELD', // HAVA MEYDANA DONUS 23
  'AIR ROCKET', // 24
  'AIR MISSILE ON TARGET', // HAVA_FUZE_HEDEFTE 25

  'FORMATIN PREPARATION', // NIZAM_HAZIRLIK, 26
  'FORMATION EXECUTION', // NIZAM_ICRA,
  'FORMATION FINISHING', // NIZAM_SONLANMA,
  'FORMATION WAITING', // NIZAM_BEKLEME,
  'SETTING FORMATION WAITING FOR ROUTE', // NIZAM_OLUSTURMA_ROTA_BEKLEME,
  'FORMATION MOVE PREPARATION', // NIZAM_INTIKAL_HAZIRLIK,
  'FORMATION MOVE EXECUTION', // NIZAM_INTIKAL_ICRA,
  'FORMATION MOVE FINISHING', // NIZAM_INTIKAL_SONLANMA, 33

  'SEA DRIFTING', // DENIZ_SURUKLENME,

  'READY TO MERGE', // BIRLESMEYE_HAZIR,

  'SUPPLY PREPARATION', // IKMAL_HAZIRLIK,
  'SUPPLY TRANSFERING', // IKMAL_AKTARMA,

  'LAY MINE PREPARATION', // MAYIN_DOSEME_HAZIRLIK,
  'LAY MINE', // MAYIN_DOSEME,
  'LAY MINE ENDING', // MAYIN_DOSEME_SONLANMA,

  'REMOVE MINE PREPARATION', // MAYIN_TEMIZLEME_HAZIRLIK,
  'REMOVE MINE', // MAYIN_TEMIZLEME,
  'REMOVE MINE ENDING', // MAYIN_TEMIZLEME_SONLANMA,
  'COVERING MOVE', // ORTME_HAREKATI,
  'DELAYING MOVE', // OYALAMA_HAREKATI,

  'SUPPLY MOVE', // IKMAL_INTIKAL,
  'SUPPLY MOVE BACK', // IKMAL_GERI_INTIKAL,
  'AIR DEFENSE MISSILE SHOT', // HAVA_SAVUNMA_FUZESI_ATISI,
  'NEUTRALIZE ENEMY',
  'SEARCH FOR ENEMY',
  'ATTACK  ENGAGEMENT',
  'MOVEMENT TO ENEMY',

  'AIR DEFENSE MISSILE PREPARATION', // 'HAVA_SAVUNMA_FUZESI_ATIS_HAZIRLIK', // 53
  'AIR MISSILE REMOVE', // 'HAVA_FUZE_SIL',
  'TORPEDO PREPARATION', //   'TORPIDO_HAZIRLIK',
  'TORPEDO FIRE', //   'TORPIDO_ATISI',
  'TORPEDO ON TARGET', //   'TORPIDO_HEDEFTE',
  'TORPEDO REMOVE', //   'TORPIDO_SIL', 58
  'SURFACE TO AIR MISSILE', // KARADAN_HAVAYA_FUZE_ATISI 59
  'SURFACE TO SURFACE MISSILE', // KARADAN_KARAYA_FUZE_ATISI,
  'SUPPLY MERGE WITH DIVIDED AGENT', // IKMAL_BOLUNEN_ETMENLE_BIRLES,
  'SUPPLY REQUEST', // IKMAL_TALEP 62
  'MARITIME EMBARKMENT MOVE PREPARATION', // DENIZ_BINDIRME_INTIKAL_HAZIRLIK
  'MARITIME DISEMBARKMENT MOVE PREPARATION', // DENIZ_INDIRME_INTIKAL_HAZIRLIK
  'MARITIME LIFT MOVE PREPARATION', // DENIZ_TASIMA_INTIKAL_HAZIRLIK
  'MARITIME EMBARKMENT MOVE EXECUTION', // DENIZ_BINDIRME_INTIKAL_ICRA
  'MARITIME DISEMBARKMENT MOVE EXECUTION', // DENIZ_INDIRME_INTIKAL_ICRA
  'MARITIME LIFT MOVE EXECUTION', // DENIZ_TASIMA_INTIKAL_ICRA
  'MARITIME EMBARKMENT WAITING', // DENIZ_BINDIRME_BEKLEME
  'MARITIME DISEMBARKMENT WAITING', // DENIZ_INDIRME_BEKLEME
  'MARITIME EMBARKMENT', // DENIZ_BINDIRME
  'MARITIME DISEMBARKMENT', // DENIZ_INDIRME
  'MARITIME MOVE ENDING', // DENIZ_TASIMA_INTIKAL_SONLANMA

  'ESTABLISH COMMUNICATION', // MUHABERE KUR
  'REMOVE COMMUNICATION', // MUHABERE KOPAR

  'MARITIME SINKING', // < 76 DENIZ_BATMA
  'MARITIME SINKING MOVE', // < 77 DENIZ_BATMA_INTIKAL
  'MARITIME SINKING MOVE TO DEEPNESS', // < 78 DENIZ_BATMA_DIBE_INTIKAL
  'SHIPWRECK DRIFTING', // < 79 KAZAZEDE_SURUKLENME
  'CBRN FIRE', // < 80 KAZAZEDE_SURUKLENME
  'LAY OBSTACLE PREPARATION', // < 81 ENGEL_DOSEME_HAZIRLIK
  'LAY OBSTACLE MOVE', // < 82 ENGEL_DOSEME_INTIKAL
  'LAY OBSTACLE', // < 83 ENGEL_DOSEME
  'REMOVE OBSTACLE PREPARATION', // < 84 ENGEL_TEMIZLEME_HAZIRLIK
  'REMOVE OBSTACLE MOVE', // < 85 ENGEL_TEMIZLEME_INTIKAL
  'REMOVE OBSTACLE', // < 86 ENGEL_TEMIZLEME
  'DISBAND FORMATION', // < 87 NIZAMDAN_AYRILMA
  'DELETE FORMATION', // < 88 NIZAM_SILME
  'MOVE TO AIR INTERCEPTION', // < 89 HAVA_ONLEMEYE_GIDILIYOR
  'AIR INTERCEPTION EXECUTION', // < 90 HAVA_ONLENIYOR
  'MOVE TO AIR ESCORT', // < 91 HAVA_HIMAYE_GIDILIYOR
  'AIR ESCORT EXECUTION', // < 92 HAVA_HIMAYE_EDILIYOR
  'MOVE TO AIR SCRAMBLE', // < 93 HAVA_SCRAMBLE_GIDILIYOR
  'AIR SCRAMBLE EXECUTION', // < 94 HAVA_SCRAMBLE_EDILIYOR
  'CREATING MARITIME AGENT', // < 95 DENIZ_ETMENI_OLUSTURULUYOR
  'LOADING SUPPLY', // < 96 IKMAL_YUKLENIYOR
  'MARITIME PATROL MOVE PREPARATION', //! < 97 KARAKOL_GOREVI_INTIKAL_HAZIRLIK
  'MARITIME PATROL MOVE', //! < 98 KARAKOL_GOREVI_INTIKAL
  'MARITIME PATROL EXECUTION', //! < 99	KARAKOL_GOREVI_ICRA
  'MARITIME PATROL ENDING', //! < 100 KARAKOL_GOREVI_SONLANMA
  'MARITIME PATROL RETURN MOVE PREPARATION', //! < 101 KARAKOL_GOREVI_DONUS_INTIKAL_HAZIRLIK
  'MARITIME PATROL RETURN MOVE', //! < 102 KARAKOL_GOREVI_DONUS_INTIKAL
  'MARITIME PATROL RETURN MOVE ENDING', //! < 103 KARAKOL_GOREVI_DONUS_INTIKAL_SONLANMA
  'MARITIME PATROL EXECUTION ENDING', //! < 104 KARAKOL_GOREVI_ICRA_SONLANMA
  'MARITIME PATROL MOVE ENDING', //! < 105 KARAKOL_GOREVI_INTIKAL_SONLANMA
  'AIR WAITING FUEL SUPPLY', // < 106 HAVADAN_YAKIT_IKMAL_BEKLEME
  'MARITIME PATROL EXECUTION PREPARATION', //! < 107 KARAKOL_GOREVI_ICRA_HAZIRLIK
  'DEPTH CHARGE SHOT', //! < 108 SU_ALTI_BOMBASI_ATISI
  'DEPTH CHARGE DELETION', //! < 109 SU_ALTI_BOMBASI_SIL
  'DEPTH CHARGE AT TARGET', //! < 110 SU_ALTI_BOMBA_HEDEFTE
  'MARITIME BOARDING MOVE TO TARGET PREPARATION', //! < 111 CIKMA_ARAMA_HEDEFINE_INTIKAL_HAZIRLIK
  'MARITIME BOARDING MOVE TO TARGET EXECUTION', //! < 112 CIKMA_ARAMA_HEDEFINE_INTIKAL_ICRA
  'MARITIME BOARDING MOVE TO TARGET ENDING', //! < 113 CIKMA_ARAMA_HEDEFINE_INTIKAL_SONLANMA
  'AIR EMERGENCY LANDING', //! < 114 HAVA_ACIL_INIS
  'MARITIME BOARDING EXECUTION', //! < 115 CIKMA_ARAMA_ICRA
  'MARITIME BOARDING', //! < 116 CIKMA_ARAMA
  'DOCK MOVE TO TARGET AGENT PREPARATION', //! < 117 DOCK_BINILECEK_ETMENE_INTIKAL_HAZIRLIK
  'DOCK MOVE TO TARGET AGENT EXECUTION', //! < 118 DOCK_BINILECEK_ETMENE_INTIKAL_ICRA
  'DOCK MOVE TO TARGET AGENT ENDING', //! < 119 DOCK_BINILECEK_ETMENE_INTIKAL_SONLANMA
  'MARITIME SUPPLY MOVE TO SUPPLIER AGENT PREPARATION', //! < 120 DENIZDE_IKMAL_ALINACAK_ETMENE_INTIKAL_HAZIRLIK
  'MARITIME SUPPLY MOVE TO SUPPLIER AGENT EXECUTION', //! < 121 DENIZDE_IKMAL_ALINACAK_ETMENE_INTIKAL_ICRA
  'MARITIME SUPPLY MOVE TO SUPPLIER AGENT ENDING', //! < 122 DENIZDE_IKMAL_ALINACAK_ETMENE_INTIKAL_SONLANMA
  'MARITIME SUPPLY MOVE TO AGENT TO BE SUPPLIED PREPARATION', //! < 123 DENIZDE_IKMAL_VERILECEK_ETMENE_INTIKAL_HAZIRLIK
  'MARITIME SUPPLY MOVE TO AGENT TO BE SUPPLIED EXECUTION', //! < 124 DENIZDE_IKMAL_VERILECEK_ETMENE_INTIKAL_ICRA
  'MARITIME SUPPLY MOVE TO AGENT TO BE SUPPLIED ENDING', //! < 125 DENIZDE_IKMAL_VERILECEK_ETMENE_INTIKAL_SONLANMA
  'SUPPLY WAITING', //! < 126 IKMAL_BEKLEME
  'MARITIME SUPPLY RETURN MOVE PREPARATION', //! < 127 DENIZDE_IKMAL_GERI_DONUS_INTIKAL_HAZIRLIK
  'MARITIME SUPPLY RETURN MOVE EXECUTON', //! < 128 DENIZDE_IKMAL_GERI_DONUS_INTIKAL_ICRA
  'MARITIME SUPPLY RETURN MOVE ENDING', //! < 129 DENIZDE_IKMAL_GERI_DONUS_INTIKAL_SONLANMA
  'AIR GROUND ATTACK MOVE', //! < 130 HAVA_KARA_TAARRUZA_GIDILIYOR
  'AIR PATROL EXECUTION', //! < 131 HAVA_DEVRIYE_ICRA
  'AIR PATROL MOVE', //! < 132 HAVA_DEVRIYE_INTIKAL
  'LAY SEA MINES MOVE TO TARGET PREPARATION', //! < 133 MAYIN_DOSEME_NOKTASINA_INTIKAL_HAZIRLIK
  'LAY SEA MINES MOVE TO TARGET EXECUTION', //! < 134 MAYIN_DOSEME_NOKTASINA_INTIKAL_ICRA
  'LAY SEA MINES MOVE TO TARGET ENDING', //! < 135 MAYIN_DOSEME_NOKTASINA_INTIKAL_SONLANMA
  'LAY SEA MINES RETURN MOVE PREPARATION', //! < 136 MAYIN_DOSEME_GERI_DONUS_INTIKAL_HAZIRLIK
  'LAY SEA MINES RETURN MOVE EXECUTION', //! < 137 MAYIN_DOSEME_GERI_DONUS_INTIKAL_ICRA
  'LAY SEA MINES RETURN MOVE ENDING', //! < 138 MAYIN_DOSEME_GERI_DONUS_INTIKAL_SONLANMA
  'SWEEP SEA MINES MOVE TO TARGET PREPARATION', //! < 139 MAYIN_TEMIZLEME_NOKTASINA_INTIKAL_HAZIRLIK
  'SWEEP SEA MINES MOVE TO TARGET EXECUTION', //! < 140 MAYIN_TEMIZLEME_NOKTASINA_INTIKAL_ICRA
  'SWEEP SEA MINES MOVE TO TARGET ENDING', //! < 141 MAYIN_TEMIZLEME_NOKTASINA_INTIKAL_SONLANMA
  'SEA MINE DRAFTING', //! < 142 DENIZ_MAYINI_SURUKLENME
  'SWEEP SEA MINES ENDING', //! < 143 MAYIN_TEMIZLEME_BOLGE_SONLANMA
  'SWEEP SEA MINES MOVE TO MINE LOCATION PREPARATION', //! < 144 MAYIN_TEMIZLEME_MAYIN_NOKTASINA_INTIKAL_HAZIRLIK
  'SWEEP SEA MINES MOVE TO MINE LOCATION EXECUTION', //! < 145 MAYIN_TEMIZLEME_MAYIN_NOKTASINA_INTIKAL_ICRA
  'SWEEP SEA MINES MOVE TO MINE LOCATION ENDING', //! < 146 MAYIN_TEMIZLEME_MAYIN_NOKTASINA_INTIKAL_SONLANMA
  'MINE DETECTION MOVE PREPARATION', //! < 147 MAYIN_TEMIZLEME_MAYIN_NOKTASINA_INTIKAL_SONLANMA
  'MINE DETECTION MOVE EXECUTION', //! < 148 MAYIN_TEMIZLEME_MAYIN_NOKTASINA_INTIKAL_SONLANMA
  'MINE DETECTION MOVE ENDING', //! < 149 MAYIN_TEMIZLEME_MAYIN_NOKTASINA_INTIKAL_SONLANMA
  'AIR LIFT LANDING', //! < 150 HAVA_TASIMA_INIS
  'AIR LIFT TAKE-OFF', //! < 151 HAVA_TASIMA_KALKIS
  'AIR LIFT EXECUTION', //! < 152 HAVA_TASIMA_ICRA
  'AIR LIFT DISEMBARKING', //! < 153 HAVA_TASIMA_INDIRILIYOR
  'AIR LIFT EMBARKING', //! < 154 HAVA_TASIMA_BINDIRILIYOR
  'MARITIME TOW MOVE TO TARGET AGENT PREPARATION', //! < 155 DENOZ_CEKME_CEKILECEK_ETMENE_INTIKAL_HAZIRLIK
  'MARITIME TOW MOVE TO TARGET AGENT EXECUTION', //! < 156 DENIZ_CEKME_CEKILECEK_ETMENE_INTIKAL_ICRA
  'MARITIME TOW MOVE TO TARGET AGENT ENDING', //! < 157 DENIZ_CEKME_CEKILECEK_ETMENE_INTIKAL_SONLANMA
  'MARITIME TOW MOVE PREPARATION', //! < 158 DENIZ_CEKME_INTIKAL_HAZIRLIK
  'MARITIME TOW MOVE EXECUTION', //! < 159 DENIZ_CEKME_INTIKAL_ICRA
  'MARITIME TOW MOVE ENDING', //! < 160 DENIZ_CEKME_INTIKAL_SONLANMA
  'MARITIME TOW RETURN MOVE PREPARTION', //! < 161 DENIZ_CEKME_SONRASI_INTIKAL_HAZIRLIK
  'MARITIME TOW RETURN MOVE EXECUTION', //! < 162 DENIZ_CEKME_SONRASI_INTIKAL_ICRA
  'MARITIME TOW RETURN MOVE ENDING', //! < 163 DENIZ_CEKME_SONRASI_INTIKAL_SONLANMA
  'BUILD INFRASTRUCTURE PREPARATION' = 164, // ALTYAPI_INSA_HAZIRLIK
  'BUILD INFRASTRUCTURE MOVE' = 165, // ALTYAPI_INSA_INTIKAL
  'BUILD INFRASTRUCTURE' = 166, // ALTYAPI_INSA

  'BUILD INFRASTRUCTURE ENDING' = 168, // ALTYAPI_INSA_BITIR
  'SUPPLYING' = 169, // IKMAL_VERILIYOR
  'FUEL LEAKING' = 170, // YAKIT_SIZDIRILIYOR
  'SURRENDER' = 171, // TESLIM_OL
  'CAPTURE POW' = 172, // ESIR_AL
  'MOVE TO POW TO BE CAPTURED' = 173, // ESIR_ALINACAK_ETMENE_INTIKAL
  'HANDOVER POW' = 174, // ESIR_DEVRET
  'MOVE TO AGENT TO BE RELEASED POW' = 175, // ESIR_DEVREDILECEK_ETMENE_INTIKAL
  'RELEASE POW' = 176, // SERBEST_BIRAK
  'NAVIGATION MISSILE SHOT' = 177, // SEYIR_FUZESI_ATISI
  'BOARDING HIJACK' = 178, // CIKMA_ELE_GECIRME
  'BOARDING RESCUE' = 179, // CIKMA_KURTARMA
  'BOARDING HIJACK EXECUTION' = 180, // CIKMA_ELE_GECIRME_ICRA
  'BOARDING RESCUE EXECUTION' = 181, // CIKMA_KURTARMA_ICRA
  'AIR RECONNAISSANCE MOVE' = 182, // HAVA_KESIF_INTIKAL
  'AIR RECONNAISSANCE EXECUTION' = 183, // 	HAVA_KESIF_ICRA

  'AIR SEAD MOVE' = 184, // HAVA_SEAD_INTIKAL
  'AIR SEAD EXECUTION' = 185, // HAVA_SEAD_ICRA
  'AIR AWACS MOVE' = 186, // HAVA_ERKEN_UYARI_INTIKAL
  'AIR AWACS EXECUTION' = 187, // HAVA_ERKEN_UYARI_ICRA
  'AIR S&R MOVE' = 188, // HAVA_ARAMA_KURTARMA_INTIKAL
  'AIR S&R EXECUTION' = 189, // HAVA_ARAMA_KURTARMA_ICRA
  'AIR S&R MOVE TO VICTIM' = 190, // HAVA_ARAMA_KURTARMA_KAZAZEDEYE_INTIKAL
  'AIR S&R VICTIM EMBARKING' = 191, // HAVA_ARAMA_KURTARMA_KAZAZEDEDE_BINDIRILIYOR
  'AIR S&R LANDING' = 192, // HAVA_ARAMA_KURTARMA_INIS
  'AIR S&R TAKE-OFF' = 193, // HAVA_ARAMA_KURTARMA_KALKIS
  'BOARDING CAPTURE EXECUTION' = 194, // CIKMA_ESIR_ALMA_ICRA
  'BOARDING CAPTURE' = 195, // CIKMA_ESIR_ALMA
  'AIR ESCORT WITH SEAD' = 196,
  'MERGE INTO AIR AGENT' = 197,
  'JAMMING EXECUTION' = 198,
  'SUPPLY LOADED' = 199,
  'AIR MOVE TO CLOSE AIR SUPPORT' = 200, // YAKIN_HAVA_DESTEGINE_GIDILIYOR
  'AIR MOVE TO CLOSE COMBAT' = 201, // YAKIN_MUHAREBE_TAARRUZUNA_GIDILIYOR
  'AIR MOVE TO TACTICAL AIR SUPPORT TO MARITIME OPERATION' = 202, // DENIZ_GOREVINE_TAKTIK_HAVA_DESTEGINE_GIDILIYOR
  'MOVE TO AMBUSH POSITION' = 203, // PUSU_KONUMUNA_INTIKAL
  'AT AMBUSH POSITION' = 204, // PUSU_KONUMUNDA
  'MOVE TO AMBUSH TARGET' = 205, // PUSU_HEDEFINE_INTIKAL
  'ENGAGED TO AMBUSH TARGET' = 206, // PUSU_HEDEFIYLE_ANGAJMAN
  'ATTACK TO AMBUSH TARGET' = 207, // PUSU_HEDEFINE_TAARRUZ
  'MOVE BACK TO AMBUSH POSITION' = 208, // PUSU_KONUMUNA_GERI_INTIKAL
  'MOVE TO BUILDING LOCATION' = 209, // BINA_KONUMUNA_INTIKAL
  'CLEARING BUILDING' = 210, // BINA_TEMIZLENIYOR
  'DETERMINE NEXT TARGET TO CLEAR' = 211, // TEMIZLIK_HEDEFI_BELIRLE
  'CBRN DECONTAMINATION STARTED' = 212, // KBRN_TEMIZLIGI_BASLADI
  'CBRN DECONTAMINATION FINISHED' = 213, // KBRN_TEMIZLIGI_BITTI
  'SEARCHING RUNWAY FOR LANDING' = 214, // HAVA_INIS_ICIN_PIST_ARANIYOR
  'MOVE TO SEARCH AND RESCUE AREA' = 215, // ARAMA_KURTARMA_ALANINA_INTIKAL
  'AT SEARCH AND RESCUE LOCATION' = 216, // ARAMA_KURTARMA_ALANINDA
  'SEARCH AND RESCUE CLARIFY BUILDING' = 217, // ARAMA_KURTARMA_BINA_BELIRLE
  'MOVE TO SEARCH AND RESCUE BUILDING' = 218, // ARAMA_KURTARMA_BINASINA_INTIKAL
  'SEARCH AND RESCUE PEOPLE' = 219, // ARAMA_KURTARMA_INSANLARI_KURTAR
  'MAINTAINANCE PREPERATION' = 226, // BAKIM_HAZIRLIK
  'MAINTAINANCE MOVE' = 227, // BAKIM_INTIKAL,
  'TRANSPORTATION FROM MAINTENANCE REQUESTING AGENT TO CONVOY' = 228, // BAKIM_ALAN_ETMENDEN_KONVOYA_AKTARIM
  'MAINTAINANCE WITHDRAW' = 229, // BAKIM_GERI_INTIKAL,
  'TRANSPORTATION FROM MAINTENANCE REQUESTING AGENT TO MAINTAINER AGENT' = 230, // BAKIM_ALAN_ETMENDEN_BAKIM_VEREN_ETMENE_AKTARIM
  'TRANSPORTATION FROM CONVOY TO MAINTAINER AGENT' = 231, // KONVOYDAN_BAKIM_VEREN_ETMENE_AKTARIM,
  'TRANSPORTATION FROM MAINTAINER AGENT TO CONVOY' = 232, // BAKIM_VEREN_ETMENDEN_KONVOYA_AKTARIM
  'TRANSPORTATION FROM CONVOY TO MAINTENANCE REQUESTING AGENT' = 233, // KONVOYDAN_BAKIM_ALAN_ETMENE_AKTARIM,
  'MAINTENANCE MERGE WITH DIVIDED AGENT' = 234, // BAKIM_VEREN_ETMENLE_BIRLES
  'LAND EMBARKATION MOVE' = 235, // KARA_BINDIRME_INTIKAL
  'LAND EMBARKATION' = 236, // KARA_BINDIRME
  'LAND DISEMBARKATION' = 237, // KARA_INDIRME
  'MAINTENANCE CONVOY DISPATCH' = 238, // BAKIM_KONVOY_CIKART
  'MAINTENANCE PROCESS START' = 239, // BAKIM_SURECI_BASLAT
  'MAINTENANCE DAMAGED TO BE GIVEN RESERVED CLEAR' = 240, // BAKIM_HASARLI_VER_REZERVINI_TEMIZLE
  'MAINTENANCE DAMAGED MANIFEST RESERVED CLEAR' = 241, // BAKIM_HASARLI_TASINIYOR_REZERVINI_TEMIZLE
  'PATROL COMMAND MOVE TO TARGET AGENT' = 242,
  'PATROL COMMAND ENGAGEMENT WITH TARGET AGENT' = 243,
  'AIR MPA EXECUTION' = 244,
  'AIR MPA MOVE' = 245,
  'AIR MPA ENGAGEMENT' = 246,
  'DROP SONOBUOY' = 247,
}

export enum EEngamentRule {
  // 'EMPTY' = 0,
  'WEAPONS FREE' = 1,
  'WEAPONS HOLD' = 2,
  'WEAPONS TIGHT' = 3,
}

export enum EIntikalDurumuTipi {
  'FINISHED WITH FAIL' = 1,
  'REACHED CONTROL POINT',
  'FINISHED SUCCESSFULLY',
  'STARTED', // basladi
}

export enum ERaporKodu {
  // Olumlu güncellemeler
  // Sona ekleme yapabilirsiniz
  'SUCCESS' = 0, // GENEL BASARILI

  'LAND MOVE STARTED', // KARA_INTIKAL_BASLADI
  'LAND MOVE FINISHED', // KARA_INTIKAL_SONLANDI
  'LAND MOVE REACHED CHECKPOINT', // KARA_INTIKAL_KONTROL_NOKTASINA_ULASILDI
  'MARITIME MOVE STARTED', // DENIZ_INTIKAL_BASLADI
  'MARITIME MOVE FINISHED', // DENIZ_INTIKAL_SONLANDI
  'MARITIME MOVE REACHED CHECKPOINT', // DENIZ_INTIKAL_KONTROL_NOKTASINA_ULASILDI

  'MOVE TO LINE OF DEPARTURE STARTED', // TAARUZ_CIKIS_HATTINA_INTIKAL_BASLADI
  'REACHED TO LINE OF DEPATURE', // TAARUZ_CIKIS_HATTINA_ULASILDI
  'ATTACK TO TARGET AGENT STARTED', // TAARRUZ_HEDEFE_TAARRUZ_BASLADI
  'REACHED TO ATTACK DESTINATION', // TAARUZ_HEDEFE_ULASILDI
  'DEFENSE STARTED ON ATTACK LOCATION', // TAARRUZ_BOLGESINDE_SAVUNMA_BASLADI
  'DEFENSE FINISHED ON ATTACK LOCATION', // TAARRUZ_BOLGESINDE_SAVUNMA_SONLANDI
  'ATTACK ENGAGEMENT STARTED', // TAARRUZ_ANGAJMAN_BASLADI

  'COMMAND ACCEPTED', // EMIR KABUL
  'AGENT DELETED', // ETMEN SILINDI

  'MERGE AGENTS SUCCESSFUL', // ETMEN_BIRLESTIR_BASARILI
  'DELETE AGENT SUCCESSFUL', // ETMEN_SIL_BASARILI
  'COMMAND REMOVED BY THE USER', // EMIR_KULLANICI_TARAFINDAN_IPTAL_EDILDI

  'ENGAGEMENT RULE CHANGED', // ANGAJMAN_KURALI_DEGISTI

  'SUPPLY PREPARATION STARTED', // IKMAL_HAZIRLIGI_BASLADI
  'SUPPLY PREPARATION FINISHED', // IKMAL_HAZIRLIGI_SONLANDI,
  'SUPPLY MOVE STARTED', // IKMAL_INTIKALI_BASLADI,
  'SUPPLY MOVE FINISHED', // IKMAL_INTIKALI_SONLANDI,
  'SUPPLY TRANSFER STARTED', // IKMAL_AKTARMA_BASLADI,
  'SUPPLY TRANSFER FINISHED', // IKMAL_AKTARMA_SONLANDI,
  'SUPPLY MOVE BACK STARTED', // IKMAL_GERI_INTIKAL_BASLADI,
  'SUPPLY MERGE COMPLETED', // IKMAL_ETMEN_BIRLESME_TAMAMLANDI,

  'DEFENSE STARTED ON WITHDRAW LOCATION', // GERI_CEKILME_BOLGESINDE_SAVUNMA_BASLADI,
  'DEFENSE FINISHED ON WITHDRAW LOCATION', // GERI_CEKILME_BOLGESINDE_SAVUNMA_SONLANDI,
  'COVERING MOVEMENT STARTED', // ORTME_HAREKATI_BASLADI,
  'COVERING MOVEMENT FINISHED', // ORTME_HAREKATI_SONLANDI,
  'DELAYING MOVEMENT STARTED', // OYALAMA_HAREKATI_BASLADI,
  'DELAYING MOVEMENT FINISHED', // OYALAMA_HAREKATI_SONLANDI,

  'DIRECT FIRE STARTED', // GOREREK_ATIS_BASLADI,
  'DIRECT FIRE FINISHED', // GOREREK_ATIS_SONLANDI,
  'INDIRECT FIRE STARTED', // GORMEDEN_ATIS_BASLADI,
  'INDIRECT FIRE FINISHED', // GORMEDEN_ATIS_SONLANDI,

  'MOVE STARTED TO WITHDRAW LOCATION', // GERI_CEKILME_BOLGESINE_INTIKAL_BASLADI,
  'REACHED TO WITHDRAW LOCATION', // GERI_CEKILME_BOLGESINE_ULASILDI,

  'MOVE STARTED TO DEFENSE LOCATION', // SAVUNMA_BOLGESINE_INTIKAL_BASLADI,
  'REACHED TO DEFENSE LOCATION', // SAVUNMA_BOLGESINE_ULASILDI,
  'DEFENSE STARTED ON DEFENSE LOCATION', // SAVUNMA_BOLGESINDE_SAVUNMA_BASLADI,
  'DEFENSE FINISHED ON DEFENSE LOCATION', // SAVUNMA_BOLGESINDE_SAVUNMA_SONLANDI,
  'TRANSPORTATION STARTED', // TASIMA_BASLADI,

  'MINE REMOVAL SUCCESSFUL', // MAYIN_TEMIZLEME_BASARILI

  'TORPEDO FIRE STARTED', // 	TORPEDO_ATIS_BASLADI,
  'TORPEDO FIRE FINISHED', // 	TORPEDO_ATIS_SONLANDI,

  'AIR DEFENSE MISSILE SHOOTING FINISHED', // HAVA_SAVUNMA_FUZE_ATISI_SONLANDI
  'DATABASE LOADED', // 'VT_YUKLENDİ',
  'SURFACE TO SURFACE MISSILE SHOT', // KARA_KARA_FUZESI_ATESLENDI
  'SURFACE TO AIR MISSILE SHOT', // KARA_HAVA_FUZESI_ATESLENDI 51
  'COMMAND FINISHED DUE TO TARGET AGENT IS DESTROYED', // HEDEF_ETMEN_YOK_OLDUGU_ICIN_EMIR_SONLANDIRILDI 52

  'DIRECT FIRE COMPLETED SUCCESSFULLY', // GOREREK_ATIS_BASARILI_TAMAMLANDI 53
  'INDIRECT FIRE COMPLETED SUCCESSFULLY', // GORMEYEREK_ATIS_BASARILI_TAMAMLANDI 54
  'NAVAL GROUND SUPPORT COMPLETED SUCCESSFULLY', // DENIZ_TOPCU_ATISI_BASARILI_TAMAMLANDI 55
  'CREATING FORMATION', // NIZAM_OLUSTURULUYOR 56
  'NAVAL SUPPLY STARTED', // DENIZ_IKMAL_BASLADI 57
  'NAVAL LAYING MINE STARTED', // DENIZ_MAYIN_DOSE_BASLADI 58
  'NAVAL REMOVING MINE STARTED', // DENIZ_MAYIN_TEMIZLE_BASLADI 59
  'NAVAL FORMATION MOVE STARTED', // DENIZ_NIZAM_INTIKAL_BASLADI 60
  'MARITIME LIFT MOVE STARTED', // DENIZ_TASIMA_INTIKAL_BASLADI, // 61
  'MARITIME EMBARKMENT STARTED', // DENIZ_BINDIRME_INTIKAL_BASLADI,	// 62
  'MARITIME DISEMBARKMENT STARTED', // DENIZ_INDIRME_INTIKAL_BASLADI,	// 63

  'SUPPLY MOVE BACK FINISHED', // IKMAL_GERI_INTIKAL_SONLANDI,							// 64
  'ADDED TO MANIFEST', // MANIFESTOYA_EKLENDI,									// 65
  'MARITIME EMBARKMENT SUCCESSFUL', // DENIZ_BINDIRME_BASARILI,								// 66
  'MARITIME LIFT SUCCESSFUL', // DENIZ_TASIMA_BASARILI,									// 67

  'COMMUNICATION ESTABLISHED', // MUHABERE_KURULDU // 68
  'COMMUNICATION REMOVED', // MUHABERE_KOPARILDI // 69

  'CBRN FIRE STARTED', // KBRN_ATISI_BASLADI // 70
  'CBRN FIRE FINISHED', // KBRN_ATISI_TAMAMLANDI // 71

  'NAVALCRAFT HAS SANK', // DENİZ ARACI BATTI // 72
  'FORMATION ESTABLISHED', // NIZAM OLUŞTURULDU // 73

  'INTERCEPT COMPLETED', // INTERCEPT GERÇEKLEŞTİRİLDİ // 74

  'MOVE STARTED TO LAY OBSTACLES AREA', // ENGEL_DOSEME_BOLGESINE_INTIKAL_BASLADI, // 75
  'REACHED TO LAY OBSTACLES AREA', // ENGEL_DOSEME_BOLGESINE_VARILDI, // 76
  'LAY OBSTACLES COMPLETED', // ENGEL_DOSEME_TAMAMLANDI, // 77
  'MOVE STARTED TO REMOVE OBSTACLES AREA', // ENGEL_TEMIZLENECEK_BOLGEYE_INTIKAL_BASLADI, // 78
  'REMOVE OBSTACLES STARTED', // ENGEL_TEMIZLIGI_BASLADI, // 79
  'REMOVE OBSTACLES COMPLETED', // ENGEL_TEMIZLIGI_TAMAMLANDI, // 80
  'LAY OBSTACLES STARTED', // ENGEL_DOSEME_BASLADI 81
  'TELEPORT STARTED', // ISINLAN_BASLADI 82
  'TELEPORT COMPLETED', // ISINLAN_TAMAMLANDI 83
  'AGENT LEFT FORMATION', // ETMEN_NIZAMDAN_AYRILDI = 84,
  'FORMATION DISBANDED BY COMMAND', // NIZAM_EMIRLE_BOZULDU = 85,
  'MARITIME AGENT CREATED', // DENIZ_ETMENI_OLUSTURULDU = 86,
  'PATROL COMMAND MOVE STARTED', // KARAKOL_GOREVINE_INTIKAL_BASLADI = 87,
  'PATROL COMMAND COMPLETED', // KARAKOL_GOREVI_TAMAMLANDI = 88,
  'PATROL COMMAND RETURN MOVE STARTED', // KARAKOL_GOREVI_DONUS_INTIKAL_BASLADI = 89,
  'PATROL COMMAND EXECUTION STARTED', // KARAKOL_GOREVI_ICRASI_BASLADI = 90,
  'PATROL COMMAND TIME EXPIRED', // KARAKOL_GOREVI_ICIN_BELIRLENEN_SURE_DOLDU = 91,
  'DEPTH CHARGE SHOT FINISHED', // SU_ALTI_BOMBASI_ATIS_SONLANDI = 92,
  'DEPTH CHARGE SHOT STARTED', // SU_ALTI_BOMBASI_ATISI_BASLADI = 93,
  'MARITIME BOARDING CANCELED', // DENIZ_CIKMA_ARAMA_IPTAL_EDILDI = 94,
  'MARITIME BOARDING MOVE TO TARGET STARTED', // CIKMA_ARAMA_HEDEF_INTIKAL_BASLADI = 95,
  'MARITIME BOARDING FINISHED', // CIKMA_ARAMA_SONLANDI = 96,
  'MARITIME BOARDING FOUND HIDDEN MANIFEST AGENT', // GIZLI_YUK_ETMEN_BULUNDU = 97,
  'MARITIME BOARDING BOARDING TO AGENT SUCCESSFUL', // CIKMA_ARAMA_YAPILACAK_ETMENE_CIKIS_BASARILI = 98,
  'MARITIME UNDOCK COMPLETED SUCCESSFULLY', // DENIZ_UNDOCK_BASARI_ILE_TAMAMLANDI = 99,
  'MARITIME DOCK COMPLETED SUCCESSFULLY', // DENIZ_DOCK_BASARI_ILE_TAMAMLANDI = 100,
  'MARITIME DOCK MOVE TO AGENT STARTED', // DENIZ_DOCK_ETMENE_INTIKAL_BASLADI = 101,
  'MARITIME SUPPLY MOVE TO AGENT STARTED', // DENIZDE_IKMAL_ETMENE_INTIKAL_BASLADI = 102,
  'MARITIME SUPPLY COMPLETED SUCCESSFULLY', // DENIZDE_IKMAL_BASARI_ILE_TAMAMLANDI = 103,
  'MARITIME SUPPLY RETURN MOVE STARTED', // DENIZDE_IKMAL_GERI_DONUS_INTIKAL_BASLADI = 104,
  'MARITIME SUPPLY DELIVERED SUCCESSFULLY', // DENIZDE_IKMAL_BASARI_ILE_TESLIM_EDILDI = 105,
  'MARITIME LAY SEA MINE COMPLETED SUCCESSFULLY', // DENIZ_MAYIN_DOSEME_BASARI_ILE_TAMAMLANDI = 106,
  'MARITIME SEA MINE LAID', // DENIZ_MAYINI_DOSENDI = 107,
  'COMMAND QUEUE UPDATED', // EMIR_KUYRUGU_GUNCELLENDI = 108,
  'MARITIME SWEEP SEA MINE COMPLETED SUCCESSFULLY', // DENIZ_MAYIN_TEMIZLEME_TAMAMLANDI = 109,
  'MARITIME MINE DETECTION STARTED', // MAYIN_TARAMA_BASLADI = 110,
  'MARITIME MINE DETECTION MINE DETECTED', // MAYIN_TARAMA_MAYIN_BULUNDU = 111,
  'MARITIME TOW MOVE TO AGENT TO BE TOWED STARTED', // DENIZ_CEKME_CEKILECEK_ETMENE_INTIKAL_BASLADI = 112,
  'MARITIME TOW MOVE STARTED', // DENIZ_CEKME_INTIKAL_BASLADI = 113,
  'MARITIME TOW RETURN MOVE STARTED', // DENIZ_CEKME_SONRASI_INTIKAL_BASLADI = 114,
  'MARITIME TOW COMPLETED SUCCESSFULLY', // DENIZ_CEKME_BASARI_ILE_TAMAMLANDI = 115,
  'MARITIME TOW TOWED AGENT DROPPED OF TO REQUESTED LOCATION', // DENIZ_CEKME_CEKILEN_ETMEN_CEKME_KONUMUNA_BIRAKILDI = 116,
  'MOVE STARTED TO LAY MINES AREA', // MAYIN_DOSENECEK_ALANA_INTIKAL_BASLADI = 117,
  'LAY MINES RETURN MOVE STARTED', // MAYIN_DOSEME_GERI_DONUS_INTIKAL_BASLADI = 118,
  'MOVE STARTED TO CLEAR MINES AREA', // MAYIN_TEMIZLENECEK_ALANA_INTIKAL_BASLADI = 119,
  'MOVE STARTED TO MINE TO BE CLEARED', // MAYIN_TEMIZLE_TEMIZLENECEK_MAYINA_INTIKAL_BASLADI = 120,
  'BUILD INFRASTRUCTURE STARTED', // ALTYAPI_INSASI_BASLADI = 121,
  'BUILD INFRASTRUCTURE COMPLETED', // ALTYAPI_INSASI_TAMAMLANDI = 122,
  'SUPPLYING', // IKMAL_VERILIYOR = 123,
  'FUEL LEAKING COMPLETED', // YAKIT_SIZDIRMA_TAMAMLANDI = 124,
  'AGENT CAPTURED', // ETMEN_ESIR_ALINDI = 125,
  'AGENT SURRENDERED' = 126, // ETMEN_TESLIM_OLDU
  'BOARDING HIJACKING SUCCESSFUL' = 127, // CIKMA_ELE_GECIRME_BASARILI
  'BOARDING RESCUE SUCCESSFUL' = 128, // CIKMA_KURTARMA_BASARILI
  'AGENT PROTOTYPE CREATION SUCCESSFUL' = 129, // ETMEN_TURU_OLUSTURMA_BASARILI
  'AGENT CREATED' = 130, // YENI_ETMEN_OLUSTURULDU
  'AGENT TIME TO JOIN UPDATED' = 131, // ETMENIN_SIMULASYONA_KATILACAGI_ZAMAN_DEGISTIRILDI
  'SAVED CHECKPOINT' = 132, // SIMULASYON_CHECKPOINT_ALINDI
  'LOADED CHECKPOINT' = 133, // SIMULASYON_CHECKPOINT_YUKLENDI
  'AGENT MOVE SPEED CHANGE SUCCESSFUL' = 134, // ETMENIN_INTIKAL_HIZI_DEGISTIRILDI
  'BOARDING CAPTURING SUCCESSFUL' = 135, // CIKMA_ESIR_ALMA_BASARILI
  // ONLEME_BASARILI = 136,		// UI'a gönderme amacıyla yazılmadı.
  // ONLEME_BASARISIZ = 137,		// UI'a gönderme amacıyla yazılmadı.
  'MISSILE NEUTRALIZED BY COUNTER MEASURE' = 138, // FUZE_KARSI_TEDBIR_TARAFINDAN_ETKISIZ_HALE_GETIRILDI_OLUMLU
  'TORPEDO NEUTRALIZED BY COUNTER MEASURE' = 139, // TORPIDO_KARSI_TEDBIR_TARAFINDAN_ETKISIZ_HALE_GETIRILDI_OLUMLU
  'HANDOVER POW SUCCESSFUL' = 140, // ESIR_DEVREDILDI
  'RELEASE POW SUCCESSFUL' = 141, // ESIR_SERBEST_BIRAKILDI
  'AGENT RELEASED' = 142, // ETMEN_SERBEST_KALDI
  'CHECKPOINT AUTOSAVED' = 143, // SIMULASYON_OTOMATIK_CHECKPOINT_ALINDI
  'NEW TARGET IDENTIFIED' = 144, // YENI_HEDEF_BELIRLENDI
  'CRUISE MISSILE FIRE' = 145, // SEYIR_FUZESI_ATESLENDI
  'TAKEN UP POSITION AT AMBUSH LOCATION' = 146, // PUSU_KONUMUNDA_MEVZI_ALINDI
  'AMBUSH ENGAGEMENT STARTED TO TARGET' = 147, // PUSU_HEDEFIYLE_ANGAJMAN_BASLADI
  'AMBUSH ATTACK STARTED TO TARGET' = 148, // PUSU_HEDEFINE_TAARRUZ_BASLADI
  'AMBUSH TARGET NEUTRALIZED' = 149, // PUSU_HEDEFI_ETKISIZ_HALE_GETIRILDI
  'MOVE BACK TO AMBUSH LOCATION STARTED' = 150, // PUSU_KONUMUNA_GERI_INTIKAL_BASLADI
  'MOVE BACK TO AMBUSH LOCATION COMPLETED' = 151, // PUSU_KONUMUNA_GERI_INTIKAL_TAMAMLANDI
  // HIZMETLER_BINARY_OLARAK_KAYDEDILDI = 152,
  // SABITLER_BINARY_OLARAK_KAYDEDILDI = 153,
  // SHAGLOBAL_BINARY_OLARAK_KAYDEDILDI = 154,
  'AIR MISSION CREATED' = 155, // HAVA_GOREVI_OLUSTURULDU
  'AGENT VOLUME CHANGED' = 156, // ETMEN_HACIMI_DEGISTIRILDI
  'COMAO DELETED' = 157, // COMAO_SILINDI
  'COMAO UPDATED' = 158, // COMAO_GUNCELLENDI
  'COMAO CREATED' = 159, // COMAO_OLUSTURULDU
  'CLEAR BUILDING STARTED' = 160, // BINA_TEMIZLIGI_BASLADI
  'CLEAR BUILDING COMPLETED' = 161, // BINA_TEMIZLIGI_TAMAMLANDI
  'SIMULATION TERMINATED' = 162, // SIMULASYON_KAPANDI
  'OWNSITREP REPORT CREATED' = 163, // OWNSITREP_RAPORU_OLUSTURMA_BASARILI
  'ENSITREP REPORT CREATED' = 164, // ENSITREP_RAPORU_OLUSTURMA_BASARILI
  'CBRN DECONTAMINATION STARTED' = 165, // KBRN_TEMIZLIGI_BASLADI
  'CBRN DECONTAMINATION FINISHED' = 166, // KBRN_TEMIZLIGI_TAMAMLANDI
  'SITREP REPORT CREATED' = 167, // SITREP_RAPORU_OLUSTURMA_BASARILI
  'REMOVED FROM MANIFEST' = 168, // MANIFESTODAN_CIKARILDI
  'SUPPLYING AGENT HAS BEEN CHANGED' = 169, // SUPPLYING AGENT HAS BEEN CHANGED // IKMALDEN_SORUMLU_ETMEN_DEGISTIRILDI
  'HIGHER AGENT HAS BEEN CHANGED' = 170, // HIGHER AGENT HAS BEEN CH // ISLETEN_ETMEN_DEGISTIRILDI
  AAR_SAYISI_ISTEGI_BASARILI = 171, // AAR_SAYISI_ISTEGI_BASARILI
  AAR_LISTESI_ISTEGI_BASARILI = 172, // AAR_LISTESI_ISTEGI_BASARILI
  AAR_ISTEGI_BASARILI = 173, // AAR_ISTEGI_BASARILI
  AAR_ETIKETI_DEGISTIRME_BASARILI = 174, // AAR_ETIKETI_DEGISTIRME_BASARILI
  EMIR_SAYISI_ISTEGI_BASARILI = 175, // EMIR_SAYISI_ISTEGI_BASARILI
  EMIR_LISTESI_ISTEGI_BASARILI = 176, // EMIR_LISTESI_ISTEGI_BASARILI
  EMIR_CEVABI_GONDERILMEYECEK = 177, // EMIR_CEVABI_GONDERILMEYECEK
  GAME_HISTORY_ISTEGI_BASARILI = 178,
  'GAME COMMAND STATISTICS REQUEST SUCCESSFUL' = 179,
  'MAINTAINANCE BACK MOVE STARTED' = 180,
  'MAINTAINANCE BACK MOVE FINISHED' = 181,
  'MAINTAINANCE TRANSFER STARTED' = 182,
  'MAINTAINANCE TRANSFER FINISHED' = 183,
  'AGENT LEFT' = 184,
  'LAND DISEMBARKMENT FINISHED' = 185,
  'LAND EMBARKMENT FINISHED' = 186,

  'MAINTENANCE MOVE STARTED' = 200000, // BAKIM_INTIKAL_BASLADI
  'MAINTENANCE AGENT MERGE COMPLETED' = 200001, // BAKIM_ETMEN_BIRLESME_TAMAMLANDI
  'MAINTENANCE SUCCESSFUL' = 200002, // BAKIM_BASARILI
  'MOVE TO DECONTAMINATION AREA STARTED' = 201000, // TEMIZLEME_BOLGESINE_INTIKAL_BASLADI
  'MOVE TO DECONTAMINATION AREA FINISHED' = 201001, // TEMIZLEME_BOLGESINE_INTIKAL_SONLANDI
  'MOVE TO DECONTAMINATON TARGET STARTED' = 201002, // TEMIZLEME_HEDEFINE_INTIKAL_BASLADI
  'DECONTAMINATION ON THE CONTAMINATED TERRAIN AREA IS STARTED' = 201003, // ARAZIDEKI_KIRLILIK_TEMIZLENMEYE_BASLANDI
  'DECONTAMINATION ON THE CONTAMINATED AGENT IS STARTED' = 201004, // ETMENDEKI_KIRLILIK_TEMIZLENMEYE_BASLANDI
  'CONTAMINATION ON THE TERRAIN IS DECONTAMINATED' = 201005, // ARAZIDEKI_KIRLILIK_TEMIZLENDI
  'CONTAMINATION ON THE AGENT IS CONTAMINATED' = 201006, // ETMENDEKI_KIRLILIK_TEMIZLENDI
  'NEW CONTAMINATION TARGET IS BEING SET FOR DECONTAMINATION' = 201007, // TEMIZLIK_ICIN_YENI_KIRLILIK_HEDEFI_BELIRLENIYOR

  'AIRCRAFT IS CRASHED BY COMMAND' = 400000, // HAVA_ARACI_EMIRLE_DUSURULDU
  'AIR MISSION LANDING TYPE IS CHANGED' = 400001, // HAVA_GOREVI_INIS_YONTEMI_DEGISTIRILDI

  'MOVE TO SEARCH AND RESCUE AREA STARTED' = 600000, // ARAMA_KURTARMA_ALANINA_INTIKAL_BASLADI
  'MOVE TO SEARCH AND RESCUE AREA FINISHED' = 600001, // ARAMA_KURTARMA_ALANINA_INTIKAL_SONLANDI
  'MOVE TO SEARCH AND RESCUE BUILDING STARTED' = 600002, // ARAMA_KURTARMA_BINASINA_INTIKAL_BASLADI
  'MOVE TO SEARCH AND RESCUE BUILDING FINISHED' = 600003, // ARAMA_KURTARMA_BINASINA_INTIKAL_SONLANDI
  'EARTHQUAKE COMMAND STARTED' = 600004, // DEPREM_EMRI_BASLADI
  'EARTHQUAKE COMMAND FINISHED' = 600005, // DEPREM_EMRI_BITTI
  'FLOOD COMMAND STARTED' = 600006, // SEL_EMRI_BASLADI
  'FLOOD COMMAND FINISHED' = 600007, // SEL_EMRI_BITTI

  //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // Başarısızlıklar (emrin icrasının iptal edildiği durumlar)
  // Sona ekleme yapabilirsiniz

  'ENCOUNTERED AN OBSTACLE ON MOVE' = -2147483648, // INTIKAL_ENGEL

  'MOVE AGENT IS INEFFECTIVE', // INTIKAL_ETMEN_ETKISIZ_OLDU
  'MOVE INSUFFICIENT SUPPLY', // INTIKAL_IKMAL_YETERSIZ
  'MOVE INSUFFICIENT SYSTEM', // INTIKAL_TMK_YETESIZ
  'MOVE INCORRECT ROUTE', // INTIKAL_ROTA_HATALI
  'MOVE SLOPE NOT EXCEEDED', // INTIKAL EGIM ASILAMADI
  'MOVE ENEMY PRESENCE ON ROUTE', // INTIKAL ROTADA DUSMAN VARLIGI
  'MOVE ROUTE STEP COUNT', // INTIKAL ROTA ADIM SAYISI
  'MOVE COULD NOT FIND ROUTE', // INTIKAL ROTA BULUNMADI
  'MOVE CANNOT ACCOMPLISH TIME TO FINISH', // INTIKAL_ISTENEN_VARIS_ZAMANINA_YETISMIYOR,
  'MOVE AGENT IS ALREADY AT LOCATION', // INTIKAL_ETMEN_ZATEN_ISTIKAMETTE,
  'MOVE CARRYING CAPACITY EXCEEDED', // INTIKAL_TASIMA_KAPASITE_ASIMI,
  'COULD NOT FIND MOVE DATA', // INTIKAL_VERISI_BULUNAMADI,
  'AGENT CANNOT MOVE IN CURRENT CONDITIONS', //	INTIKAL_ETMEN_GECERLI_KOSULLARDA_HAREKET_EDEMIYOR,
  'MOVE TARGET LOCATION WAS NOT SPECIFIED', // INTIKAL_HEDEF_KONUMU_SECILMEDI
  'MOVE TARGET LOCATION IS OUT OF BOUNDS', // INTIKAL_HEDEF_KONUM_ARAZI_SINIRLARI_DISINDA
  'MOVE CANNOT BE EXECUTED AT DESIRED SPEED', // INTIKAL_ISTENEN_HIZDA_GERCEKLESTIRILEMIYOR

  'NO ROAD NETWORK RECORD ON DATABASE', // 	VERITABANINDA_KAYITLI_KARAYOLU_AGI_YOK,
  'NO SEAWAY NETWORK RECORD ON DATABASE', // 	VERITABANINDA_KAYITLI_DENIZYOLU_AGI_YOK,
  'NO AIRWAY NETWORK RECORD ON DATABASE', // 	VERITABANINDA_KAYITLI_HAVAYOLU_AGI_YOK,

  'LAND AGENT CANNOT USE TRAFFIC SEPERATION LINES', // KARA_ETMENI_DENIZYOLU_KULLANAMAZ
  'LAND AGENT CANNOT USE AIR CORRIDORS', // KARA_ETMENI_HAVAYOLU_KULLANAMAZ
  'MARITIME AGENT CANNOT USE ROADS', // DENIZ_ETMENI_KARAYOLU_KULLANAMAZ
  'MARITIME AGENT CANNOT USE AIR CORRIDORS', // DENIZ_ETMENI_HAVAYOLU_KULLANAMAZ
  'AIR AGENT CANNOT USE ROADS', // HAVA_ETMENI_KARAYOLU_KULLANAMAZ
  'AIR AGENT CANNOT USE TRAFFIC SEPERATION LINES', // HAVA_ETMENI_DENIZYOLU_KULLANAMAZ

  'TELEPORT TARGET LOCATION IS OUT OF BOUNDS', // ISINLAN__HEDEF_KONUM_ARAZI_SINIRLARI_DISINDA

  'COULD NOT REACH LINE OF DEPARTURE', // TAARRUZ_CIKIS_HATTINA_ULASILAMADI
  'LINE OF DEPARTURE IS OUT OF BOUNDS', // TAARRUZ_CIKIS_HATTI_KONUMU_ARAZININ_DISINDA
  'LINE OF DEPARTURE WAS NOT SPECIFIED', // TAARRUZ_CIKIS_HATTI_KONUMU_GIRILMEDI
  'COULD NOT REACH ATTACK TARGET', // TAARRUZ_HEDEFINE_ULASILAMADI
  'ATTACK AREA WAS NOT SPECIFIED', // TAARRUZ_EDILMEK_ISTENEN_BOLGE_SECILMEDI
  'ATTACK AREA IS OUT OF BOUNDS', // TAARRUZ_EDILMEK_ISTENEN_BOLGE_ARAZININ_DISINDA
  'ATTACK AREA RADIUS WAS NOT SPECIFIED', // TAARRUZ_BOLGESI_YARICAPI_GIRILMEDI
  'ATTACK AREA RADIUS IS 0 METERS', // TAARRUZ_BOLGESI_YARICAPI_0_GIRILDI
  'ATTACK AREA REQUIRES AT LEAST THREE LOCATIONS', // TAARRUZ_BOLGE_ICIN_EN_AZ_3_KONUM_GIRILMELI

  'COVERTING/DELAYING TIME WAS NOT SPECIFIED', // ORTME_OYALAMA_SURESI_GIRILMEDI
  'WITHDRAW AREA WAS NOT SPECIFIED', // GERI_CEKILME_BOLGESI_SECILMEDI
  'WITHDRAW AREA IS OUT OF BOUNDS', // GERI_CEKILME_BOLGESI_ARAZININ_DISINDA
  'WITHDRAW AREA RADIUS WAS NOT SPECIFIED', // GERI_CEKILME_BOLGESI_YARICAPI_GIRILMEDI
  'WITHDRAW AREA RADIUS IS 0 METERES', // GERI_CEKILME_BOLGESI_YARICAPI_0_GIRILDI
  'WITHDRAW AREA REQUIRES AT LEAST THREE LOCATIONS', // GERI_CEKILME_BOLGESI_ICIN_EN_AZ_3_KONUM_GIRILMELI

  'DEFENSE AREA WAS NOT SPECIFIED', // SAVUNMA_BOLGESI_SECILMEDI
  'DEFENSE AREA IS OUT OF BOUNDS', // SAVUNMA_BOLGESI_ARAZININ_DISINDA
  'DEFENSE AREA RADIUS WAS NOT SPECIFIED', // SAVUNMA_BOLGESI_YARICAPI_GIRILMEDI
  'DEFENSE AREA RADIUS IS 0 METERS', // SAVUNMA_BOLGESI_YARICAPI_0_GIRILDI
  'DEFENSE AREA REQUIRES AT LEAST THREE LOCATIONS', // SAVUNMA_BOLGESI_ICIN_EN_AZ_3_KONUM_GIRILMELI

  'FIRE INSUFFICIENT AMOUNT OF WEAPONS', // ATIS_SILAH_MIKTARI_YETERSIZ
  'FIRE INSUFFICIENT AMOUNT OF AMMO', // ATIS_MUHIMMAT_MIKTARI_YETERSIZ
  'FIRE INSUFFICIENT AMOUNT OF SUPPLIES', //	ATIS_KULLANILACAK_IKMAL_MADDESI_YETERSIZ,
  'FIRE TARGET OUT OF RANGE', //	ATIS_HEDEF_MENZIL_DISINDA,
  'FIRE TARGET BEHIND COVER', //	ATIS_HEDEF_SUTRE_ARKASINDA,
  'FIRE NO POINTING UNIT OR OUT OF RANGE', //	ATIS_ISARETLEYICI_BIRIM_YOK_VEYA_MENZILI_YETERSIZ,
  'FIRE WEAPON OR AMMUNITION IS UNEFFECTIVE IN CURRENT CONDITIONS', //	ATIS_SILAH_VEYA_MUHIMMAT_GECERLI_KOSULLARDA_ETKISIZ,
  'FIRE WEAPON IS MISSING', // ATIS_SILAH_BULUNAMADI,
  'FIRE LOCATION WAS NOT SPECIFIED', // ATIS_KONUMU_GIRILMEDI
  'TARGET IS OUT OF TERRAIN BOUNDS', // ATIS_KONUMU_ARAZI_DISINDA

  'INVALID TIME', // 	GIRILEN_SURE_GECERSIZ,
  'INVALID SPEED', // 	GIRILEN_HIZ_GECERSIZ,
  'INVALID NUMBER OF SHOTS', // 	GIRILEN_MIKTAR_GECERSIZ,
  'INVALID AMMUNITION', // 	GIRILEN_MUHIMMAT_GECERSIZ,
  'INVALID AGENT', // 	GIRILEN_ETMEN_GECERSIZ,
  'SPECIFIED AMMUNITION AND ENTITY IS INCOMPATIBLE', // GIRILEN_MUHIMMAT_GIRILEN_UNSUR_ILE_UYUMSUZ

  'AIR TASK COULD NOT BE CREATED', // HAVA_GOREV_OLUSTURULAMADI,
  'AIR TASK SUBCOMMAND IS INCORRECT', // HAVA_ALT_GOREV_HATALI,
  'AIR REFUEL COMMAND WAS NOT FOUND', // HAVA_IKMAL_GOREVI_BULUNAMADI,
  'AIR REFUEL TASK INSUFFICIENT SUPPLY', // HAVA_IKMAL_GOREVI_GEREKLI_IKMALE_SAHIP_DEGIL,
  'AIR TASK SPEED IS OUT OF BOUNDARIES OF AIRCRAFT', // HAVA_GOREV_HIZI_HAVA_ARACININ_SINIRLARI_DISINDA,
  'AIR TASK ALTITUDE IS OUT OF BOUNDARIES OF AIRCRAFT', // HAVA_GOREV_IRTIFASI_HAVA_ARACININ_SINIRLARI_DISINDA
  'AIR TASK WEIGHT IS TOO MUCH', // HAVA_AGIRLIK_FAZLA
  'AIR TASK NO AVALIABLE RUNWAY FOR TAKE OFF', // HAVA_KALKIS_ICIN_UYGUN_PIST_YOK
  'AIR TASK ROUTE IS OUT OF ALTITUDE BOUNDARIES', // HAVA_HEDEF_ROTA_IRTIFA_DISI

  'DIVISION FAILED', // BOLUNME_BASARISIZ,

  'MERGE TARGET AGENT IS ITSELF', //	BIRLESME_HEDEF_ETMENIN_KENDISI,
  'MERGE TARGET AGENT IS HIGHER AGENT', //	BIRLESME_HEDEF_ETMENIN_USTU,
  'MERGE AGENTS ARE MARITIME AGENTS', //	BIRLESME_ETMENLER_DENIZ_ETMENI,
  'MERGE TARGET AGENT IS SUPPLIER AGENT TO SOME AGENTS', //	BIRLESME_BIRLESECEK_ETMENIN_IKMALINDEN_SORUMLU_OLDUGU_ETMEN_VAR,
  'MERGE TARGET AGENT IS HIGHER AGENT TO SOME AGENTS', //	BIRLESME_BIRLESECEK_ETMENIN_ISLETTIGI_ETMEN_VAR,
  'MERGE TARGET AGENT IS FAR', //	BIRLESME_HEDEF_ETMEN_AYNI_KONUMDA_DEGIL,
  'MERGE TARGET AGENT IS MISSING', // BIRLESME_HEDEF_ETMEN_YOK

  'MINE WARFARE INSUFFICIENT REQUIREMENTS', //	MAYIN_HARBI_IHTIYACLAR_YETERSIZ,
  'MINE WARFARE HAS NO ABILITY TO LAY OBSTACLE', //	MAYIN_HARBI_ENGEL_DOSEME_YETENEGI_YOK,
  'MINE WARFARE HAS NO ABILITY TO REMOVE OBSTACLE', //	MAYIN_HARBI_ENGEL_TEMIZLEME_YETENEGI_YOK,
  'MINE WARFARE EXCEED CARRYING CAPACTIY', //	MAYIN_HARBI_TASIMA_KAPASITE_ASIMI,
  'MINE WARFARE NOT IN LOCATION TO LAY', //	MAYIN_HARBI_DOSEME_KONUMUNDA_DEGIL,
  'MINE WARFARE NAVALCRAFT CANNOT REMOVE OBSTACLES', //	MAYIN_HARBI_DENIZ_ARACI_ENGEL_TEMIZLEYEMEZ,
  'MINE WARFARE NOT IN LOCATION TO REMOVE', //	MAYIN_HARBI_TEMIZLEME_KONUMUNDA_DEGIL,
  'MINE WARFARE OUT OF STEPS', //	MAYIN_HARBI_ADIMLAR_BITMIS,
  'MINE WARFARE COULD NOT COMPLETE CONTROLS', //	MAYIN_HARBI_KONTROLLER_SAGLANAMADI,

  'TIME COULD NOT BE LOADED', // ZAMAN_YUKLENEMEDI,
  'THE CONTINUE COMMAND CANNOT BE ISSUED WITH A FUTURE DATE', // ZAMAN_DEVAM_ETME_KOMUTU_ILERI_TARIHLI_VERILEMEZ,

  'COMMAND REJECTED GENERIC', // EMIR_RET_JENERIK, Sebebi belli olmayan ret
  'COMMAND REJECTED COULD NOT FIND AGENT FOR COMMAND', // EMIR_RET_EMRI_ALACAK_ETMEN_BULUNAMADI,
  'COMMAND REJECTED RECEIVER TYPE IS NOT SPECIFIED', // EMIR_RET_EMIR_ALICI_TIPI_BELIRTILMEMIS,
  'COMMAND REJECTED COMMAND STRUCTURE IS WRONG', // EMIR_RET_EMIR_VERISI_YAPISI_YANLIS

  'COULD NOT FIND AIR SUB-MISSION', // HAVA_ALT_GOREV_BULUNAMADI
  'AIR MISSION INSUFFICIENT FUEL', // HAVA_GOREVI_YAKIT_YETERSIZ

  'AIR NO ACTING AGENT', // 	HAVA_ICRA_ETMEN_YOK,
  'AIR UNMANNED VEHICLE EXCEEDS DISTANCE', // 	HAVA_INSANSIZ_ARAC_UZAKLASMA_MESAFE_ASIMI,
  'AIR REFUEL ORDER IS NOT SUITABLE FOR AIRCRAFT', // 	HAVA_IKMAL_VER_EMRI_HAVA_ARACINA_UYGUN_DEGIL,
  'AIR TAKE REFUEL ORDER IS NOT SUITABLE FOR AIRCRAFT', // 	HAVA_IKMAL_AL_EMRI_HAVA_ARACINA_UYGUN_DEGIL,
  'AIR MISSION NOT ENOUGH AIRCRAFTS', // 	HAVA_GOREVI_YETERLI_HAVA_ARACI_YOK,

  'COULD NOT REACH TO DEFENSE AREA', // SAVUNMA_BOLGESINE_ULASILAMADI
  'COULD NOT REACH TO WITHDRAW AREA', // GERI_CEKILME_BOLGESINE_ULASILAMADI

  'FAILED TO LOAD COMAO', // 	COMAO_OKUNAMADI,
  'INSUFFICIENT SENSING RANGE', // 	ALGI_MESAFESI_YETERSIZ,
  'SUPPLYING AGENT DOES NOT HAVE SUPPLY', // 	IKMAL_ETMEN_ISTENEN_IKMAL_MADDESINE_SAHIP_DEGIL,

  // Görerek görmeyerek atış
  'TARGET INEFFECTIVE', // 	HEDEF_ETKISIZ,
  'TARGET IS PRISONER OF WAR', // 	HEDEF_HARP_ESIRI,
  'COULD NOT FIND TARGET', // 	HEDEF_BULUNAMADI,

  'COMMAND COMPLIANCE TYPE IS NOT RECOGNIZED', // 	EMIR_UYGULAMA_SEKLI_ANLASILMADI,
  'PARALLEL COMMAND IS NOT SUITABLE FOR COMPLIANCE', // 	PARALEL_EMIR_UYGULAMA_SEKLI_ICIN_UYGUN_DEGIL,

  'ROCKET FAIL', // 	FUZE_ATISI_BASARISIZ,
  'AIR TASK CRASHED DUE TO LACK OF FUELS', // 	HAVA_GOREVI_YAKIT_YETERSIZLIGINDEN_DUSTU,
  'COMAO COULD NOT REMOVED', // 	COMAO_SILINEMEDI,

  'COULD NOT FIND ASSIGNED AGENT FOR THE CLIENT USER', // 	ISTEMCININ_BAGLI_OLDUGU_ETMEN_BULUNAMADI,
  'CLIENT USER HAS NO AUTHORITY OVER THE SELECTED AGENT', // 	ISTEMCININ_ETMEN_UZERINDE_EMIR_YETKISI_YOK
  'CLIENT IS NOT RECOGNIZED', // ISTEMCI_TANINMIYOR

  'MOVE EXCEEDS LIQUID CARRYING CAPACITY', // INTIKAL_SIVI_TASIMA_KAPASITE_ASIMI
  'MOVE EXCEEDS HUMAN CARRYING CAPACITY', // INTIKAL_INSAN_TASIMA_KAPASITE_ASIMI
  'MOVE SPEED IS 0 IN AREA', // INTIKAL_HUCRE_ICINDE_INTIKAL_HIZI_SIFIR

  'WRONG AIR LIFTING TYPE', // HAVA_TASIMA_TURU_HATALI
  'AIR LIFTED AGENT CANNOT BE AIR DROPPED', // TASINAN_ETMEN_PARASUTLE_ATLAYAMAZ
  'WEIGHT OF THE AGENT TO BE CARRIED EXCEEDS CARRYING CAPACITY', // TASINACAK_ETMEN_AGIRLIGI_TASIMA_KAPASITESINI_ASIYOR
  'HUMAN AMOUNT OF THE AGENT TO BE CARRIED EXCEEDS HUMAN CARRYING CAPACITY', // TASINACAK_ETMEN_INSAN_SAYISI_INSAN_TASIMA_KAPASITESINI_ASIYOR

  'MISSILE SHOOTING INSUFFICIENT SUPPLIES', // FUZE_ATISI_IKMAL_YETERSIZ

  'AGENT TO BE TRANSPORTED IS NOT ACTIVE', // TASINACAK_ETMEN_AKTIF_DEGIL -2147483522
  'AN ENTITY OF AGENT IS OVER THE MAXIMUM CARRYING CAPACTIY FOR AIRCRAFT', // HAVA_ARACI_EN_AGIR_UNSURU_TASIYAMAZ -2147483521
  'A SUUPLY OF AGENT IS OVER THE MAXIMUM CARRYING CAPACTIY FOR AIRCRAFT', // HAVA_ARACI_EN_AGIR_IKMALI_TASIYAMAZ -2147483520

  // VT yükle hataları
  'DATABASE CONNECTION PROBLEM', // VT_BAGLANTI_HATASI -2147483519
  'FAILED TO LOAD DATABASE', // VT_YUKLENEMEDI -2147483518
  'AGENT OR AGENTS ARE OUT OF THEATER BOUNDS', // ETMEN_VEYA_ETMENLER_HARITA_DISINDA -2147483517
  'AGENTS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // ETMEN_SAYISI_MAX_SAYIDAN_BUYUK -2147483516
  'SIDES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // TARAF_SAYISI_MAX_SAYIDAN_BUYUK -2147483515
  'SIDE RELATIONS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // TARAF_ILISKILERI_SAYISI_MAX_SAYIDAN_BUYUK -2147483514
  'COULD NOT RECOGNIZE SIDE', // TARAF_ID_BULUNAMADI -2147483513
  'OBSTACLE FEATURES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // ARAZI_KENAR_TIPI_SAYISI_MAX_SAYIDAN_BUYUK -2147483512
  'TERRAIN TYPES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // ARAZI_TURU_SAYISI_MAX_SAYIDAN_BUYUK -2147483511
  'ROAD FEATURES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // YOL_OZELLIKLERI_SAYISI_MAX_SAYIDAN_BUYUK -2147483510
  'PRECIPITATION TYPES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // YAGIS_TIPI_SAYISI_MAX_SAYIDAN_BUYUK -2147483509
  'TERRAIN/WEATHER MOVEMENT MATRIX EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // ARAZI_HAVA_INTIKAL_SAYISI_MAX_SAYIDAN_BUYUK -2147483508
  'ROAD/WEATHER MOVEMENT EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // YOL_HAVA_INTIKAL_SAYISI_MAX_SAYIDAN_BUYUK -2147483507
  'DEPTH/ALTITUDE CATEGORIES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // DERINLIK_YUKSEKLIK_SAYISI_MAX_SAYIDAN_BUYUK -2147483506
  'INVALID DEPTH/ALTITUDE CATEGORY', // DERINLIK_YUKSEKLIK_ARALIK_GECERSIZ -2147483505
  'FLOW DIRECTIONS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // AKINTI_ISTIKAMETI_SAYISI_MAX_SAYIDAN_BUYUK -2147483504
  'INTENSITY OF FLOW EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // AKINTI_SIDDETI_SAYISI_MAX_SAYIDAN_BUYUK -2147483503
  'LIGHT STATUS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // AYDINLIK_SAYISI_DEPOLAYABILECEGINDEN_FAZLA -2147483502
  'WAVE DIRECTIONS MAXIMUM ACCEPTABLE ENTRIES', // DALGA_ISTIKAMETI_SAYISI_MAX_SAYIDAN_BUYUK -2147483501
  'WAVE HEIGHTS MAXIMUM ACCEPTABLE ENTRIES', // DALGA_YUKSEKLIGI_SAYISI_MAX_SAYIDAN_BUYUK -2147483500
  'LIGHT DIRECTIONS MAXIMUM ACCEPTABLE ENTRIES', // ISIK_ISTIKAMETI_SAYISI_MAX_SAYIDAN_BUYUK -2147483499
  'INTENSITY OF LIGHT MAXIMUM ACCEPTABLE ENTRIES', // ISIK_SIDDETI_SAYISI_MAX_SAYIDAN_BUYUK -2147483498
  'MAGNETIC ANOMALY PARAMETERS MAXIMUM ACCEPTABLE ENTRIES', // MANYETIK_ANOMALI_SAYISI_MAX_SAYIDAN_BUYUK -2147483497
  'SPACE WEATHERS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // UZAY_HAVASI_SAYISI_MAX_SAYIDAN_BUYUK -2147483496
  'AMOUNT OF PRECIPITATIONS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // YAGIS_MIKTARI_SAYISI_MAX_SAYIDAN_BUYUK -2147483495
  'TIDE HEIGHTS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // GELGIT_YUKSEKLIGI_SAYISI_MAX_SAYIDAN_BUYUK -2147483494
  'BEAUFORTS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // BEAUFORT_SAYISI_MAX_SAYIDAN_BUYUK -2147483493
  'WIND DIRECTIONS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // RUZGAR_ISTIKAMETI_MAX_SAYIDAN_BUYUK -2147483492
  'WEATHER MATRIX DOES NOT HAVE THE SAME AREA WITH THEATER', // HAVA_MATRISI_ARAZI_ILE_AYNI_ALANA_SAHIP_DEGIL -2147483491
  'SEA TRAFFIC SEPARATION SCHEME NODE TYPE WAS NOT RECOGNIZED', // DENIZ_TRAFIK_BOLUMLEME_YOLU_DUGUM_TURU_ANLASILMADI -2147483490
  'SUPPLIES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // IKMAL_SINIFI_SAYISI_MAX_SAYIDAN_BUYUK -2147483489
  'AIRLIFT CAPACITY INDEXES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // HAVA_ARACI_KAPASITE_INDEKS_SAYISI_MAX_SAYIDAN_BUYUK -2147483488
  'ALTITUDE ZONES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // IRTIFA_BOLGELERI_SAYISI_MAX_SAYIDAN_BUYUK -2147483487
  'AIRCRAFT CAPACITIES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // HAVA_ARACI_KAPASITE_SAYISI_MAX_SAYIDAN_BUYUK -2147483486
  'AIRCRAFT TEMPERATURE CATEGORIES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // HAVA_ARACI_SICAKLIK_KATEGORI_SAYISI_MAX_SAYIDAN_BUYUK -2147483485
  'SUBSEA DEFENSE INDEXES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // SU_SAVUNMA_MESAFE_SAYISI_MAX_SAYIDAN_BUYUK -2147483484
  'SUBSEA DEFENSE ENTITIES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // SU_ALTI_ETKI_ARAC_SAYISI_MAX_SAYIDAN_BUYUK -2147483483
  'DEPTH ZONES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // SU_ALTI_DERINLIK_BOLGELERI_SAYISI_MAX_SAYIDAN_BUYUK -2147483482
  'SUBSEA DEFENSE MATRIX EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // SU_ALTI_ETKI_MATRISI_SAYISI_MAX_SAYIDAN_BUYUK -2147483481
  'AIR DEFENSE MATRIX EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // HAVA_SAVUNMA_ETKI_MATRISI_SAYISI_MAX_SAYIDAN_BUYUK -2147483480
  'AIR DEFENSE ALTITUDE ZONES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // HAVA_SAVUNMA_IRTIFA_BOLGELERI_SAYISI_MAX_SAYIDAN_BUYUK -2147483479
  'SYSTEMS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // TMK_SAYISI_MAX_SAYIDAN_BUYUK -2147483478
  'NAVALCRAFTS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // DENIZ_ARACLARI_SAYISI_MAX_SAYIDAN_BUYUK -2147483477
  'OBSTACLES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // INSAN_YAPIMI_ENGEL_SAYISI_MAX_SAYIDAN_BUYUK -2147483476
  'COMMUNICATION DEVICES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // MUHABERE_CIHAZLARI_SAYISI_MAX_SAYIDAN_BUYUK -2147483475
  'BUILDINGS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // BINALARIN_SAYISI_MAX_SAYIDAN_BUYUK -2147483474
  'PORTS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // LIMANLARIN_SAYISI_MAX_SAYIDAN_BUYUK -2147483473
  'FACTIONS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // ETMEN_SINIFLARI_SAYISI_MAX_SAYIDAN_BUYUK -2147483472
  'AGENT PROTOTYPES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // ETMEN_TURLERI_SAYISI_MAX_SAYIDAN_BUYUK -2147483471

  "TORPEDO IS SLOWER THAN IT'S TARGET", // TORPIDO_HEDEFTEN_DAHA_YAVAS -2147483470
  'TORPEDO TARGET IS NOT ENEMY', // TORPIDO_HEDEF_DUSMAN_DEGIL -2147483469

  'NAVAL MOVE INSUFFICIENT DEPTH', // DENIZ_INTIKAL_DERINLIK_YETERLI_DEGIL -2147483468
  'SURFACE TO AIR MISSILE TARGET AGENT IS NOT AN AIR AGENT', // KARA_HAVA_FUZESI_HEDEF_ETMEN_HAVA_GOREVI_DEGIL -2147483467

  'NAVAL SINKING VICTIM EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // DENIZ_KAZAZEDE_TABLOSU_SAYISI_MAX_SAYIDAN_BUYUK -2147483466
  'NAVAL SINKING MATRIX EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // DENIZ_ARACI_BATMA_MATRISI_SAYISI_MAX_SAYIDAN_BUYUK -2147483465

  'FRIENDLY FIRE MATRIX EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // DAZE_TABLOSU_SAYISI_MAX_SAYIDAN_DAHA_BUYUK -2147483464
  'FRIENDLY FIRE INDEXES EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // DAZE_INDEX_SAYISI_MAX_SAYIDAN_DAHA_BUYUK -2147483463
  'TARGET AGENT WAS NOT DETECTED', // HEDEF_ETMEN_ALGILANMADI -2147483462
  'SIDES MAINTENANCE PARAMETERS EXCEEDS MAXIMUM ACCEPTABLE ENTRIES', // TARAFLAR_BAKIM_PARAMETRELERI_SAYISI_MAX_SAYIDAN_DAHA_BUYUK -2147483461
  'SIDES MAINTENANCE PARAMETERS ENTITY TYPE WAS NOT RECOGNIZED', // TARAFLAR_BAKIM_PARAMETRELERI_UNSUR_TIPI_ANLASILMADI -2147483460
  'DETECTION RANGE CANNOT BE LESS THAN RECOGNITION RANGE', // TESPIT_MENZILI_TESHIS_MENZILINDEN_KUCUK_OLAMAZ -2147483459
  'FORMATION OBJECTS FIRST OBJECT IS NOT PIVOT', // NIZAM_OGELERI_ILK_ELEMAN_PIVOT_ETMEN_DEGIL -2147483458
  'AGENT IS NOT OBJECT FOR FORMATION', // ETMEN_NIZAMIN_OGESI_DEGIL -2147483457

  'AIR ALTITUDE TEMPERATURE IS NOT SUITABLE FOR AIR MISSION', // HAVA KOSULLARI UCUSA UYGUN DEGIL -2147483456
  'AIR MISSION DESTROYED', // HAVA_GOREVI_IMHA_EDILDI // -2147483455;
  "SUPPLYING AGENT DOESN'T HAVE SUFFICIENT VEHICLE CAPACITY FOR REQUESTED SUPPLIES", // IKMAL_ETMENDE_ISTENEN_IKMALLERI_TASIYABILECEK_SAYIDA_ARAC_YOK, // -2147483454
  "SUPPLYING AGENT DOESN'T HAVE ENOUGH SUPPLIES FOR THE REQUEST", // IKMAL_IKMAL_ISTENEN_ETMENDE_YETERLI_MIKTARDA_MEVCUT_DEGIL, // -2147483453
  'SUPPLYING AGENT IS EXECUTING AN ANOTHER COMMAND', // IKMAL_IKMALDEN_SORUMLU_ETMENIN_ICRA_ETTIGI_BASKA_BIR_EMIR_VAR, // -2147483452

  // 'AGENT TO BE LIFTED IS NOT PRESENT AT EMBARKMENT LOCATION', // TASINACAK_ETMEN_BINDIRME_KONUMUNDA_DEGIL, // 2147483451
  'AGENT TO BE DISEMBARKED INSUFFICIENT CAPACTIY', // INDIRILECEK_ETMEN_KAPASITESI_YETERSIZ,						// -2147483451
  'LAND AGENT TO BE TELEPORTED CANNOT TELEPORT TO WATER', // ISINLAN_KARA_ETMENI_DENIZE_ISINLANAMAZ, // -2147483450
  'MARITIME AGENT TO BE TELEPORTED CANNOT TELEPORT TO LAND', // ISINLAN_DENIZ_ETMENI_KARAYA_ISINLANAMAZ, // -2147483449

  'SUPPLY REQURESTING AGENT IS NOT AT THE RENDEZVOUS POINT', // IKMAL_TALEP_EDEN_ETMEN_RANDEVU_KONUMUNDA_DEGIL,			// -2147483448
  'SUPPLY TRANSFER FAILED', // IKMAL_AKTARMA_BASARISIZ,								// -2147483447
  'AGENT HAS NO SUPPLYING AGENT', // ETMENIN_IKMALDEN_SORUMLU_ETMENI_YOK,					// -2147483446
  'SUPPLYING AGENT IS NOT AT THE RENDEZVOUS POINT', // IKMAL_TESLIM_EDECEK_ETMEN_RANDEVU_KONUMUNDA_DEGIL,		// -2147483445

  'DISEMBARKMENT PORT INSUFFICIENT DEPTH', // INDIRME_LIMANI_RIHTIM_DERINLIGI_YETERSIZ,				// -2147483444
  'EMBARKMENT PORT INSUFFICIENT DEPTH', // BINDIRME_LIMANI_RIHTIM_DERINLIGI_YETERSIZ,				// -2147483443
  'AGENT TO BE LIFTED IS NOT AT THE PORT', // TASINACAK_ETMEN_LIMAN_BOLGESINDE_DEGIL,					// -2147483442
  'AGENT TO BE EMBARKED WAS NOT FOUND', // BINDIRILECEK_ETMEN_BULUNAMADI,							// -2147483441
  'AGENT TO BE EMBARKED IS NOT A MARITIME AGENT', // BINDIRILECEK_ETMEN_DENIZ_ETMENI_DEGIL,					// -2147483440
  'AGENT TO BE DISEMBARKED WAS NOT FOUND', // INDIRILECEK_ETMEN_BULUNAMADI,							// -2147483439
  'AGENT TO BE DISEMBARKED IS NOT A MARITIME AGENT', // INDIRILECEK_ETMEN_DENIZ_ETMENI_DEGIL,					// -2147483438
  'AGENT TO BE LIFTED IS NOT AT MANIFEST AT AGENT TO BE EMBARKED', // TASINACAK_ETMEN_BINDIRILECEK_ETMENIN_MANIFESTOSUNDA_DEGIL,	// -2147483437
  'AGENT TO BE DISEMBARKED IS NOT AT THE LOCATION', // INDIRILECEK_ETMEN_KONUMDA_BULUNAMADI,						// -2147483436
  'AGENT TO BE EMBARKED IS NOT AT THE LOCATION', // BINDIRILECEK_ETMEN_KONUMDA_BULUNAMADI,						// -2147483435
  'INSUFFICIENT PORT DEPTH', // LIMAN_RIHTIM_DERINLIGI_YETERSIZ,							// -2147483434
  'COMMAND REJECTION AGENT HAS NO NAVALCRAFTS', // EMIR_RET_EMRI_ALACAK_ETMENDE_DENIZ_ARACI_BULUNAMADI		// -2147483433
  'AIR SUB-MISSION MOVEMENT ROUTE WAS NOT SPECIFIED', // HAVA_ALT_GOREV_INTIKAL_ROTASI_SECILMEDI,					// -2147483432
  'COULD NOT ESTABLISH COMMUNICATION', // MUHABERE_KURULAMADI	,										// -2147483431
  'COULD NOT REMOVE COMMUNICATION', // MUHABERE_KOPARILAMADI										// -2147483430
  'UNKNOWN AMMUNITION', // MUHIMMAT_TIPI_ANLASILMADI,									// -2147483429
  'COMMAND REJECTED FORMATION TO RECEIVE COMMAND WAS NOT FOUND', // EMIR_RET_EMRI_ALACAK_NIZAM_BULUNAMADI,						// -2147483428
  'COMMAND REJECTED AGENT CURRENTLY IN A FORMATION', // EMIR_RET_ETMEN_NIZAM_ETMENI,								// -2147483427
  'CBRN FIRE FAILED TO COMPLETE', // KBRN_ATISI_TAMAMLANAMADI,									// -2147483426

  'AGENT TO CARRY IS NOT AT THE PORT AREA', // TASIYACAK_ETMEN_LIMAN_BOLGESINDE_DEGIL,						// -2147483425

  'INSUFFICIENT SUPPLIES OR ENTITIES TO LAY OBSTACLES', // ENGEL_DOSEME_ICIN_YETERLI_IKMAL_VEYA_UNSUR_YOK,				// -2147483424
  'INSUFFICIENT SUPPLIES OR ENTITIES TO REMOVE OBSTACLES', // ENGEL_TEMIZLIGI_ICIN_YETERLI_IKMAL_VEYA_UNSUR_YOK,			// -2147483423
  'AGENT CANNOT LAY OBSTACLES', // ETMENIN_ENGEL_DOSEME_YETENEGI_YOK,							// -2147483422
  'AGENT CANNOT REMOVE OBSTACLES', // ETMENIN_ENGEL_TEMIZLEME_YETENEGI_YOK,						// -2147483421

  'QUERIED TERRAIN BATCH IS WRONG', // SORGULANAN_ARAZI_BATCH_YANLIS // -2147483420
  'TERRAIN BORDER DETAILS IS MISSING', // ARAZI_KENAR_BILGILERI_EKSIK // -2147483419
  'AIR ALTITUDE ZONE NUMBERS ARE WRONG', // HAVA_IRTIFA_BOLGELERI_SAYILARI_HATALI // -2147483418
  'QUERIED TERRAIN BATCH NUMBER IS WRONG', // SORGULANAN_ARAZI_BATCH_SAYISI_YANLIS // -2147483417
  'QUERIED TERRAIN BORDER VALUES DATA IS WRONG', // SORGULANAN_ARAZI_BORDER_DATA_SAYISI_YANLIS // -2147483416
  'CALCULATED TERRAIN INDEX IS WRONG', // HESAPLANAN_ARAZI_INDEX_HATALI // -2147483415
  'HEAD DIRECTION VALUE IS INVALID', // GIRILEN_BAS_ISTIKAMET_DEGERI_GECERSIZ // -2147483414
  'FORMATION MEMBER IS IN ANOTHER FORMATION', // NIZAM_UYESI_BASKA_BIR_NIZAMDA // -2147483413
  'INVALID FORMATION NAME', // NIZAM_ADI_GECERSIZ // -2147483412
  'FORMATION MEMBERS WERE NOT SPECIFIED', // NIZAM_UYELERI_TANIMLANMADI // -2147483411
  'NAVALCRAFT INVALID HEIGHT', // DENIZ_ARACI_GECERSIZ_YUKSEKLIK // -2147483410
  'AGENT TO BE CARRIED WAS NOT SPECIFIED', // TASINACAK_ETMEN_BELIRTILMEDI // -2147483409
  'EMBARKMENT PORT WAS NOT SPECIFIED', // BINDIRME_LIMANI_BELIRTILMEDI // -2147483408
  'DISEMBARKMENT PORT WAS NOT SPECIFIED', // INDIRME_LIMANI_BELIRTILMEDI // -2147483407
  'AGENT TO DISEMBARKED WAS NOT SPECIFIED', // INDIRILECEK_ETMEN_BELIRTILMEDI // -2147483406
  'NUMBER OF SHOTS IS NOT VALID', // ATIS_MIKTARI_GECERSIZ // -2147483405
  'TARGET LOCATION WAS NOT SPECIFIED', // HEDEF_LOKASYON_BELIRTILMEDI // -2147483404
  'CARRYING AGENT IS NOT AT THE PORT LOCATION', // TASIYAN_ETMEN_LIMAN_BOLGESINDE_DEGIL // -2147483403
  'AGENT IS A FORMATION MEMBER', // ETMEN_BIR_NIZAM_UYESI // -2147483402
  'INVALID AIR ESCORT AGENT', // UYGUN_OLMAYAN_HIMAYE_ETMENI // -2147483401
  'INVALID AIR INTERCEPT AGENT', // UYGUN_OLMAYAN_ONLEME_ETMENI // -2147483400
  'AMMUNITION TYPE IS NOT EFFECTIVE', // MUHIMMAT_TURU_ETKILI_DEGIL //2147483499
  'LOCATION TO DISEMBARK WAS NOT SPECIFIED', // INDIRILECEK_KONUM_BELIRTILMEDI, // -2147483398
  'LOCATION TO DISEMBARK IS OUT OF THEATRE BOUNDARIES', // INDIRILECEK_KONUM_ARAZI_DISINDA, // -2147483397
  'LOCATION TO DISEMBARK IS NOT VALID', // INDIRILECEK_KONUM_UYGUN_DEGIL, // -2147483396
  'AIRCRAFT NAME IS WRONG', // HAVA_ARACI_ISIM_BILGISI_YANLIS, // -2147483395
  'AIRCRAFT HAS MULTIPLE SAME TYPES OF WEAPONS', // HAVA_ARACI_BIRDEN_FAZLA_AYNI_TUR_SILAHA_SAHIP, // -2147483394
  'AGENT DIVIDE INSUFFICIENT SUPPLY QUANTITY', // ETMEN_BOL_IKMAL_SAYISI_YETERSIZ, // -2147483393
  'COULD NOT FIND SUFFICIENT AMOUNT OF CURRENT ENTITIES', // YETERLI_MEVCUT_UNSUR_BULUNAMADI, // -2147483392
  'COULD NOT FIND SUFFICIENT AMOUNT OF ENTITIES IN MAINTENANCE', // YETERLI_BAKIMDA_UNSUR_BULUNAMADI, // -2147483391
  'COULD NOT FIND SUFFICIENT AMOUNT OF CASUALTY ENTITIES', // YETERLI_ZAYIAT_UNSUR_BULUNAMADI, // -2147483390
  'COULD NOT FIND SUFFICIENT AMOUNT OF ENTITIES IN CBRN EFFECT', // YETERLI_KBRN_ETKISINDE_UNSUR_BULUNAMADI, // -2147483389
  'COULD NOT FIND SUFFICIENT AMOUNT OF MIXED ENTITIES', // YETERLI_KARISTIRILMIS_UNSUR_BULUNAMADI, // -2147483388
  'CARRYING AGENT WAS NOT SPECIFIED', // TASIYAN_ETMEN_BELIRTILMEDI, // -2147483387
  'HIGHER AGENT WAS NOT FOUND', // UST_ETMEN_BULUNAMADI, // -2147483386
  'SUPPLYING AGENT WAS NOT FOUND', // IKMALDEN_SORUMLU_ETMEN_BULUNAMADI, // -2147483385
  'DIVIDE TYPE WAS NOT RECOGNIZED', // BOLUNME_TIPI_ANLASILMADI, // -2147483384
  'ENTITY TYPE WAS NOT RECOGNIZED', // UNSUR_TIPI_ANLASILMADI, // -2147483383
  'LAY OBSTACLE WRONG TEAM QUANTTIY', // ENGEL_DOSE_TIM_SAYISI_HATALI, // -2147483382
  'LAY OBSTACLE ID OF OBSTACLE LAY IS WRONG', // ENGEL_DOSE_DOSENECEK_ENGEL_ID_HATALI, // -2147483381
  'LAY OBSTACLE WRONG DIMENSIONS', // ENGEL_DOSE_UZUNLUK_VE_GENISLIK_HATALI, // -2147483380
  'REMOVE OBSTACLE WRONG AGENT ID', // ENGEL_TEMIZLE_ETMEN_ID_HATALI, // -2147483379
  'WRONG COMMAND DETAILS', // EMIR_ICERIGI_HATALI, // -2147483378
  'RESUPPLYING AGENT ID IS WRONG', // IKMAL_ALAN_ETMEN_ID_HATALI, // -2147483377
  'SUPPLYER AGENT ID IS WRONG', // IKMAL_VEREN_ETMEN_ID_HATALI, // -2147483376
  'SUPPLY TYPE IS WRONG', // IKMAL_TIPI_HATALI, // -2147483375
  'REQUESTED SUPPLY IS WRONG', // ISTENEN_IKMAL_HATALI, // -2147483374
  'REQUESTED SUPPLY QUANTITY IS WRONG', // ISTENEN_IKMAL_MIKTARI_HATALI, // -2147483373
  'REQUESTED SUPPLY TARGET AMOUNT IS WRONG', // ISTENEN_IKMAL_HEDEF_SEVIYESI_HATALI, // -2147483372
  'REQUESTED SUPPLY AUTOMATIC RESUPPLY AMOUNT IS WRONG', // ISTENEN_IKMAL_OTOMATIK_YENIDEN_IKMAL_SEVIYESI_HATALI, // -2147483371
  'TELEPORT LOCATION IS BELOW OF THE THEATRE', // ISINLANMA_NOKTASI_ARAZININ_ALTINDA_KALMAKTADIR, // -2147483370
  'AGENT PROTOTYPE WAS NOT RECOGNIZED', // ETMEN_TIPI_ANLASILMADI, // -2147483369
  'TELEPORT TARGET TYPE WAS NOT RECOGNIZED', // ISINLANMA_HEDEF_TIPI_ANLASILMADI, // -2147483368
  'TARGET TYPE WAS NOT RECOGNIZED', // HEDEF_TIPI_ANLASILMADI, // -2147483367
  'AGENT PROTOTYPE IS NOT LAND TYPE', // ETMEN_TIPI_KARA_DEGIL, // -2147483366
  'AGENT PROTOTYPE IS NOT MARITIME TYPE', // ETMEN_TIPI_DENIZ_DEGIL, // -2147483365
  'AGENT PROTOTYPE IS NOT AIR TYPE', // ETMEN_TIPI_HAVA_DEGIL, // -2147483364
  'AGENT PROTOTYPE IS NOT OBSTACLE', // ETMEN_TIPI_ENGEL_DEGIL, // -2147483363
  'AGENT PROTOTYPE IS NOT MISSILE', // ETMEN_TIPI_FUZE_DEGIL, // -2147483362
  'AGENT PROTOTYPE IS NOT CBRN', // ETMEN_TIPI_KBRN_DEGIL, // -2147483361
  'AGENT PROTOTYPE IS NOT TORPEDO', // ETMEN_TIPI_TORPIDO_DEGIL, // -2147483360
  'AGENT PROTOTYPE IS NOT CIVILIAN', // ETMEN_TIPI_SIVIL_DEGIL, // -2147483359

  'COMMAND TYPE WAS NOT RECOGNIZED' = -2147483358, // EMIR_TURU_ANLASILMADI
  'EMBARKED CANNOT MOVE' = -2147483357, // BINDIRILMIS_INTIKAL_YAPILAMAZ
  'WRONG CASUALTY LIMIT' = -2147483356, // ZAYIAT_LIMITI_HATALI
  'PROCUREMENT METHOD WAS NOT RECOGNIZED' = -2147483355, // TEDARIK_YONTEMI_ANLASILAMADI
  'EMBARKMENT AIRPORT WAS NOT FOUND' = -2147483354, // BINDIRME_HAVA_ALANI_BULUNAMADI
  'DISEMBARKMENT AIRPORT WAS NOT FOUND' = -2147483353, // INDIRME_HAVA_ALANI_BULUNAMADI
  'LAND AGENT IS IN MEMBERS OF FORMATION' = -2147483352, // NIZAM_UYELERINDE_KARA_ETMENI_BULUNDU
  'DISEMBARKMENT AIRPORT BELONGS TO ENEMY' = -2147483351, // INDIRME_HAVA_ALANI_DUSMAN_TARAFA_AIT
  'COMMAND EXECUTION TIME TYPE WAS NOT RECOGNIZED' = -2147483350, // ICRA_ZAMAN_TIPI_BULUNAMADI
  'COMMAND EXECUTION TIME TYPE IS WRONG' = -2147483349, // ICRA_ZAMAN_TIPI_HATALI
  'COMMAND EXECUTION TIME TYPE WAS NOT FOUND' = -2147483348, // ICRA_ZAMANI_BULUNAMADI
  'COMAO WAS NOT FOUND' = -2147483347, // COMAO_ID_BULUNAMADI
  'COMAO IS INVALID' = -2147483346, // COMAO_ID_ESLESMEDI
  'COMAO EXECUTION TIME TYPE WAS NOT FOUND' = -2147483345, // COMAO_ICRA_ZAMAN_TIPI_BULUNAMADI
  'COMAO EXECUTION TIME TYPE IS WRONG' = -2147483344, // COMAO_ICRA_ZAMAN_TIPI_HATALI
  'DELAY TIME WAS NOT FOUND' = -2147483343, // GECIKME_ZAMANI_BULUNAMADI
  'DELAY TIME IS WRONG' = -2147483342, // GECIKME_ZAMANI_HATALI
  'COMMAND WAS NOT FOUND' = -2147483341, // EMIR_ID_BULUNAMADI
  'RECEIVER TYPE WAS NOT FOUND' = -2147483340, // ALICI_TIPI_BULUNAMADI
  'RECEIVER IS WRONG' = -2147483339, // ALICI_TIPI_HATALI
  'COMMAND APPLICATION METHOD WAS NOT FOUND' = -2147483338, // UYGULAMA_SEKLI_BULUNAMADI
  'PREVIOUS COMMAND WAS NOT FOUND' = -2147483337, // ONCEKI_EMIR_ID_BULUNAMADI
  'PREVIOUS COMMAND IS WRONG' = -2147483336, // ONCEKI_EMIR_ID_HATALI
  'NEW AGENT DETAILS WAS NOT FOUND' = -2147483335, // YENI_ETMEN_DETAYLARI_BULUNAMADI
  'NEW AGENT DETAILS IS WRONG' = -2147483334, // YENI_ETMEN_DETAYLARI_HATALI
  'SYMBOL WAS NOT FOUND' = -2147483333, // SIDC_BULUNAMADI
  'SYMBOL IS WRONG' = -2147483332, // SIDC_HATALI
  'AIRPORT INFORMATION WAS NOT FOUND' = -2147483331, // HAVA_ALANI_BILGISI_BULUNAMADI
  'AIRPORT INFORMATION IS WRONG' = -2147483330, // HAVA_ALANI_BILGISI_HATALI
  'AGENT TO JOIN WAS NOT FOUND' = -2147483329, // KATILACAGI_ETMEN_VERITABANI_ID_BULUNAMADI
  'AGENT TO JOIN INFORMATION IS WRONG' = -2147483328, // KATILACAGI_ETMEN_VERITABANI_ID_HATALI
  'AIRCRAFT INFORMATION WAS NOT FOUND' = -2147483327, // HAVA_ARACI_BILGISI_BULUNAMADI
  'AIRCRAFT INFORMATION IS WRONG' = -2147483326, // HAVA_ARACI_BILGISI_HATALI
  'AIRCRAFT WAS NOT FOUND' = -2147483325, // HAVA_ARACI_VERITABANI_ID_BULUNAMADI
  'AIRCRAFT ID IS WRONG' = -2147483324, // HAVA_ARACI_VERITABANI_ID_HATALI
  'AIRCRAFT QUANTITY WAS NOT FOUND' = -2147483323, // HAVA_ARACI_SAYISI_BULUNAMADI
  'AIRCRAFT QUANTITY IS WRONG' = -2147483322, // HAVA_ARACI_SAYISI_HATALI
  'PAYLOAD LIST WAS NOT FOUND' = -2147483321, // FAYDALI_YUK_LISTESI_BULUNAMADI
  'PAYLOAD LIST IS WRONG' = -2147483320, // FAYDALI_YUK_LISTESI_HATALI
  'PRESET PAYLOAD INFORMATION WAS NOT FOUND' = -2147483319, // HAZIR_FAYDALI_YUK_MU_BILGISI_BULUNAMADI
  'PRESET PAYLOAD INFORMATION IS WRONG' = -2147483318, // HAZIR_FAYDALI_YUK_MU_BILGISI_HATALI
  'PAYLOAD ID WAS NOT FOUND' = -2147483317, // YUK_ID_BULUNAMADI
  'PAYLOAD ID IS WRONG' = -2147483316, // YUK_ID_HATALI
  'PAYLOAD TYPE WAS NOT FOUND' = -2147483315, // YUK_TIPI_BULUNAMADI
  'PAYLOAD TYPE IS WRONG' = -2147483314, // YUK_TIPI_HATALI
  'PAYLOAD QUANTITY WAS NOT FOUND' = -2147483313, // YUK_MIKTARI_BULUNAMADI
  'PAYLOAD QUANTITY IS WRONG' = -2147483312, // YUK_MIKTARI_HATALI
  'AIR SUBMISSION ID WAS NOT FOUND' = -2147483311, // HAVA_ALT_GOREV_ID_BULUNAMADI
  'AIR SUBMISSION ID IS WRONG' = -2147483310, // HAVA_ALT_GOREV_ID_HATALI
  'AIR SUBMISSION TYPE WAS NOT FOUND' = -2147483309, // HAVA_ALT_GOREV_TIP_BULUNAMADI
  'AIR SUBMISSION TYPE IS WRONG' = -2147483308, // HAVA_ALT_GOREV_TIP_HATALI
  'AIR SUBMISSION EXECUTION TIME TYPE WAS NOT FOUND' = -2147483307, // HAVA_ALT_GOREV_ICRA_ZAMANI_TIPI_BULUNAMADI
  'AIR SUBMISSION EXECUTION TIME TYPE IS WRONG' = -2147483306, // HAVA_ALT_GOREV_ICRA_ZAMANI_TIPI_HATALI
  'AIR SUBMISSION EXECUTION TIME WAS NOT FOUND' = -2147483305, // HAVA_ALT_GOREV_ICRA_ZAMANI_BULUNAMADI
  'AIR SUBMISSION EXECUTION TIME IS WRONG' = -2147483304, // HAVA_ALT_GOREV_ICRA_ZAMANI_HATALI
  'AIR SUBMISSION MISSION SPEED WAS NOT FOUND' = -2147483303, // HAVA_ALT_GOREV_GOREV_HIZI_BULUNAMADI
  'AIR SUBMISSION MISSION SPEED IS WRONG' = -2147483302, // HAVA_ALT_GOREV_GOREV_HIZI_HATALI
  'AIR SUBMISSION MISSION ALTITUDE WAS NOT FOUND' = -2147483301, // HAVA_ALT_GOREV_GOREV_IRTIFASI_BULUNAMADI
  'AIR SUBMISSION MISSION ALTITUDE IS WRONG' = -2147483300, // HAVA_ALT_GOREV_GOREV_IRTIFASI_HATALI
  'AIR SUBMISSION ENGAGEMENT RULE WAS NOT FOUND' = -2147483299, // HAVA_ALT_GOREV_ANGAJMAN_KURALI_BULUNAMADI
  'AIR SUBMISSION ENGAGEMENT RULE IS WRONG' = -2147483298, // HAVA_ALT_GOREV_ANGAJMAN_KURALI_HATALI
  'AIR SUBMISSION INGRESS ROUTE WAS NOT FOUND' = -2147483297, // HAVA_ALT_GOREV_GIDIS_ROTASI_BULUNAMADI
  'AIR SUBMISSION INGRESS ROUTE IS WRONG' = -2147483296, // HAVA_ALT_GOREV_GIDIS_ROTASI_HATALI
  'AIR SUBMISSION INGRESS ROUTE LATITUDE IS WRONG' = -2147483295, // HAVA_ALT_GOREV_GIDIS_ROTASI_ENLEM_BILGISI_YANLIS
  'AIR SUBMISSION INGRESS ROUTE LONGITUDE IS WRONG' = -2147483294, // HAVA_ALT_GOREV_GIDIS_ROTASI_BOYLAM_BILGISI_YANLIS
  'AIR SUBMISSION INGRESS ROUTE ALTITUDE IS WRONG' = -2147483293, // HAVA_ALT_GOREV_GIDIS_ROTASI_YUKSEKLIK_BILGISI_YANLIS
  'AIR SUBMISSION EXTRA PARAMETERS WAS NOT FOUDN' = -2147483292, // HAVA_ALT_GOREV_ILAVE_PARAMETRELER_BULUNAMADI
  'AIR SUBMISSION EXTRA PARAMETERS IS WRONG' = -2147483291, // HAVA_ALT_GOREV_ILAVE_PARAMETRELER_HATALI
  'AIR SUBMISSION GET REFUEL COMMAND ID WAS NOT FOUND' = -2147483290, // HAVA_ALT_GOREV_IKMAL_ALINACAK_EMIR_ID_BULUNAMADI
  'AIR SUBMISSION GET REFUEL COMMAND ID IS WRONG' = -2147483289, // HAVA_ALT_GOREV_IKMAL_ALINACAK_EMIR_ID_HATALI
  'AIR SUBMISSION GET REFUEL SUBMISSION ID WAS NOT FOUND' = -2147483288, // HAVA_ALT_GOREV_IKMAL_ALINACAK_ALT_EMIR_ID_BULUNAMADI
  'AIR SUBMISSION GET REFUEL SUBMISSION ID IS WRONG' = -2147483287, // HAVA_ALT_GOREV_IKMAL_ALINACAK_ALT_EMIR_ID_HATALI
  'AIR SUBMISSION REFUEL AMOUNT WAS NOT FOUND' = -2147483286, // HAVA_ALT_GOREV_ALINACAK_YAKIT_MIKTARI_BULUNAMADI
  'AIR SUBMISSION REFUEL AMOUNT IS WRONG' = -2147483285, // HAVA_ALT_GOREV_ALINACAK_YAKIT_MIKTARI_HATALI
  'AIR SUBMISSION MISSION ROUTE WAS NOT FOUND' = -2147483284, // HAVA_ALT_GOREV_GOREV_ROTASI_BULUNAMADI
  'AIR SUBMISSION MISSION ROUTE IS WRONG' = -2147483283, // HAVA_ALT_GOREV_GOREV_ROTASI_HATALI
  'AIR SUBMISSION MISSION ROUTE LATITUDE IS WRONG' = -2147483282, // HAVA_ALT_GOREV_GOREV_ROTASI_ENLEM_BILGISI_YANLIS
  'AIR SUBMISSION MISSION ROUTE LONGITUDE IS WRONG' = -2147483281, // HAVA_ALT_GOREV_GOREV_ROTASI_BOYLAM_BILGISI_YANLIS
  'AIR SUBMISSION MISSION ROUTE ALTITUDE IS WRONG' = -2147483280, // HAVA_ALT_GOREV_GOREV_ROTASI_YUKSEKLIK_BILGISI_YANLIS
  'AIR SUBMISSION TARGET TYPE WAS NOT FOUND' = -2147483279, // HAVA_ALT_GOREV_HEDEF_TIPI_BULUNAMADI
  'AIR SUBMISSION TARGET TYPE IS WRONG' = -2147483278, // HAVA_ALT_GOREV_HEDEF_TIPI_HATALI
  'AIR SUBMISSION TARGET AGENT FOR ATTACK WAS NOT FOUND' = -2147483277, // HAVA_ALT_GOREV_TAARRUZ_EDILECEK_HEDEF_ETMEN_ID_BULUNAMADI
  'AIR SUBMISSION TARGET AGENT ID FOR ATTACK IS WRONG' = -2147483276, // HAVA_ALT_GOREV_TAARRUZ_EDILECEK_HEDEF_ETMEN_ID_HATALI
  'AIR SUBMISSION AMMUNITION TO USE WAS NOT FOUND' = -2147483275, // HAVA_ALT_GOREV_KULLANILACAK_MUHIMMAT_ID_BULUNAMADI
  'AIR SUBMISSION AMMUNITION ID TO USE IS WRONG' = -2147483274, // HAVA_ALT_GOREV_KULLANILACAK_MUHIMMAT_ID_HATALI
  'AIR SUBMISSION NUMBER OF SHOTS WAS NOT FOUND' = -2147483273, // HAVA_ALT_GOREV_ATIS_SAYISI_BULUNAMADI
  'AIR SUBMISSION NUMBER OF SHOTS IS WRONG' = -2147483272, // HAVA_ALT_GOREV_ATIS_SAYISI_HATALI
  'AIR SUBMISSION PRIORITY ORDER CONTROL WAS NOT FOUND' = -2147483271, // HAVA_ALT_GOREV_ONCELIK_KONTROL_BULUNAMADI
  'AIR SUBMISSION PRIORITY ORDER CONTROL IS WRONG' = -2147483270, // HAVA_ALT_GOREV_ONCELIK_KONTROL_HATALI
  'AIR SUBMISSION PRIORITY ORDER WAS NOT FOUND' = -2147483269, // HAVA_ALT_GOREV_HEDEF_TURU_ONCELIK_SIRALAMASI_BULUNAMADI
  'AIR SUBMISSION PRIORITY ORDER IS WRONG' = -2147483268, // HAVA_ALT_GOREV_HEDEF_TURU_ONCELIK_SIRALAMASI_HATALI
  'AIR SUBMISSION PRIORTIY ORDER PRIMARY TARGET WAS NOT FOUND' = -2147483267, // HAVA_ALT_GOREV_BIRINCI_ONCELIKLI_HEDEF_BULUNAMADI
  'AIR SUBMISSION PRIORTIY ORDER SECONDARY TARGET WAS NOT FOUND' = -2147483266, // HAVA_ALT_GOREV_IKINCI_ONCELIKLI_HEDEF_BULUNAMADI
  'AIR SUBMISSION PRIORTIY ORDER THIRD TARGET WAS NOT FOUND' = -2147483265, // HAVA_ALT_GOREV_UCUNCU_ONCELIKLI_HEDEF_BULUNAMADI
  'AIR SUBMISSION PRIORTIY ORDER FOURTH TARGET WAS NOT FOUND' = -2147483264, // HAVA_ALT_GOREV_DORDUNCU_ONCELIKLI_HEDEF_BULUNAMADI
  'AIR SUBMISSION SURVEILLANCE DISTANCE WAS NOT FOUND' = -2147483263, // HAVA_ALT_GOREV_IZLEME_MESAFESI_BULUNAMADI
  'AIR SUBMISSION SURVEILLANCE DISTANCE IS WRONG' = -2147483262, // HAVA_ALT_GOREV_IZLEME_MESAFES_HATALI
  'AIR SUBMISSION AIR LIFT TYPE WAS NOT FOUND' = -2147483261, // HAVA_ALT_GOREV_HAVADAN_INTIKAL_TURU_BULUNAMADI
  'AIR SUBMISSION AIR LIFT TYPE IS WRONG' = -2147483260, // HAVA_ALT_GOREV_HAVADAN_INTIKAL_TURU_HATALI
  'AIR SUBMISSION AGENT TO CARRY WAS NOT FOUND' = -2147483259, // HAVA_ALT_GOREV_TASINACAK_ETMEN_ID_BULUNAMADI
  'AIR SUBMISSION AGENT ID TO CARRY IS WRONG' = -2147483258, // HAVA_ALT_GOREV_TASINACAK_ETMEN_ID_HATALI
  'AIR SUBMISSION EMBARKMENT AIRPORT WAS NOT FOUND' = -2147483257, // HAVA_ALT_GOREV_BINDIRME_HAVA_ALANI_BULUNAMADI
  'AIR SUBMISSION EMBARKMENT AIRPORT IS WRONG' = -2147483256, // HAVA_ALT_GOREV_BINDIRMA_HAVA_ALANI_HATALI
  'AIR SUBMISSION DISEMBARKMENT AIRPORT WAS NOT FOUND' = -2147483255, // HAVA_ALT_GOREV_INDIRME_HAVA_ALANI_BULUNAMADI
  'AIR SUBMISSION DISEMBARKMENT AIRPORT IS WRONG' = -2147483254, // HAVA_ALT_GOREV_INDIRME_HAVA_ALANI_HATALI
  'AIR SUBMISSION FOLLOWING DISTANCE FOR AGENT WAS NOT FOUND' = -2147483253, // HAVA_ALT_GOREV_ETMENE_GORE_TAKIP_KONUMU_BULUNAMADI
  'AIR SUBMISSION FOLLOWING DISTANCE FOR AGENT IS WRONG' = -2147483252, // HAVA_ALT_GOREV_ETMENE_GORE_TAKIP_KONUMU_HATALI
  'AIR SUBMISSION EGRESS ROUTE WAS NOT FOUND' = -2147483251, // HAVA_ALT_GOREV_DONUS_ROTASI_BULUNAMADI
  'AIR SUBMISSION EGRESS ROUTE IS WRONG' = -2147483250, // HAVA_ALT_GOREV_DONUS_ROTASI_HATALI
  'AIR SUBMISSION EGRESS ROUTE LATITUDE IS WRONG' = -2147483249, // HAVA_ALT_GOREV_DONUS_ROTASI_ENLEM_BILGISI_YANLIS
  'AIR SUBMISSION EGRESS ROUTE LONGITUDE IS WRONG' = -2147483248, // HAVA_ALT_GOREV_DONUS_ROTASI_BOYLAM_BILGISI_YANLIS
  'AIR SUBMISSION EGRESS ROUTE ALTITUDE IS WRONG' = -2147483247, // HAVA_ALT_GOREV_DONUS_ROTASI_YUKSEKLIK_BILGISI_YANLIS
  'AIR SUBMISSION WAITING TIME BEFORE DEPARTURE WAS NOT FOUND' = -2147483246, // HAVA_ALT_GOREV_HEDEFTEN_AYRILIS_BEKLEME_SURESI_BULUNAMADI
  'AIR SUBMISSION WAITING TIME BEFORE DEPARTURE IS WRONG' = -2147483245, // HAVA_ALT_GOREV_HEDEFTEN_AYRILIS_BEKLEME_SURESI_HATALI
  'AIR SUBMISSION CONNECTED TO ANOTHER MISSION INFORMATION WAS NOT FOUND' = -2147483244, // HAVA_ALT_GOREV_BASKA_GOREVE_BAGLI_MI_BILGISI_BULUNAMADI
  'AIR SUBMISSION MISSION TO CHAIN WAS NOT FOUND' = -2147483243, // HAVA_ALT_GOREV_BAGLANILACAK_GOREV_BULUNAMADI
  'AGENT CANNOT RECEIVE COMMANDS' = -2147483242, // ETMEN_EMIR_ALMAYA_UYGUN_DEGIL
  'AIR SUBMISSION ROUTE IS OUT OF THEATRE BOX' = -2147483241, // HAVA_ALT_GOREV_ROTA_ARAZI_DISINDA
  'FORMATION MEMBER AND PIVOT CANNOT BE AT THE SAME LOCATION' = -2147483240, // NIZAM_OGESI_VE_PIVOT_AYNI_KONUMDA_OLAMAZ
  'AGENT TO EMBARK IS NOT FROM SAME, FRIENDLY OR ALLY SIDE' = -2147483239, // BINDIRILECEK_ETMEN_DOST_MUTTEFIK_YA_DA_KENDISI_DEGIL
  'AGENT TO DISEMBARK IS NOT FROM SAME, FRIENDLY OR ALLY SIDE' = -2147483238, // INDIRILECEK_ETMEN_DOST_MUTTEFIK_YA_DA_KENDISI_DEGIL
  'FORMATION DISBANDED' = -2147483237, // NIZAM_BOZULDU
  'RUNWAY WAS NOT FOUND' = -2147483236, // PIST_BULUNAMADI
  'AGENT CANNOT REACH TO ESCORT TARGET AGENT' = -2147483235, // ETMEN_HIMAYE_HEDEFINE_YETISEMEZ
  'TIME DETAILS ARE WRONG' = -2147483234, // ZAMAN_PARAMETRELERI_HATALI
  'FORMATION MEMBER HAS NO NAVALCRAFT' = -2147483233, // NIZAM_UYESINDE_DENIZ_ARACI_BULUNAMADI
  'UNABLE TO REACH LAND WITHIN DISEMBARKMENT DISTANCE THRESHOLD' = -2147483232, // AZAMI_MESAFEDE_KARA_BULUNAMADI
  'FORMATION MEMBERS CANNOT BE AT THE SAME LOCATION' = -2147483231, // NIZAM_UYELERI_AYNI_KONUMDA_BULUNAMAZ
  'VEHICLE TO CARRY SELF-PROPELLED SYSTEM IS MISSING ON AGENT' = -2147483230, // KUNDAGI_MOTORLU_TMKYI_TASIYACAK_ARAC_ETMENDE_MEVCUT_DEGIL
  'QUANTITY OF VEHICLE TO CARRY SELF-PROPELLED SYSTEM IS INSUFFICIENT ON AGENT' = -2147483229, // KUNDAGI_MOTORLU_TMKYI_TASIYACAK_ARAC_SAYISI_YETERSIZ
  'CARRYING CAPACITY IS NOT SUFFICIENT TO CARRY SELF-PROPELLED SYSTEM' = -2147483228, // TASIMA_KAPASITESI_KUNDAGI_MOTORLU_TMKYI_TASIMAYA_YETMIYOR
  'QUANTITY OF VEHICLE TO TOW SYSTEMS NEEDS BE TOWED IS INSUFFICIENT ON AGENT' = -2147483227, // CEKILI_TMKLARI_CEKMEYE_YETECEK_MIKTARDA_ARAC_MEVCUT_DEGIL
  'DEFAULT AMMUNITION INDEX FOR SYSTEMS WAS NOT SPECIFIED' = -2147483226, // TMKLAR_ICIN_DEFAULT_MUHIMMAT_SECILMEMIS
  'AIR SUBMISSION AGENT TO ESCORT IS NOT PART OF THE COMAO' = -2147483225, // HAVA_ALT_GOREV_HIMAYE_EDILECEK_ETMEN_COMAONUN_PARCASI_DEGIL
  'COMMAND REJECTED COMMAND RECEIVER TYPE IS WRONG' = -2147483224, // EMIR_RET_EMIR_ALICI_TIPI_YANLIS
  'NAVALCRAFT WAS NOT FOUND' = -2147483223, // DENIZ_ARACI_BULUNAMADI
  'COMMAND REJECTED VOLUME INFORMATION IS WRONG' = -2147483222, // EMIR_RET_HACIM_VERISI_HATALI
  'AGENT IS NOT AT THE PORT' = -2147483221, // ETMEN_LIMANDA_DEGIL
  'COULD NOT CREATE MARITIME AGENT' = -2147483220, // DENIZ_ETMENI_OLUSTURULAMADI
  'SELECTED AMMUNITION IS NOT TRACEABLE' = -2147483219, // SECILEN_MUHIMMAT_SEYRI_IZLENEBILIR_DEGIL
  'AGENT IS NOT WITHIN EMBARKMENT DISTANCE THRESHOLD' = -2147483218, // ETMEN_AZAMI_BINDIRME_MESAFESINDE_DEGIL
  'AGENT EMBARKMENT LOCATION WAS NOT SPECIFIED' = -2147483217, // BINDIRILECEK_KONUM_BELIRTILMEDI
  'AGENT EMBARKMENT LOCATION IS OUT OF THEATRE BOX' = -2147483216, // BINDIRILECEK_KONUM_ARAZI_DISINDA
  'INGRESS ROUTE TO MISSION START POINT IS MISSING' = -2147483215, // GOREV_BASLANGIC_KONUMUNA_INTIKAL_ROTASI_GIRILMEDI
  'EGRESS ROUTE AFTER THE MISSION IS MISSING' = -2147483214, // GOREV_SONRASI_INTIKAL_ROTASI_GIRILMEDI
  'MARITIME PATROL AREA WRONG OR NOT FOUND' = -2147483213, // DEVRIYE_BOLGE_BILGISI_HATALI_VEYA_BULUNAMADI
  'AGENT HAS NO SENSING DEVICE' = -2147483212, // ETMENDE_ALGI_CIHAZI_MEVCUT_DEGIL
  'MARITIME PATROL AREA HAS LOCATION OUTSIDE OF THEATRE' = -2147483211, // DEVRIYE_BOLGE_BILGISINDE_ARAZI_DISINDA_KONUM_MEVCUT
  'FOLLOWING DISTANCE EXCEEDS AGENTS MAX RECOGNITION DISTANCE' = -2147483210, // IZLEME_MESAFESI_ETMENIN_MAKSIMUM_TESPIT_MESAFESINDEN_FAZLA
  'MARITIME PATROL COMMAND FINISHED' = -2147483209, // KARAKOL_GOREVI_SONLANDI
  'NOT ENOUGH ENTITIES TO ARRANGE DESIRED TEAM' = -2147483208, // ISTENILEN_TAKIMI_OLUSTURACAK_KADAR_UNSUR_MEVCUT_DEGIL
  'LAY MINE INSUFFICIENT ENTITES' = -2147483207, // ENGEL_DOSEME_ICIN_YETERLI_UNSUR_MEVCUT_DEGIL
  'LAY MINE INSUFFICIENT SUPPLIES' = -2147483206, // ENGEL_DOSEME_ICIN_YETERLI_IKMAL_MEVCUT_DEGIL
  'LAY MINE INSUFFICIENT REQUIRED SYSTEMS' = -2147483205, // ENGEL_DOSEME_ICIN_YETERLI_GEREKLI_TMK_MEVCUT_DEGIL
  'MARITIME WAY ENVIRONMENT CONDITIONS ARE NOT SUITABLE FOR MOVE' = -2147483204, // DENIZ_YOLU_ORTAM_PARAMETRESI_INTIKALE_UYGUN_DEGIL
  'AIR SUBMISSION AGENT TO BE ESCORTED HAS NO COMMAND' = -2147483203, // HAVA_ALT_GOREV_HIMAYE_EDILEN_ETMENIN_EMRI_YOK
  'MOVE INSUFFICIENT REQUIRED SYSTEMS' = -2147483202, // INTIKAL_ICIN_YETERLI_GEREKLI_TMK_MEVCUT_DEGIL
  'SECRECY LEVEL WAS NOT SPECIFIED OR NOT SUITABLE' = -2147483201, // GIZLILIK_DERECESI_BELIRTILMEDI_VEYA_UYGUN_DEGIL
  'NAVALCRAFT IS NOT SUITABLE TO DISEMBARK TO LOCATION' = -2147483200, // DENIZ_ARACI_KONUMA_INDIRMEYE_UYGUN_DEGIL
  'TARGET MARITIME AGENT IS UNDER THE SEA' = -2147483199, // HEDEF_DENIZ_ETMENI_SU_ALTI_KONUMDA
  'AGENT TO BOARD WAS NOT FOUND' = -2147483198, // CIKILACAK_ETMEN_BULUNAMADI
  'MARITIME BOARDING INVALID SEARCH TIME' = -2147483197, // CIKMA_ARAMA_SURESI_GECERSIZ
  'MARITIME BOARDING INVALID SEARCH ENTITY' = -2147483196, // CIKMA_ARAMA_BIRLIGI_GECERSIZ_UNSUR
  'MARITIME BOARDING TARGET AGENT IS NOT ALLY, ENEMY OR NEUTRAL' = -2147483195, // CIKMA_ARAMA_YAPILACAK_ETMEN_DOST_DUSMAN_YA_DA_TARAFSIZ_DEGIL
  'AIR MISSION CANCELED DUE TO CRITICAL FUEL LEVEL' = -2147483194, // HAVA_GOREVI_YAKIT_KRITIK_SEVIYEDE
  'MARITIME BOARDING TARGET AGENT IS NOT MARITIME AGENT' = -2147483193, // CIKMA_ARAMA_YAPILACAK_ETMEN_DENIZ_ETMENI_DEGIL
  'MARITIME BOARDING COMMAND CANCELED DUE TO TARGET AGENT IS FASTER' = -2147483192, // CIKMA_ARAMA_YAPILACAK_ETMEN_DAHA_HIZLI_OLDUGU_ICIN_EMIR_IPTAL_EDILDI
  'MARITIME BOARDING AGENT DIVIDE FAILED' = -2147483191, // CIKMA_ARAMA_YAPACAK_BIRLIK_BOLUNME_BASARISIZ
  'MARITIME BOARDING BOARD TO TARGET AGENT FAILED' = -2147483190, // CIKMA_ARAMA_YAPILACAK_ETMENE_CIKIS_BASARISIZ
  'TARGET AGENT IS MEMBER OF FORMATION' = -2147483189, // HEDEF_ETMEN_NIZAM_UYESI
  'COMMAND REQUESTED AT SPECIFIC START TIME WILL NOT BE ABLE TO EXECUTE AT REQUESTED TIME' = -2147483188, // BASLANGIC_ZAMANLI_EMIR_ISTENEN_ZAMANDA_EMRI_UYGULAMAYA_BASLAYAMAYACAK
  'TIME PASSED FOR THE COMMAND THAT REQUESTED WITH FINISH TIME' = -2147483187, // TAMAMLANMA_ZAMANLI_EMRIN_TAMAMLANMA_ZAMANI_GECTI
  'MARITIME DOCK MARITIME AGENT TO DOCK WAS NOT FOUND' = -2147483186, // DENIZ_DOCK_BINILECEK_ETMEN_BULUNAMADI
  'AGENT IS NOT AT DOCKED STATUS IN ANY MARITIME AGENT' = -2147483185, // ETMEN_HERHANGI_BIR_DENIZ_ARACINDA_DOCK_DURUMUNDA_DEGIL
  'MARITIME AGENT TO BE DOCKED ON IS NOT SUITABLE FOR DOCKING' = -2147483184, // BINILECEK_DENIZ_ARACI_DOCK_ICIN_UYGUN_DEGIL
  'MARITIME AGENT TO BE DOCKED ON INSUFFICIENT PAYLOAD CAPACITY' = -2147483183, // BINILECEK_DENIZ_ARACI_KATI_YUK_TASIMA_KAPASITESI_YETERSIZ
  'MARITIME AGENT TO BE DOCKED ON INSUFFICIENT POOL CAPACITY' = -2147483182, // BINILECEK_DENIZ_ARACI_HAVUZ_KAPASITESI_YETERSIZ
  'MARITIME AGENT CANNOT BE UNDOCKED OUTSIDE OF PORT' = -2147483181, // LIMAN_DISINDA_DENIZ_ETMENI_INDIRILEMEZ
  'MARITIME AGENT CANNOT BE DOCKED OUTSIDE OF PORT' = -2147483180, // LIMAN_DISINDA_DENIZ_ETMENI_BINDIRILEMEZ
  'MARITIME AGENT TO BE DOCKED ON INSUFFICIENT WIDTH OR LENGTH' = -2147483179, // BINDIRILECEK_DENIZ_ARACI_GENISLIGI_VEYA_UZUNLUGU_YETERSIZ
  'MARITIME AGENT CANNOT REACH TO AGENT TO BE DOCKED ON DUE TO HIGH SPEED' = -2147483178, // DOCK_BINILECEK_DENIZ_ETMENINE_YUKSEK_HIZI_YUZUNDEN_YETISILEMIYOR
  'SUPPLIES AND SYSTEMS WERE NOT FOUND' = -2147483177, // IKMAL_VE_TMK_MADDELERI_BULUNAMADI
  'SUPPLY DELIVERY WAS NOT FOUND OR WRONG' = -2147483176, // IKMAL_TESLIM_SEKLI_BULUNAMADI_VEYA_HATALI
  'MARITIME SUPPLY LAND AGENT CANNOT DELIVER' = -2147483175, // DENIZDE_IKMAL_KARA_ETMENI_IKMAL_TESLIM_EDEMEZ
  'MARITIME SUPPLY LAND AGENT IS NOT AT PORT' = -2147483174, // DENIZDE_IKMAL_IKMAL_VERECEK_KARA_ETMENI_LIMAN_BOLGESINDE_DEGIL
  'ENEMY CONTROLS THE PORT' = -2147483173, // LIMAN_SAHIPLIGI_DUSMAN_TARAFTA
  'MARITIME SUPPLY NO SUITABLE VEHICLE FOR THE CONVOY' = -2147483172, // DENIZDE_IKMAL_KONVOY_ICIN_UYGUN_ARAC_YOK
  'AGENT TO BE SUPPLIED IS FORMATION MEMBER' = -2147483171, // IKMAL_ALINACAK_ETMEN_NIZAM_UYESI
  'SUPPLIER AGENT DOES NOT HAVE REQUESTED SUPPLY' = -2147483170, // IKMAL_VERECEK_ETMENDE_ISTENEN_IKMAL_MEVCUT_DEGIL
  'SUPPLIER AGENT DOES NOT HAVE REQUESTED ENTITY' = -2147483169, // IKMAL_VERECEK_ETMENDE_ISTENEN_UNSUR_MEVCUT_DEGIL
  'SUPPLIER AGENT HAS INSUFFICIENT AMOUNT OF REQUESTED SUPPLY' = -2147483168, // IKMAL_VERECEK_ETMENDE_ISTENEN_IKMAL_ISTENEN_SAYIDA_MEVCUT_DEGIL
  'SUPPLIER AGENT HAS INSUFFICIENT AMOUNT OF REQUESTED ENTITY' = -2147483167, // IKMAL_VERECEK_ETMENDE_ISTENEN_UNSUR_ISTENEN_SAYIDA_MEVCUT_DEGIL
  'AGENT TO BE SUPPLIED TARGET AMOUNT IS BEING EXCEEDED' = -2147483166, // IKMAL_ALACAK_ETMEN_HEDEF_SAYI_ASILIYOR

  'MARITIME SUPPLY AGENT TO BE SUPPLIED IS NOT AT SUPPLY ZONE' = -2147483160, // DENIZDE_IKMAL_IKMAL_AKTARILACAK_ETMEN_IKMAL_BOLGESINDE_DEGIL
  'MARITIME AGENT TARGET AGENT IS SINKING OR INEFFECTIVE' = -2147483159, // CIKMA_ARAMA_YAPILACAK_ETMEN_BATIYOR_YA_DA_ETKISIZ
  'MARITIME DOCK TARGET AGENT IS SINKING OR INEFFECTIVE' = -2147483158, // DENIZ_DOCK_BINILECEK_ETMEN_BATIYOR_YA_DA_ETKISIZ
  'MARITIME SUPPLY AGENT TO BE SUPPLIED IS SINKING OR INEFFECTIVE' = -2147483157, // DENIZDE_IKMAL_ALACAK_ETMEN_BATIYOR_YA_DA_ETKISIZ
  'MARITIME SUPPLY SUPPLIER AGENT IS SINKING OR INEFFECTIVE' = -2147483156, // DENIZDE_IKMAL_VERECEK_ETMEN_BATIYOR_YA_DA_ETKISIZ
  'MARITIME SUPPLY CONVOY AGENT IS SINKING OR INEFFECTIVE' = -2147483155, // DENIZDE_IKMAL_KONVOY_ETMEN_BATIYOR_YA_DA_ETKISIZ
  'AGENT TO BE LIFTED IS NOT AT AIRPORT' = -2147483154, // TASINACAK_ETMEN_HAVAALANI_BOLGESINDE_DEGIL
  'FORMATION MEMBER AND PIVOT CANNOT BE THE SAME AGENT' = -2147483153, // NIZAM_OGESI_VE_PIVOT_AYNI_ETMEN_OLAMAZ
  'INVALID SHORT NAME' = -2147483152, // KISA_ISIM_HATALI
  'INVALID LONG NAME' = -2147483151, // UZUN_ISIM_HATALI
  'LAY MINE AREA WAS NOT FOUND' = -2147483150, // MAYIN_DOSE_MAYIN_BOLGESI_BULUNAMADI
  'LAY MINE INGRESS ROUTE WAS NOT FOUND' = -2147483149, // MAYIN_DOSE_GIDIS_ROTASI_BULUNAMADI
  'LAY MINE EGRESS ROUTE WAS NOT FOUND' = -2147483148, // MAYIN_DOSE_DONUS_ROTASI_BULUNAMADI
  'LAY MINE AMOUNT OF MINES WAS NOT FOUND' = -2147483147, // MAYIN_DOSE_DOSENECEK_MAYIN_SAYISI_BULUNAMADI
  'LAY MINE MINE TYPE WAS NOT FOUND' = -2147483146, // MAYIN_DOSE_DOSENECEK_MAYIN_BILGISI_BULUNAMADI
  'LAY MINE AMOUNT OF TEAM WAS NOT FOUND' = -2147483145, // MAYIN_DOSE_TIM_SAYISI_BULUNAMADI
  'NO MAGIC SUPPLY WAS FOUND AT THE SIMULATION' = -2147483144, // VERITABANINDA_KAYITLI_MAGIC_IKMAL_YOK
  'FAILED TO UPDATE COMMAND QUEUE' = -2147483143, // EMIR_KUYRUGU_GUNCELLENEMEDI
  'SWEEP MINE INGRESS ROUTE WAS NOT FOUND' = -2147483142, // MAYIN_TEMIZLE_GIDIS_ROTASI_BULUNAMADI
  'SWEEP MINE WRONG OR MISSING ZONE INFORMATION' = -2147483141, // MAYIN_TEMIZLE_HATALI_VEYA_EKSIK_BOLGE_BILGISI
  'SWEEP MINE WRONG OR MISSING MINE INFORMATION' = -2147483140, // MAYIN_TEMIZLE_HATALI_VEYA_EKSIK_ENGEL_BILGISI
  'SWEEP MINE HIGH CHANCE FOR AGENT TO DETONATE THE MINE' = -2147483139, // MAYIN_TEMIZLE_ETMENIN_MAYIN_PATLATMA_OLASILIGI_YUKSEK
  'SWEEP MINE MARITIME AGENT CANNOT SWEEP MINES' = -2147483138, // MAYIN_TEMIZLE_DENIZ_ARACI_KULLANIM_ALANI_MAYIN_HARBI_DEGIL
  'SWEEP MINE OBSTACLE AGENT WAS NOT IDENTIFIED' = -2147483137, // MAYIN_TEMIZLE_HEDEF_ENGEL_ETMEN_TANINMIYOR
  'SWEEP MINE MINE DETONED DURING PROCESS' = -2147483136, // MAYIN_TEMIZLE_MAYIN_TEMIZLERKEN_PATLADI
  'MARITIME AGENT STOPPED DUE TO CASUALTY RATE' = -2147483135, // DENIZ_ETMENI_ZAYIAT_ORANI_SEBEBI_ILE_DURDU
  'FORMATION MEMBER MARITIME AGENT IS DAMAGED' = -2147483134, // NIZAM_UYESI_DENIZ_ETMENI_HASARLI
  'SUPPLYING MARITIME AGENT IS DAMAGED' = -2147483133, // IKMAL_TESLIM_EDECEK_DENIZ_ETMENI_HASARLI
  'MARITIME AGENT TO BE DOCKED ON IS DAMAGED' = -2147483132, // DOCK_BINILECEK_DENIZ_ETMENI_HASARLI
  'MARITIME AGENT AGENT TO BE UNDOCKED IS DAMAGED' = -2147483131, // DENIZ_TASIMA_INDIRME_EMRINDE_INDIRILECEK_DENIZ_ETMENI_HASARLI
  'AIRCRAFT LANDING TYPE WAS NOT IDENTIFIED' = -2147483130, // HAVA_INIS_YONTEMI_ANLASILMADI
  'ALTITUDE ZONES ARE NOT ORDERED' = -2147483129, // IRTIFA_BOLGELERI_SIRALI_DEGIL
  'DEPTH ZONES ARE NOT ORDERED' = -2147483128, // DERINLIK_BOLGELERI_SIRALI_DEGIL
  'DISTANCE ZONES ARE NOT ORDERED' = -2147483127, // MESAFE_BOLGELERI_SIRALI_DEGIL
  'MARITIME BOARDING AGENT TO BOARD SYSTEM OR SUPPLY INFORMATION WAS NOT FOUND' = -2147483126, // CIKMA_ARAMA_YAPACAK_BIRLIK_SISTEM_VEYA_IKMAL_BILGISI_BULUNAMADI
  'AGENT IS CONTROLLED BY ANOTHER PLUGIN' = -2147483125, // ETMEN_BASKA_EKLENTI_TARAFINDAN_YONETILIYOR
  'AIRCRAFT LANDING TO LOCATION IS NOT SUITABLE' = -2147483124, // HAVA_KONUMA_INIS_UYGUN_DEGIL
  'AIRCRAFT LANDING TO AGENT IS NOT SUITABLE' = -2147483123, // HAVA_ETMENE_INIS_UYGUN_DEGIL
  'AIRCRAFT LANDING TO AIRPORT IS NOT SUITABLE' = -2147483122, // HAVA_HAVAALANINA_INIS_UYGUN_DEGIL
  'AIRCRAFT CANNOT TAKE OFF VERTICALLY' = -2147483121, // HAVA_ARACI_DIKINE_KALKIS_YAPAMAZ
  'AIRCRAFT CANNOT TAKE OFF' = -2147483120, // HAVA_ARACI_KALKIS_YAPAMAZ
  'MARITIME TOW TARGET POINT IS UNDER THE SEA' = -2147483119, // DENIZ_CEKME_EMRI_HEDEF_NOKTASI_SU_ALTINDA
  'MARITIME TOW AGENT TO BE TOWED WAS NOT FOUND' = -2147483118, // DENIZ_CEKME_CEKILECEK_ETMEN_ID_HATALI_VEYA_BULUNAMADI
  'MARITIME TOW ROUTE POINTS WAS NOT FOUND' = -2147483117, // DENIZ_CEKME_KULLANICININ_SAGLADIGI_ROTA_HEDEF_NOKTALARI_BULUNAMADI
  'MARITIME TOW MARITIME AGENT CANNOT TOW' = -2147483116, // DENIZ_CEKME_DENIZ_ARACI_CEKMEYE_UYGUN_DEGIL
  'MARITIME TOW AGENT TO BE TOWED IS NOT MARITIME AGENT' = -2147483115, // DENIZ_CEKME_CEKILECEK_ETMEN_TIPI_DENIZ_DEGIL
  'MARITIME TOW AGENT TO BE TOWED IS NOT AT SEA LEVEL' = -2147483114, // DENIZ_CEKME_CEKILECEK_ETMEN_SATIHTA_DEGIL
  'MARITIME TOW AGENT TO BE TOWED IS SINKING OR DOCKED' = -2147483113, // DENIZ_CEKME_CEKILECEK_ETMEN_ETKISIZ_BATIYOR_VEYA_TASINIYOR
  'MARITIME TOW INSUFFICIENT TOWING CAPACITY' = -2147483112, // DENIZ_CEKME_CEKME_KAPASITESI_YETERLI_DEGIL
  'MARITIME TOW AGENT RELATIONS ARE NOT SUITABLE FOR TOWING' = -2147483111, // ETMENLERIN_TARAF_ILISKILERI_CEKME_ICIN_UYGUN_DEGIL
  'MARITIME TOW PORT TO TOW IS NOT UNDER FRIENDLY CONTROL' = -2147483110, // CEKILECEK_LIMAN_SAHIP_TARAF_DOST_MUTTEFIK_VEYA_KENDISI_DEGIL
  'MARITIME TOW AGENT TO BE TOWED IS NOT AT LOCATION' = -2147483109, // CEKILECEK_ETMEN_KONUMUNDA_DEGIL
  "MARITIME TOW COULDN'T ADD AGENT TO BE TOWED TO MANIFEST" = -2147483108, // CEKILECEK_ETMEN_MANIFESTOYA_EKLENEMEDI
  'COULD NOT FIND ROUTE FOR SUPPLY CONVOY' = -2147483107, // IKMAL_KONVOY_ICIN_ROTA_BULUNAMADI
  'BUILD INFRASTRUCTURE INTERRUPTED' = -2147483106, // ALTYAPI_INSASI_YARIDA_KESILDI
  'COULD NOT CREATE NODE' = -2147483105, // DUGUM_YARATMA_SIRASINDA_BIR_HATA_MEYDANA_GELDI
  'AGENT TO BE CARRIED IS NOT EMBARKATION LOCATION' = -2147483104, // TASINACAK_ETMEN_BINDIRME_KONUMUNDA_DEGIL
  'COMMAND EXCEEDED EXECUTION' = -2147483103, // EMIR_ICRA_ZAMANI_GECMIS
  'FUEL LEAKING MAGIC FUEL LEAKING INFO WAS NOT FOUND' = -2147483102, // YAKIT_SIZDIR_MAGIC_SIZDIRMA_BILGISI_BULUNAMADI
  'FUEL LEAKING SUPPLY TO LEAK INFO WAS NOT FOUND OR WRONG' = -2147483101, // YAKIT_SIZDIR_SIZDIRILACAK_IKMAL_BILGISI_HATALI_VEYA_BULUNAMADI
  'FUEL LEAKING AGENT TO LEAK INFO WAS NOT FOUND OR WRONG' = -2147483100, // YAKIT_SIZDIR_SIZDIRACAK_ETMEN_BILGISI_HATALI_VEYA_BULUNAMADI
  'FUEL LEAKING SUPPLY AMOUNT TO LEAK WAS NOT FOUND OR WRONG' = -2147483099, // YAKIT_SIZDIR_SIZDIRILACAK_IKMAL_MIKTARI_HATALI_VEYA_BULUNAMADI
  'PORT IS OUT OF THEATRE' = -2147483098, // LIMAN_ARAZI_DISINDA
  'TARGET AGENT HAS NO NAVALCRAFT' = -2147483097, // HEDEF_ETMENDE_DENIZ_ARACI_MEVCUT_DEGIL
  'SELECTED AMMUNITION IS NOT EFFECTIVE AGAINST LAND TARGETS' = -2147483096, // SECILEN_MUHIMMAT_KARA_HEDEFLERINE_ETKILI_DEGIL
  'SELECTED AMMUNITION IS NOT EFFECTIVE AGAINST AIR TARGETS' = -2147483095, // SECILEN_MUHIMMAT_HAVA_HEDEFLERINE_ETKILI_DEGIL
  'SELECTED AMMUNITION IS NOT EFFECTIVE AGAINST SEA SURFACE TARGETS' = -2147483094, // SECILEN_MUHIMMAT_SUUSTU_HEDEFLERINE_ETKILI_DEGIL
  'SELECTED AMMUNITION IS NOT EFFECTIVE AGAINST SUBSURFACE TARGETS' = -2147483093, // SECILEN_MUHIMMAT_SUALTI_HEDEFLERINE_ETKILI_DEGIL
  'AIR AGENT CANNOT RECEIVE SUB MISSIONS' = -2147483092, // HAVA_ETMENI_ALT_GOREV_KABUL_EDEMEZ
  "SUPPLYING AGENT DOESN'T HAVE ENOUGH SUPPLIES FOR THE REQUEST FUEL TO LEAK IS NOT SUFFICIENT ON AGENT" = -2147483091, // SIZDIRILACAK_YAKIT_ETMENDE_YETERLI_MIKTARDA_MEVCUT_DEGIL
  "FUEL LEAKING AGENT DOESN'T HAVE ENOUGH SUPPLIES TO LEAK" = -2147483091, // SIZDIRILACAK_YAKIT_ETMENDE_YETERLI_MIKTARDA_MEVCUT_DEGIL
  'FUEL LEAKING FAILED COULD NOT CAUSE CONTAMINATION' = -2147483090, // YAKIT_SIZDIR_BASARISIZ_KIRLILIK_OLUSTURULAMADI
  'CONSUMPTION RATE FOR FUEL TO LEAK IS NOT TIME BASED' = -2147483089, // SIZDIRILACAK_YAKITIN_ZAMAN_BIRIMI_GUN_SAAT_VEYA_DAKIKA_DEGIL
  'AGENT TO BE SUPPLIED WAS NOT FOUND' = -2147483088, // IKMAL_ALACAK_ETMEN_BULUNAMADI
  'SUPPLIER AGENT WAS NOT FOUND' = -2147483087, // IKMAL_VERECEK_ETMEN_BULUNAMADI
  'AIR SUB MISSION EXECUTION TYPE IS WRONG' = -2147483086, // HAVA_ALT_GOREV_UYGULAMA_SEKLI_HATALI
  'BUILD INFRASTRUCTURE ENGINEERING EQUPMENT WAS NOT FOUND' = -2147483085, // ALTYAPI_INSA_EMRI_ISTIHKAM_TECHIZATI_BULUNAMADI
  'BUILD INFRASTRUCTURE INVALID EQUIPMENT QUANTITY' = -2147483084, // ALTYAPI_INSA_EMRI_GECERSIZ_TECHIZAT_SAYISI
  'BUILD INFRASTRUCTURE INVALID WIDTH' = -2147483083, // ALTYAPI_INSA_EMRI_GECERSIZ_GENISLIK
  'BUILD INFRASTRUCTURE INVALID LANE QUANTITY' = -2147483082, // ALTYAPI_INSA_EMRI_GECERSIZ_SERIT_SAYISI
  'BUILD INFRASTRUCTURE INVALID ROUTE' = -2147483081, // ALTYAPI_INSA_EMRI_GECERSIZ_ROTA
  'BUILD INFRASTRUCTURE INVALID MATERIAL' = -2147483080, // ALTYAPI_INSA_EMRI_GECERSIZ_MALZEME
  'BUILD INFRASTRUCTURE INVALID CONSTRUCTION TIME' = -2147483079, // ALTYAPI_INSA_EMRI_GECERSIZ_INSA_SURESI
  'BUILD INFRASTRUCTURE INVALID MOVE SPEED' = -2147483078, // ALTYAPI_INSA_EMRI_GECERSIZ_INTIKAL_HIZI
  "BUILD INFRASTRUCTURE AGENT DOESN'T HAVE REQURIED SYSTEM OR SUPPLY" = -2147483077, // ALTYAPI_INSA_EMRI_ETMEN_GEREKLI_TMK_VEYA_IKMALE_SAHIP_DEGIL
  'POW AGENT WAS NOT FOUND' = -2147483076, // ESIR_ETMEN_BULUNAMADI
  'AGENT TO RECEIVE POW WAS NOT FOUND' = -2147483075, // TESLIM_ALACAK_ETMEN_BULUNAMADI
  'FAILED TO READ AGENT PROTOTYPE DATA' = -2147483074, // VT_ETMEN_TURU_OKUMA_HATASI
  'MARITIME DOCK EMBARKING AGENT AND AGENT TO EMBARK CANNOT BE THE SAME' = -2147483073, // DOCK_BINILECEK_VE_BINECEK_ETMEN_AYNI_OLAMAZ
  'LIFERAFT NAVALCRAFTS WAS NOT SPECIFIED' = -2147483072, // LIFERAFT_DENIZ_ARACLARI_SABITLERDE_BELIRLENMEDI
  'AGENT CANNOT RECEIVE OTHER AGENTS' = -2147483071, // ETMEN_TESLIM_ALMA_YETERLILIGINE_SAHIP_DEGIL
  'SUPPLIER AGENT AND AGENT TO BE SUPPLIED CANNOT BE THE SAME' = -2147483070, // IKMAL_ALACAK_VE_VERECEK_ETMEN_AYNI_OLAMAZ
  'UNSUFFICIENT CARRYING CAPACITY FOR CONVOY AGENT' = -2147483069, // KONVOY_ETMENIN_TASIMA_KAPASITESI_YETERSIZ
  'BUILDING LOCATION IS OUT OF THEATER' = -2147483068, // INSA_KONUMU_ARAZI_DISINDA
  'RUNWAY BUILDING LOCATION IS OUT OF THEATER' = -2147483067, // PIST_INSA_KONUMU_HAVAALANI_DISINDA
  'NAVIGATION ROUTE IS OUT OF THEATER' = -2147483066, // SEYIR_ROTASI_ARAZI_DISINDA
  'NUMBER OF MINES TO LAY IS INVALID' = -2147483065, // MAYIN_DOSE_DOSENECEK_MAYIN_SAYISI_GECERSIZ
  'SEARCH INFO WAS NOT FOUND' = -2147483064, // ARAMA_BILGISI_BULUNAMADI
  'HIJACK INFO WAS NOT FOUND' = -2147483063, // KACIRMA_BILGISI_BULUNAMADI
  'RESCUE INFO WAS NOT FOUND' = -2147483062, // KURTARMA_BILGISI_BULUNAMADI
  'AGENT TO RESCUE IS ENEMY OR SUSPICIOUS' = -2147483061, // KURTARILACAK_ETMEN_DUSMAN_VEYA_SUPHELI
  'AGENT TO RESCUE IS ON OWN SIDE' = -2147483060, // ARANACAK_ETMEN_KENDI_TARAFINDA
  'COMMAND TO EXECUTE AFTER BOARDING WAS NOT SPECIFIED' = -2147483059, // CIKMA_SONRASI_GERCEKLESTIRILECEK_KOMUT_SECILMEDI
  'AGENT IDENTIFICATION DISTANCE IS NOT SUFFICIENT TO EXECUTE THE MISSION' = -2147483058, // ETMEN_TESHIS_MESAFESI_GOREVI_ICRA_ETMEK_ICIN_YETERSIZ
  'MARITIME TOW PORT INFO IS NOT VALID' = -2147483057, // CEKILECEK_LIMAN_BILGISI_HATALI_VEYA_BULUNAMADI
  'MARITIME TOW LOCATION INFO IS NOT VALID' = -2147483056, // CEKILECEK_KONUM_BILGISI_HATALI_VEYA_BULUNAMADI
  'MARITIME TOW TARGET LOCATION IS OUT OF THEATER' = -2147483055, // CEKILECEK_KONUM_ARAZI_DISINDA
  'DATABASE LOADING DEPTH/HEIGHT INFO FOR QUAD IS MISSING' = -2147483054, // VT_YUKLE_QUAD_ICINDE_GELEN_YUKSEKLIK_VERISI_BULUNAMADI
  'DATABASE LOADING TERRAIN TYPE INFO FOR QUAD IS MISSING' = -2147483053, // VT_YUKLE_QUAD_ICINDE_GELEN_ARAZI_VERISI_BULUNAMADI
  'CANNOT USE FIELD EFFECTIVE AMMUNITION' = -2147483052, // ALAN_ETKILI_MUHIMMAT_KULLANILAMAZ
  'THERE IS NO HUMAN ON BOARDING AGENT' = -2147483051, // CIKMA_YAPACAK_BIRLIKTE_INSAN_MEVCUT_DEGIL
  'THERE IS NO WEAPON CARRIABLE BY ANY HUMAN ON BOARDING AGENT' = -2147483050, // CIKMA_YAPACAK_BIRLIKTE_INSANIN_TASIYABILECEGI_SILAH_MEVCUT_DEGIL
  'SHORT NAME SHOULD BE UNIQUE ON AGENT PROTOTYPES' = -2147483049, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_ETMEN_TURU_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON FACTIONS' = -2147483048, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_ETMEN_SINIFI_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON AGENTS' = -2147483047, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_ETMEN_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON NAVALCRAFTS' = -2147483046, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_DENIZ_ARACI_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON AIRCRAFTS' = -2147483045, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_HAVA_ARACI_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON PAYLOADS' = -2147483044, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_FAYDALI_YUK_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON SUPPLIES' = -2147483043, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_IKMAL_SINIFI_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON OBSTACLES' = -2147483042, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_INSAN_YAPIMI_ENGEL_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON COMMUNICATION DEVICES' = -2147483041, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_MUHABERE_CIHAZI_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON REQUIRED SUPPLIES' = -2147483040, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_GEREKLI_IKMAL_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON REQUIRED SYSTEMS' = -2147483039, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_GEREKLI_TMK_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON AMMUNITIONS' = -2147483038, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_MUHIMMAT_TURU_OLAMAZ
  'SHORT NAME SHOULD BE UNIQUE ON SYSTEMS' = -2147483037, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_TMK_OLAMAZ
  'BOARDING HIJACKING FAILED' = -2147483036, // CIKMA_ELE_GECIRME_BASARISIZ
  'BOARDING RESCUE FAILED' = -2147483035, // CIKMA_KURTARMA_BASARISIZ
  'VOLUME INFO IS MISSING' = -2147483034, // HACIM_BILGISI_BULUNAMADI_VEYA_EKSIK
  'VOLUME INFO IS NOT VALID' = -2147483033, // HACIM_BILGISI_HATALI
  'SYMBOL INFO IS MISSING OR INVALID' = -2147483032, // SEMBOL_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE CATEGORY INFO IS MISSING OR INVALID' = -2147483031, // ETMEN_TURU_KATEGORI_BILGISI_HATALI_VEYA_BULUNAMADI
  'AGENT PROTOTYPE SIZE INFO IS MISSING OR INVALID' = -2147483030, // ETMEN_TURU_BUYUKLUK_BILGISI_HATALI_VEYA_BULUNAMADI
  'PLUGIN ID IS MISSING OR INVALID' = -2147483029, // EKLENTI_ID_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTPYE SYSTEMS INFO IS MISSING OR INVALID' = -2147483028, // ETMEN_TURU_TMK_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE SUPPLIES INFO IS MISSING OR INVALID' = -2147483027, // ETMEN_TURU_IKMAL_BILGISI_BULUNAMADI_VEYA_HATALI
  'SUPPLIES AUTO RESUPPLY LEVEL EXCEEDS TARGET AMOUNT LEVEL' = -2147483026, // IKMAL_HEDEF_SEVIYE_OTOMATIK_IKMAL_SEVIYESINI_ASIYOR
  'AGENT PROTOTYPE AMMUNITIONS INFO IS MISSING OR INVALID' = -2147483025, // ETMEN_TURU_MUHABERE_CIHAZLARI_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE OBSTACLES INFO IS MISSING OR INVALID' = -2147483024, // ETMEN_TURU_ENGELLER_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE AIRCRAFTS INFO IS MISSING OR INVALID' = -2147483023, // ETMEN_TURU_HAVA_ARACLARI_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE NAVALCRAFTS INFO IS MISSING OR INVALID' = -2147483022, // ETMEN_TURU_DENIZ_ARACLARI_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE SPACECRAFTS INFO IS MISSING OR INVALID' = -2147483021, // ETMEN_TURU_UZAY_ARACLARI_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE MINE WARFARE EFFECTIVENESS INFO IS MISSING OR INVALID' = -2147483020, // ETMEN_TURU_ENGEL_HARBI_ETKINLIGI_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE MOVE PREPARATION INFO IS MISSING OR INVALID' = -2147483019, // ETMEN_TURU_INTIKAL_HAZIRLIK_SURELERI_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE MOVE ENDING INFO IS MISSING OR INVALID' = -2147483018, // ETMEN_TURU_INTIKAL_BITIRME_SURELERI_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE MOVEMENT EFFECTS INFO IS MISSING OR INVALID' = -2147483017, // ETMEN_TURU_INTIKAL_ETKINLIK_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE EFFECTIVENESS INFO IS MISSING OR INVALID' = -2147483016, // ETMEN_TURU_EGITIM_MORAL_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE BUILDING CLEARING ACTIVITY INFO IS MISSING OR INVALID' = -2147483015, // ETMEN_TURU_BINA_TEMIZLEME_BILGISI_BULUNAMADI_VEYA_HATALI
  'AGENT PROTOTYPE CREATION FAILED' = -2147483014, // ETMEN_TURU_OLUSTURMA_BASARISIZ
  'SELECTED FACTION IS MISSING OR INVALID' = -2147483013, // ETMEN_SINIFI_VT_ID_BULUNAMADI_VEYA_HATALI
  'NEW AGENT LOCATION INFO IS MISSING OR INVALID' = -2147483012, // YENI_ETMEN_KONUM_BILGISI_BULUNAMADI_VEYA_HATALI
  'NEW AGENT LOCATION IS OUT OF THEATER' = -2147483011, // YENI_ETMEN_KONUMU_ARAZI_DISINDA
  'NEW AGENT CASUALTY INFO IS MISSING OR INVALID' = -2147483010, // YENI_ETMEN_ZAYIAT_ORANI_BULUNAMADI_VEYA_HATALI
  'NEW AGENT POSTURE INFO IS MISSING OR INVALID' = -2147483009, // YENI_ETMEN_FAALIYET_BILGISI_BULUNAMADI_VEYA_HATALI
  'NEW AGENT BEARING INFO IS MISSING OR INVALID' = -2147483008, // YENI_ETMEN_ISTIKAMET_BILGISI_BULUNAMADI_VEYA_HATALI
  'NEW AGENT MAGIC SUPPLY INFO IS MISSING OR INVALID' = -2147483007, // YENI_ETMEN_MAGIC_IKMAL_BILGISI_BULUNAMADI_VEYA_HATALI
  'NEW AGENT AGENT PROTOTYPE INFO IS MISSING OR INVALID' = -2147483006, // YENI_ETMEN_ETMEN_TURU_ID_BILGISI_BULUNAMADI_VEYA_HATALI
  'NEW AGENT DISEMBARKED ATTACK SPEED INFO IS MISSING OR INVALID' = -2147483005, // YENI_ETMEN_YAYA_TAARRUZ_HIZI_BILGISI_BULUNAMADI_VEYA_HATALI
  'NEW AGENT EMBARKED ATTACK SPEED INFO IS MISSING OR INVALID' = -2147483004, // YENI_ETMEN_BINDIRILMIS_TAARRUZ_HIZI_BILGISI_BULUNAMADI_VEYA_HATALI
  'NEW AGENT HIGHER HQ INFO IS MISSING OR INVALID' = -2147483003, // YENI_ETMEN_BAGLI_OLDUGU_ETMEN_BILGISI_BULUNAMADI_VEYA_HATALI
  'NEW AGENT SUPPLYING HQ INFO IS MISSING OR INVALID' = -2147483002, // YENI_ETMEN_IKMALDEN_SORUMLU_ETMEN_BILGISI_BULUNAMADI_VEYA_HATALI
  'NEW AGENT TIME TO JOIN INFO IS MISSING OR INVALID' = -2147483001, // YENI_ETMEN_SIMULASYONA_KATILACAGI_ZAMAN_BULUNAMADI_VEYA_HATALI
  'NEW AGENT CREATION FAILED' = -2147483000, // YENI_ETMEN_OLUSTURULAMADI
  'NEW LAND AGENT CANNOT BE ON WATER' = -2147482999, // YENI_KARA_ETMENI_DENIZDE_BULUNAMAZ
  'NEW MARITIME AGENT CANNOT BE ON LAND' = -2147482998, // YENI_DENIZ_ETMENI_KARADA_BULUNAMAZ
  'AGENT IS MISSING OR INVALID' = -2147482997, // ETMEN_ID_BULUNAMADI_VEYA_HATALI
  'AGENT TIME TO JOIN INFO IS MISSING OR INVALID' = -2147482996, // ETMENIN_SIMULASYONA_KATILACAGI_ZAMAN_BILGISI_BULUNAMADI_VEYA_HATALI
  'SELECTED WEAPON CANNOT ENGAGE' = -2147482995, // SECILEN_SILAH_ANGAJMANA_GIREMEZ
  'SELECTED WEAPON CANNOT ENGAGE BY COMMAND' = -2147482994, // SECILEN_SILAH_EMIRLE_ANGAJMANA_GIREMEZ
  'BUILD INFRASTRUCTURE SELECTED SYSTEM CANNOT BUILD INFRASTRUCTURE' = -2147482993, // BUILD INFRASTRUCTURE SELECTED SYSTEM_ALTYAPI_INSASINA_UYGUN_DEGIL
  'BUILD INFRASTRUCTURE SELECTED SYSTEM CANNOT BUILD ROAD' = -2147482992, // BUILD INFRASTRUCTURE SELECTED SYSTEM_YOL_INSASINA_UYGUN_DEGIL
  'BUILD INFRASTRUCTURE SELECTED SYSTEM CANNOT BUILD BRIDGE' = -2147482991, // BUILD INFRASTRUCTURE SELECTED SYSTEM_KOPRU_INSASINA_UYGUN_DEGIL
  'BUILD INFRASTRUCTURE SELECTED SYSTEM CANNOT BUILD TUNNEL' = -2147482990, // BUILD INFRASTRUCTURE SELECTED SYSTEM_TUNEL_INSASINA_UYGUN_DEGIL
  'BUILD INFRASTRUCTURE SELECTED SYSTEM CANNOT BUILD RUNWAY' = -2147482989, // BUILD INFRASTRUCTURE SELECTED SYSTEM_PIST_INSASINA_UYGUN_DEGIL
  'BUILD INFRASTRUCTURE SELECTED SYSTEM CANNOT BUILD BUNKER' = -2147482988, // BUILD INFRASTRUCTURE SELECTED SYSTEM_KORUGAN_INSASINA_UYGUN_DEGIL
  'MOVEMENT ALTITUDE IS NOT SUITABLE FOR AGENT' = -2147482987, // INTIKAL_YUKSEKLIGI_ETMEN_ICIN_UYGUN_DEGIL
  'MINE FIELD INVALID HEIGHT' = -2147482986, // MAYIN_BOLGESI_GECERSIZ_YUKSEKLIK
  'MINE INVALID HEIGHT' = -2147482985, // MAYIN_YUKSEKLIGI_GECERSIZ
  'AIR MISSION CANNOT EXECUTE INTERCEPT' = -2147482984, // HAVA_GOREVI_ONLEME_ICRA_EDEMEZ
  'CANNOT ENGAGE WITH AGENT WHO IS NOT AN ENEMY' = -2147482983, // DUSMAN_OLMAYAN_ETMENLE_ANGJAMANA_GIRILEMEZ
  'TARGET AGENT CANNOT BE THE AGENT ITSELF' = -2147482982, // HEDEF_ETMEN_ETMENIN_KENDISI_OLAMAZ
  'CANNOT CARRY ENEMY AGENT' = -2147482981, // DUSMAN_ETMEN_TASINAMAZ
  'CANNOT DISEMBARK TO ENEMY AGENT' = -2147482980, // DUSMAN_ETMENE_INDIRME_YAPILAMAZ
  'FAILED TO SAVE CHECKPOINT' = -2147482979, // SIMULASYON_CHECKPOINT_ALMA_BASARISIZ
  'FAILED TO LOAD CHECKPOINT' = -2147482978, // SIMULASYON_CHECKPOINT_YUKLEME_BASARISIZ
  'CHECKPOINT ID IS MISSING' = -2147482977, // CHECKPOINT_ID_BULUNAMADI
  'AGENT IS NOT MEMBER OF FORMATION OR PIVOT' = -2147482976, // ETMEN_NIZAM_UYESI_VE_PIVOT_DEGIL
  'AIRCRAFT INSUFFICIENT SOLID PAYLOAD CAPACITY' = -2147482975, // HAVA_ARACI_KATI_TASIMA_KAPASITESI_YETERSIZ
  'AIRCRAFT INSUFFICIENT LIQUID PAYLOAD CAPACITY' = -2147482974, // HAVA_ARACI_SIVI_TASIMA_KAPASITESI_YETERSIZ
  'AIRCRAFT INSUFFICIENT HUMAN PAYLOAD CAPACITY' = -2147482973, // HAVA_ARACI_INSAN_TASIMA_KAPASITESI_YETERSIZ
  'INVALID DEFENCE AREA INFORMATION' = -2147482972, // SAVUNMA_BOLGESI_HATALI
  'INVALID DEFENCE DIRECTION' = -2147482971, // SAVUNMA_ISTIKAMETI_HATALI
  'INVALID WITHDRAW DIRECTION' = -2147482970, // GERI_CEKILME_ISTIKAMETI_HATALI
  'AIRCRAFT CANNOT EXECUTE SEARCH AND RESCUE ' = -2147482969, // HAVA_ARACI_ARAMA_KURTARMA_YAPMAYA_ELVERISLI_DEGIL
  'CANNOT FIRE TO LOCATION WITH POINT EFFECTIVE AMMUNITION' = -2147482968, // NOKTA_ETKILI_MUHIMMATLA_KONUMA_ATIS_YAPILAMAZ
  'AIR SUB-MISSION MISSION AREA IS NOT POLYGON' = -2147482967, // HAVA_ALT_GOREV_GOREV_ROTASI_POLIGON_DEGIL
  'COMMAND CANNOT BE CANCELED' = -2147482966, // EMIR_IPTAL_EDILEMEZ
  'COMMAND AND CLIENT VALIDATION FAILED' = -2147482965, // EMIR_VE_ISTEMCI_UYGUNLUK_KONTROLU_BASARISIZ
  'COMMAND REJECTED USER ROLE CANNOT GIVE ORDER' = -2147482964, // EMIR_RET_ISTEMCI_ROLU_EMIR_VERMEYE_UYGUN_DEGIL
  'COMMAND REJECTED NO AGENT WAS ASSIGNED TO PLAYER ROLE' = -2147482963, // EMIR_RET_PLAYER_ROLUNDEKI_ISTEMCIYE_ETMEN_ATANMAMIS
  'COMMAND REJECTED CANNOT GIVE ORDER TO A HIGHER AGENT' = -2147482962, // EMIR_RET_PLAYER_UST_ETMENINE_EMIR_VEREMEZ
  'COMMAND REJECTED CANNOT ASSING AGENT TO THIS USER ROLE' = -2147482961, // EMIR_RET_BU_ROLDEKI_ISTEMCIYE_ETMEN_ATANAMAZ
  'REQUIRED SUPPLY IS MISSING' = -2147482960, // GEREKLI_IKMAL_MEVCUT_DEGIL
  'REQUIRED SYSTEM IS MISSING' = -2147482959, // GEREKLI_TMK_MEVCUT_DEGIL,
  'AGENT CANNOT BE HIGHER AGENT TO ITSELF' = -2147482958, // ETMENIN_UST_ISLETEN_ETMENI_KENDISI_OLAMAZ
  'DESIRED SPEED WAS NOT FOUND ON CHANGE MOVE SPEED COMMAND' = -2147482957, // INTIKAL_HIZI_DEGISTIR_EMRINDE_ISTENEN_HIZ_BULUNAMADI
  'AGENT HAS NO MOVE COMMAND' = -2147482956, // ETMENIN_INTIKAL_EMRI_BULUNMUYOR
  'HANDOVER POW INFO IS MISSING' = -2147482955, // TESLIM_EDILECEK_ESIR_BILGISI_BULUNAMADI
  'HANDOVER RECEIVING AGENT INFO IS MISSING' = -2147482954, // TESLIM_ALACAK_ETMEN_BILGISI_BULUNAMADI
  'HANDOVER POW INFO IS INVALID' = -2147482953, // TESLIM_EDILECEK_ESIR_BILGISI_HATALI
  'HANDOVER RECEIVING AGENT INFO IS INVALID' = -2147482952, // TESLIM_ALACAK_ETMEN_BILGISI_HATALI
  'AGENT TO HANDOVER IS NOT POW' = -2147482951, // TESLIM_EDILECEK_ETMEN_HARP_ESIRI_DEGIL
  'AGENT TO HANDOVER IS NOT IN MANIFEST' = -2147482950, // TESLIM_EDILECEK_ETMEN_MANIFESTODA_DEGIL
  'HANDOVER RECEIVING AGENT IS HOSTILE' = -2147482949, // ESIR_TESLIM_EDILECEK_ETMEN_DUSMAN_VEYA_SUPHELI
  'HANDOVER RECEIVING AGENT WAS NOT FOUND' = -2147482948, // TESLIM_ALACAK_ETMEN_MEVCUT_DEGIL
  'AGENT TRANSFER NAVALCRAFT WAS NOT FOUND' = -2147482947, // ETMEN_TRANSFER_EDILECEK_DENIZ_ARACI_BULUNAMADI
  'SUPPLIER AGENT IS MEMBER OF FORMATION' = -2147482946, // IKMAL_VERECEK_ETMEN_NIZAM_UYESI
  'AGENT TO RECEIVE CANCEL COMMAND WAS NOT FOUND' = -2147482945, // EMIR_IPTAL_EMRINI_ALAN_ETMEN_BULUNAMADI
  'AGENT TO RECEIVE MAGIC FILL UP COMMAND WAS NOT FOUND' = -2147482944, // ETMEN_TAMAMLA_EMRINI_ALAN_ETMEN_BULUNAMADI
  'AGENT TO RECEIVE MAGIC FILL UP COMMAND IS INVALID' = -2147482943, // ETMEN_TAMAMLA_EMRINI_ALAN_ETMEN_UYGUN_DEGIL
  'CANNOT GIVE COMMAND TO VICTIM OR SINKING AGENT' = -2147482942, // EMIR_KAZAZEDE_YADA_BATAN_ETMENE_VERILEMEZ
  'BACKEND IS NOT READY' = -2147482941, // ARKAYUZ_HAZIR_DEGIL
  'RECEIVED UNKNOWN COMMAND TYPE' = -2147482940, // BILINMEYEN_EMIR_TURU_ALINDI
  'FAILED TO READ COMMAND DETAILS' = -2147482939, // EMIR_ICERIGI_OKUMA_HATASI
  'AGENT TO JOIN IS WRONG' = -2147482938, // KATILACAGI_ETMEN_HATALI
  'COMAO TIME TYPE WAS NOT RECOGNIZED' = -2147482937, // COMAO_ZAMAN_TIPI_ANLASILMADI
  'AGENT TO EXECUTE COMMAND WAS NOT FOUND' = -2147482936, // ICRA_EDECEK_ETMEN_MEVCUT_DEGIL
  'TAKEOFF TIME TYPE IS WRONG' = -2147482935, // KALKIS_ZAMAN_TIPI_HATALI
  'COMMAND IS NOT AN AIR MISSION' = -2147482934, // EMIR_HAVA_GOREVI_DEGIL
  'INSUFFICIENT INVENTORY FOR DIVIDE' = -2147482933, // BOLUNME_ICIN_YETERLI_ENVANTER_YOK
  'COMMAND IS NOT IN MICRO AGENTS' = -2147482932, // EMIR_MIKROETMENLERDE_YOK
  'AGENT TO CAPTURE/DETAIN IS NOT HOSTILE' = -2147482931, // ESIR_ALINACAK_ETMEN_DUSMAN_VEYA_SUPHELI_DEGIL
  'BOARDING CAPTURING FAILED' = -2147482930, // CIKMA_ESIR_ALMA_BASARISIZ
  'AGENT TRANSFER FAILED' = -2147482929, // ETMEN_TRANSFERI_BASARISIZ
  'AGENT PROTOTYPE IS NOT VALID FOR CAPTURE/DETAIN' = -2147482928, // ETMEN_TIPI_ESIR_ALMAYA_UYGUN_DEGIL
  'AGENT IS INEFFECTIVE' = -2147482927, // ETMEN_ETKISIZ_HALE_GETIRILDI
  'TORPEDO CRASHED INTO LAND' = -2147482926, // TORPIDO_KARAYA_CARPTI
  'INVALID DEFENCE AREA SIZE' = -2147482925, // SAVUNMA_BOLGESI_ALANI_0_OLAMAZ
  'CAPTURE INFO WAS NOT FOUND' = -2147482924, // ALIKOYMA_BILGISI_BULUNAMADI
  'BOARDING AGENT IS INEFFECTIVE' = -2147482923, // CIKMA_YAPAN_BIRLIK_ETKISIZ
  'AIR INGRESS ROUTE IS OUT OF BOUNDARIES OF THE AIRCRAFT' = -2147482922, // HAVA_GIDIS_IRTIFASI_HAVA_ARACININ_SINIRLARI_DISINDA
  'AIR EGRESS ROUTE IS OUT OF BOUNDARIES OF THE AIRCRAFT' = -2147482921, // HAVA_DONUS_IRTIFASI_HAVA_ARACININ_SINIRLARI_DISINDA
  'AIR MISSION CANNOT EXECUTE SEAD' = -2147482920, // HAVA_GOREVI_SEAD_ICRA_EDEMEZ
  'AIR SUB-MISSION ORDER IS MISSING' = -2147482919, // HAVA_ALT_GOREV_SIRALAMASI_YOK
  'AIR DIVIDE INVALID QUANTITY' = -2147482918, // HAVA_BOLUNME_MIKTARI_GECERSIZ
  'AIR DIVIDE CANNOT DIVIDE INTO REQUESTED QUANTITY' = -2147482917, // HAVA_GOREVI_BELIRTILEN_SAYIDA_BOLUNEMEZ
  'AIR MERGE AGENT TO MERGE IS MISSING' = -2147482916, // HAVA_GOREVININ_BIRLESECEGI_ETMEN_MEVCUT_DEGIL
  'AIR MERGE CAN ONLY MERGE INTO AIR AGENTS WHEN ON AIR' = -2147482915, // HAVA_GOREVI_HAVADAYKEN_YALNIZCA_HAVA_ETMENLERIYLE_BIRLESEBILIR
  'AIR MERGE CAN ONLY MERGE INTO SAME TYPE OF AIRCRAFTS' = -2147482914, // HAVA_GOREVI_YALNIZCA_AYNI_TURDEN_HAVA_ARACLARIYLA_BIRLESEBILIR
  'AIR MERGE CAN ONLY MERGE INTO LAND AGENTS WHEN ON LAND' = -2147482913, // HAVA_GOREVI_YERDEYKEN_YALNIZCA_KARA_ETMENLERIYLE_BIRLESEBILIR
  'AIR MERGE FAILED' = -2147482912, // HAVA_ETMENI_BIRLESME_BASARISIZ
  'OWN MISSILE NEUTRALIZED BY COUNTER MEASURE' = -2147482911, // FUZE_KARSI_TEDBIR_TARAFINDAN_ETKISIZ_HALE_GETIRILDI_OLUMSUZ
  'OWN TORPEDO NEUTRALIZED BY COUNTER MEASURE' = -2147482910, // TORPIDO_KARSI_TEDBIR_TARAFINDAN_ETKISIZ_HALE_GETIRILDI_OLUMSUZ
  'MISSILE FAILED TO NEUTRALIZE BY COUNTERMEASURES' = -2147482909, // FUZE_KARSI_TEDBIR_TARAFINDAN_ETKISIZ_HALE_GETIRILEMEDI
  'TORPEDO FAILED TO NEUTRALIZE BY COUNTERMEASURES' = -2147482908, // TORPIDO_KARSI_TEDBIR_TARAFINDAN_ETKISIZ_HALE_GETIRILEMEDI
  'EW DEVICE TO JAM IS MISSING OR INVALID' = -2147482907, // KARISTIRACAK_ELEKTRONIK_HARP_CIHAZI_BILGISI_BULUNAMADI_VEYA_HATALI
  'JAMMING BEARING INFO IS MISSING OR INVALID' = -2147482906, // KARISTIRILACAK_ISTIKAMET_BILGISI_BULUNAMADI_VEYA_HATALI
  'JAMMING TIME INFO IS MISSING OR INVALID' = -2147482905, // KARISTIRILACAK_SURE_BILGISI_BULUNAMADI_VEYA_HATALI
  'SELECTED DEVICE CANNOT JAM' = -2147482904, // SECILEN_CIHAZ_KARISTIRICI_DEGIL
  'JAMMING TIME CANNOT BE ZERO' = -2147482903, // KARISTIRILACAK_SURE_SIFIR_OLAMAZ
  'JAMMING DEVICE STATUS INFO IS MISSING' = -2147482902, // KARISTIRACAK_CIHAZ_DURUM_BILGISI_BULUNAMADI
  'INSUFFICIENT AMOUNT OF JAMMING DEVICES' = -2147482901, // KARISTIRACAK_CIHAZ_YETERLI_SAYIDA_MEVCUT_DEGIL
  'CANNOT LOAD GAME WHEN EXPERIMENTATION IS ACTIVE' = -2147482900, // DENEY_OYUN_OYNANIRKEN_NORMAL_OYUN_YUKLENEMEZ
  'CANNOT START EXPERIMENTATION WHEN SIMULATION IS ACTIVE' = -2147482899, // NORMAL_OYUN_OYNANIRKEN_DENEY_OYUN_YUKLENEMEZ
  'AGENT CANNOT CREATE AIR MISSION' = -2147482898, // ETMEN_HAVA_GOREVI_YARATAMAZ
  'MOVEMENT ALTITUDE IS INVALID' = -2147482897, // INTIKAL_YUKSEKLIGI_GECERSIZ
  'INSUFFICIENT SHOOTING RANGE' = -2147482896, // ATIS_MENZILI_YETERSIZ
  'AGENT CANNOT DIVIDE INTO ITS OWN PROTOTYPE' = -2147482895, // ETMEN_KENDI_ETMEN_TURUNE_BOLUNEMEZ
  'AGENT TO LIFT AND AGENT TO LIFTED CANNOT BE THE SAME' = -2147482894, // TASIYACAK_VE_TASINACAK_ETMEN_AYNI_OLAMAZ
  'AGENT TO LIFT IS MISSING' = -2147482893, // TASINACAK_ETMEN_BULUNAMADI
  'ENGAGEMENT RULE COMMAND CANNOT BE EXECUTED ON MARITIME AGENT' = -2147482892, // ANGAJMAN_KURALI_EMRI_DENIZ_ETMENI_ICIN_KULLANILAMAZ
  'AGENT TO EMBARK IS ALREADY BEING TRANSPORTED' = -2147482891, // BINECEK_ETMEN_TASINIYOR/
  'DATABASE LOAD QUAD IS MISSING' = -2147482890, // VT_YUKLE_QUAD_ID_BULUNAMADI
  'AIR LIFTING AIR MISSION CANNOT BE DIVIDED' = -2147482889, // TASIMA_GOREVINE_SAHIP_HAVA_GOREVI_BOLUNEMEZ
  'AGENT TO ESTABLISH COMMUNICATION WAS NOT FOUND' = -2147482888, // MUHABERE_KURULACAK_ETMEN_BULUNAMADI
  'AGENT TO REMOVE COMMUNICATION WAS NOT FOUND' = -2147482887, // MUHABERE_KOPARILACAK_ETMEN_BULUNAMADI
  'SUBMARINE CANNOT REACH DESIRED DEPTH LEVEL' = -2147482886, // GIRILEN_DERINLIK_DENIZALTI_ARACIN_ULASAMAYACAGI_SEVIYEDE
  'CHECKPOINT AUTOSAVE FAILED' = -2147482885, // SIMULASYON_OTOMATIK_CHECKPOINT_ALMA_BASARISIZ
  'CANNOT EXECUTE COMMAND WHEN EXPERIMENTATION IS RUNNING' = -2147482884, // DENEY_OYUNU_OYNANIRKEN_EMIR_VERILEMEZ
  'AIR SUB-MISSION FORWARD AIR CONTROL POST WAS NOT FOUND' = -2147482883, // HAVA_ALT_GOREV_ILERI_HAVA_KONTROL_BULUNAMADI
  'AIR SUB-MISSION AGENT TO BE SUPPORTED WAS NOT FOUND' = -2147482882, // HAVA_ALT_GOREV_DESTEK_OLUNACAK_ETMEN_BULUNAMADI
  'AGENTS HAS NO COMMUNICATION' = -2147482881, // ETMENLERIN_MUHABERESI_YOK
  'AIR SUB-MISSION MISSION CANCELED AGENT TO BE SUPPORTED IS INEFFECTIVE' = -2147482880, // DESTEK_OLUNAN_ETMEN_ETKISIZ_OLDUGU_ICIN_GOREV_IPTAL_EDILDI
  'AIR SUB-MISSION MISSION CANCELED AGENT TO BE SUPPORTED IS NOT IN ENGAGEMENT' = -2147482879, // DESTEK_OLUNAN_ETMEN_ANGAJMANDA_OLMADIGINDAN_GOREV_IPTAL_EDILDI
  'FORWARD AIR CONTROL POST WAS NOT FOUND' = -2147482878, // ILERI_HAVA_KONTROL_BULUNAMADI
  'AGENT TO SUPPORT WAS NOT FOUND' = -2147482877, // DESTEK_OLUNAN_ETMEN_BULUNAMADI
  'AGENT TO ATTACK MUST BE A NAVAL AGENT' = -2147482876, // TAARRUZ_EDILECEK_ETMEN_DENIZ_ETMENI_OLMAK_ZORUNDA
  'MAX DURATION FOR AMBUSH IS INVALID' = -2147482874, // GIRILEN_EN_FAZLA_PUSU_SURESI_HATALI
  'MAX SHOCK FIRE DURATION FOR AMBUSH IS INVALID' = -2147482873, // GIRILEN_PUSU_SOK_ATESI_SURESI_HATALI
  'AMBUSH LOCATION IS OUT OF THEATER' = -2147482872, // GIRILEN_PUSU_KONUMU_ARAZI_SINIRLARI_DISINDA
  'CASUALTY LIMIT INFO IS INVALID' = -2147482871, // GIRILEN_ZAYIAT_LIMITI_HATALI
  'TARGET AGENT INFO IS INVALID' = -2147482870, // BELIRTILEN_HEDEF_ETMEN_HATALI
  'IMMOBILE DUE TO PRISONER OF WAR' = -2147482869, // immobile due to prisoner of war // HARP_ESIRI_SEBEBIYLE_INTIKAL_EDEMEZ
  'COULD NOT FIND ANY COMMUNICATION DEVICE' = -2147482868, // MUHABERE_CIHAZI_BULUNAMADI
  'AIR MISSION CANCELED, FORWARD AIR CONTROL POST WAS NOT FOUND' = -2147482867, // ILERI_HAVA_KONTROL_BULUNAMADIGINDAN_GOREV_IPTAL_EDILDI
  'COULD NOT FIND COMMAND TO BE CHAINED TO' = -2147482866, // ZINCIRLI_EMRIN_BAGLANACAGI_EMIR_BULUNAMADI
  'DIVIDED AIR AGENT CAN ONLY MERGE INTO TO THE AGENT THAT WAS DIVIDED FROM' = -2147482865, // HAVADA_BOLUNMUS_ETMEN_YALNIZCA_BOLUNDUGU_ETMENE_GERI_BIRLESEBILIR
  'CANNOT FIND ANY STOP TIME COMMAND FOR EXPERIMENTATION' = -2147482864, // DENEY_OYUNUNA_AIT_EMIR_BULUNMUYOR
  'AGENT CONTINUE BY NEXT SUB-MISSION' = -2147482863, // ETMEN_BIR_SONRAKI_ALT_GOREVE_GECTI
  // HIZMETLER_BINARY_OLARAK_KAYDEDILIRKEN_HATA_OLUSTU = -2147482862,
  // SABITLER_BINARY_OLARAK_KAYDEDILIRKEN_HATA_OLUSTU = -2147482861,
  // SHAGLOBAL_BINARY_OLARAK_KAYDEDILIRKEN_HATA_OLUSTU = -2147482860,
  // HIZMETLER_BINARY_DOSYADAN_YUKLENIRKEN_HATA_OLUSTU = -2147482859,
  // SABITLER_BINARY_DOSYADAN_YUKLENIRKEN_HATA_OLUSTU = -2147482858,
  // SHAGLOBAL_BINARY_DOSYADAN_YUKLENIRKEN_HATA_OLUSTU = -2147482857,
  'SPACECRAFTS QUANTITY EXCEEDS MAX' = -2147482856, // UZAY_ARACLARI_SAYISI_MAX_SAYIDAN_BUYUK
  'SPACECRAFT NAME MUST BE UNIQUE' = -2147482855, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_UZAY_ARACI_OLAMAZ
  'SIDE RELATION INFO WAS NOT FOUND OR INVALID' = -2147482854, // TARAF_ILISKI_DURUMU_BULUNAMADI_VEYA_HATALI
  'FAILED TO CHANGE SIDE RELATION' = -2147482853, // TARAF_ILISKISI_DEGISTIRILIRKEN_HATA_ILE_KARSILASILDI
  'VOLUME CANNOT BE ZERO' = -2147482852, // YENI_ATANAN_HACIM_SIFIR_OLAMAZ
  'VOLUME CANNOT BE NEGATIVE NUMBER' = -2147482851, // YENI_ATANAN_HACIM_NEGATIF_OLAMAZ
  'AGENT MUST HAVE AT LEAST 10% OF HUMAN POPULATION OF THE TARGET TO BE CAPTURED' = -2147482850, // ETMENDEKI_INSAN_SAYISI_ESIR_ALACAGI_ETMENDEKININ_EN_AZ_ONDA_BIRI_OLMALI
  'CANNOT CAPTURE AN UNIDENTIFIED AGENT' = -2147482849, // ALGILANMAYAN_ETMEN_ESIR_ALINANMAZ
  'CANNOT CAPTURE A NON ENEMY AGENT' = -2147482848, // DUSMAN_OLMAYAN_ETMEN_ESIR_ALINANMAZ
  'CANNOT CAPTURE A NON SURRENDERED AGENT' = -2147482847, // TESLIM_OLMAMIS_ETMEN_ESIR_ALINAMAZ
  'FAILED TO UPDATE COMAO' = -2147482846, // COMAO_GUNCELLENEMEDI
  'FAILED TO CREATE COMAO' = -2147482845, // COMAO_OLUSTURULAMADI
  'COULD NOT FIND REFERRED NODE ON COMMAND' = -2147482844, // EMIRDE_REFERE_EDILEN_DUGUM_BULUNAMADI
  'AIR SUB-MISSION AGENT TO ESCORT IS INVALID' = -2147482843, // HAVA_ALT_GOREV_HIMAYE_EDILECEK_ETMEN_GECERSIZ
  'MAX SENSING TIME VALUE IS INVALID' = -2147482842, // MAX_ALGI_ZAMANI_DEGERI_HATALI
  'NO BUILDING AT THE TARGET AREA' = -2147482841, // SECILEN_BOLGEDE_TEMIZLENECEK_BINA_BULUNAMADI
  'MINE DETONATED ACCIDENTALLY DURING REMOVING OBSTACLE' = -2147482840, // TEMIZLIK_SIRASINDA_MAYIN_YANLISLIKLA_PATLATILDI
  'HYMOTS E CANNOT EXECUTE COMMANDS DURING A HYMOTS C RUN IS ACTIVE' = -2147482839, // NORMAL_OYUN_OYNANIRKEN_HYMOTS_E_EMIR_VEREMEZ
  'AGENT IS ALREADY BEING AIR LIFTED' = -2147482838, // TASINAN_ETMEN_TASIMA_ESNASINDA
  'INVALID GAME ID' = -2147482837, // OYUN_ID_GECERSIZ
  'CANNOT EXECUTE AN ORDER. GAME IS NOT LOADED' = -2147482836, // EMIR_VERILMEK_ISTENEN_DB_BACKEND_DE_YUKLU_DEGIL
  'CHECKPOINT TO BE LOADED DOES NOT BELONG TO ANY RUN' = -2147482835, // DALLANMA_GERCEKLESTIRILMEK_ISTENEN_CHECKPOINT_KOSUYA_AIT_DEGIL
  'FAILED TO LOAD CHECKPOINT. BAD REQUEST FOR BRANCH ID' = -2147482834, // BRANCH_ID_ISTEMESI_HATALI
  'FAILED TO LOAD CHECKPOINT. COULD NOT CREATE BRANCH' = -2147482833, // VERITABANINA_DALLANDIRMA_GONDERILMESI_BASARISIZ
  'FAILED TO LOAD CHECKPOINT. COULD NOT SEND CHECKPOINT AND BRANCH IDS' = -2147482832, // CHECKPOINT_ID_BRANCH_ID_GONDERILEMEDI
  'AUTOMATIC CHECKPOINT ID IS MISSING' = -2147482831, // OTOMATIK_CHECKPOINT_ID_BOS_GELDI
  'COULD NOT RECEIVE CHECKPOINT ID FROM DATABASE' = -2147482830, // VERITABANINDAN_CHECKPOINT_ID_ALINAMADI
  "THE AGENT ISN'T IN SELECTED AREA AND WON'T COMPLY WITH THE ORDER" = -2147482829, // ETMEN_SECILI_BOLGE_ICINDE_DEGIL_EMRI_ICRA_ETMEYECEK
  "THE AGENT TO EXECUTE LISTED IN BULK ORDER COULDN'T BE FOUND" = -2147482828, // .TOPLU_EMIRDEKI_EMRI_ALACAK_ETMEN_BULUNAMADI
  'MESSAGE SECURITY CLASSIFICATION WAS NOT SPECIFIED' = -2147482827, // MESAJ_GUVENLIK_SINIFLANDIRMASI_BELIRLENEMEDI
  'AGENT CONTROLLING UNMANNED NAVAL CRAFT IS SINKING OR INEFFECTIVE' = -2147482826, // INSANSIZ_DENIZ_ARACI_KONTROLU_SAGLAYAN_ETMEN_BATIYOR_VEYA_ETKISIZ
  'AGENT CONTROLLING UNMANNED NAVAL CRAFT IS OUT OF CONTROL RANGE' = -2147482825, // INSANSIZ_DENIZ_ARACI_KONTROLU_SAGLAYAN_ETMEN_KONTROL_MENZILINDEN_UZAKTA
  'AGENT CONTROLLING UNMANNED NAVAL CRAFT CANNOT MEET REQUIREMENTS' = -2147482824, // INSANSIZ_DENIZ_ARACI_KONTROLU_SAGLAYAN_ETMEN_GEREKLILERI_KARSILAMIYOR
  'CBRN AGENT TO BE DECONTAMINATED IS INVALID' = -2147482823, // TEMIZLENECEK_KBRN_ETMENI_HATALI
  'INSUFFICIENT SUPPLY FOR CBRN DECONTAMINATION' = -2147482822, // KBRN_TEMIZLIGI_ICIN_YETERLI_IKMAL_YOK
  'NO CBRN AGENT TO DECONTAMINATE' = -2147482821, // TEMIZLENECEK_KBRN_ETMENI_YOK
  'NO AGENT TO EXECUTE DECONTAMINATION' = -2147482820, // TEMIZLEME_ISLEMINI_YAPACAK_KBRN_ETMENI_YOK
  'REQUIRED SUPPLY FOR CBRN DECONTAMINATION IS MISSING' = -2147482819, // KBRN_TEMIZLIGI_ICIN_GEREKEN_IKMAL_YOK
  'AIR SUB-MISSION VERTICAL DISEMBARKMENT TYPE IS INVALID' = -2147482818, // HAVA_ALT_GOREV_DIKEY_INDIRME_TIPI_ANLASILMADI
  'AIR SUB-MISSION VERTICAL EMBARKMENT TYPE IS INVALID' = -2147482817, // HAVA_ALT_GOREV_DIKEY_BINDIRME_TIPI_ANLASILMADI
  'AIR SUB-MISSION AGENT TO DISEMBARK IS INVALID' = -2147482816, // HAVA_ALT_GOREV_INDIRILECEK_ETMEN_ANLASILMADI
  'AIR SUB-MISSION AGENT TO EMBARK IS INVALID' = -2147482815, // HAVA_ALT_GOREV_BINDIRILECEK_ETMEN_ANLASILMADI
  'AIR SUB-MISSION AGENT TO DISEMBARK WAS NOT FOUND' = -2147482814, // HAVA_ALT_GOREV_INDIRILECEK_ETMEN_BULUNAMADI
  'AIR SUB-MISSION AGENT TO EMBARK WAS NOT FOUND' = -2147482813, // HAVA_ALT_GOREV_BINDIRILECEK_ETMEN_BULUNAMADI
  'FUEL LEAKING LEAKING DURATION WAS NOT FOUND OR INVALID' = -2147482812, // YAKIT_SIZDIR_SIZDIRILACAK_SURE_MIKTARI_HATALI_VEYA_BULUNAMADI
  'FUEL LEAKING AMMUNITION TO GET CONTAMINATION INFO WAS NOT FOUND OR INVALID' = -2147482811, // YAKIT_SIZDIR_KIRLILIK_BILGISI_ALINACAK_MUHIMMAT_REFERANSI_HATALI_VEYA_BULUNAMADI
  'CANNOT DIVIDE NAVALCRAFT FROM A NAVAL AGENT' = -2147482810, // DENIZ_ETMENINDEN_DENIZ_ARACI_BOLUNEMEZ
  'AIR MISSION CANNOT BE AT THE MISSION SITE AT THE GIVEN TIME' = -2147482809, // HAVA_GOREVI_BELIRTILEN_ZAMANDA_GOREV_BOLGESINDE_BULUNAMAZ
  'AIR MISSION CANNOT INITIATE THE MISSION AT THE GIVEN TIME' = -2147482808, // HAVA_GOREVI_BELIRTILEN_ZAMANDA_GOREVE_BASLAYAMAZ
  'AGENT CANNOT CLEAR BUILDINGS' = -2147482807, // ETMEN_BINA_TEMIZLEME_YETERLILIGINE_SAHIP_DEGIL
  'SELECTED SYSTEM CAN ONLY BE USED BY FLYING AIRCRAFT' = -2147482806, // SECILEN_SILAH_HAVADAKI_UCAK_TARAFINDAN_KULLANILABILIR
  'AIR MISSION CANCELLED DUE TO LIQUID CAPACITY BEING FULL' = -2147482805, // HAVA_GOREVI_SIVI_TASIMA_KAPASITESI_DOLDUGUNDAN_GOREV_IPTAL_EDILDI
  'RECURSION DETECTED IN HIGHER AGENT' = -2147482804, // RECURSION_DETECTED_IN_HIGHER_AGENT // UST_ISLETEN_ETMENDE_DONGU_TESPIT_EDILDI
  'AGENT CANNOT BE ITS OWN HIGHER AGENT' = -2147482803, // AGENT_CANNOT_BE_ITS_OWN_HIGHER_AGENT // ETMEN_KENDISININ_UST_ISLETEN_ETMENI_OLAMAZ
  'AAR COUNT REQUEST UNSUCCESSFUL' = -2147482802, // AAR_SAYISI_ISTEGI_BASARISIZ
  'AAR LIST REQUEST UNSUCCESSFUL' = -2147482801, // AAR_LISTESI_ISTEGI_BASARISIZ
  'AAR IS MISSING' = -2147482800, // AAR_BULUNMUYOR
  'AAR REQUEST UNSUCCESSFUL' = -2147482799, // AAR_ISTEGI_BASARISIZ
  'AAR LABEL CHANGE UNSUCCESSFUL' = -2147482798, // AAR_ETIKETI_DEGISTIRME_BASARISIZ
  'COMMAND COUNT REQUEST UNSUCCESSFUL' = -2147482797, // EMIR_SAYISI_ISTEGI_BASARISIZ
  'COMMAND LIST REQUEST UNSUCCESSFUL' = -2147482796, // EMIR_LISTESI_ISTEGI_BASARISIZ
  'COMMAND UNIQUE ID MISSING' = -2147482795, // EMIR_UNIQUE_ID_BULUNAMADI
  'DATA READ FROM DATABASE INCORRECT' = -2147482794, // DATABASE_DEN_OKUNAN_VERI_HATALI
  'COULD NOT PROCESS TERRAIN' = -2147482793, // ARAZI_YAZILAMADI
  'UNABLE TO GENERATE REPORT DUE TO NO LOADED GAME' = -2147482792, // YUKLU_OYUN_OLMADIGI_ICIN_RAPOR_OLUSTURULAMADI
  'UPDATE DATA CONTENT NOT FOUND' = -2147482791, // GUNCELLEME_VERISI_ICERIGI_BULUNAMADI
  'THERE CAN ONLY BE ONE NAVALCRAFT IN A SEA AGENT' = 2147482790, // DENIZ_ETMENINDE_YALNIZ_BIR_DENIZ_ARACI_OLABILIR
  'NO AGENT TO ADD TO FORMATION' = -2147482789, // NIZAMA_EKLENMEK_ISTENEN_ETMEN_BULUNAMADI
  'AUTO RESUPPLY MUST BE LOWER THAN TARGET' = -2147482788, // OTOMATIK_IKMAL_SEVIYESI_HEDEF_IKMAL_SEVIYESINDEN_DUSUK_OLMALI,
  'RTI TASK ID IS NOT A STRING' = -2147482787, // RTI_TASK_ID_STRING_FORMATINDA_DEGIL
  'RTI TASK ID STRING LENGTH IS DIFFERENT THAN IT SHOULD BE' = -2147482786, // RTI_TASK_ID_STRING_UZUNLUGU_OLMASI_GEREKEN_DEGERDEN_FARKLI
  'SUPPLY TARGET AMOUNT CANNOT BE LOWER THAN_ZERO' = -2147482785, // IKMAL_HEDEF_MIKTAR_SIFIRDAN_KUCUK_OLAMAZ
  'AUTO RESUPPLY CANNOT BE LOWER THAN ZERO' = -2147482784, // IKMAL_OTOMATIK_MIKTAR_SIFIRDAN_KUCUK_OLAMAZ
  'SUPPLY TARGET AMOUNT CANNOT BE LOWER THAN AUTO RESUPPLY' = -2147482783, // IKMAL_HEDEF_MIKTAR_OTOMATIK_MIKTARDAN_KUCUK_OLAMAZ
  'SUPPLY CURRENT AMOUNT CANNOT BE LOWER THAN ZERO' = -2147482782, // IKMAL_MEVCUT_MIKTAR_SIFIRDAN_KUCUK_OLAMAZ
  'ENTITY CURRENT AMOUNT CANNOT BE LOWER THAN ZERO' = -2147482781, // UNSUR_MEVCUT_MIKTAR_SIFIRDAN_KUCUK_OLAMAZ
  'ENTITY WOUNDED AMOUNT CANNOT BE LOWER THAN ZERO' = -2147482780, // UNSUR_BAKIMDA_MIKTAR_SIFIRDAN_KUCUK_OLAMAZ
  'ENTITY CASULTY AMOUNT CANNOT BE LOWER THAN ZERO' = -2147482779, // UNSUR_ZAYI_MIKTAR_SIFIRDAN_KUCUK_OLAMAZ
  'ENTITY CONTAMINATED AMOUNT CANNOT BE LOWER THAN ZERO' = -2147482778, // UNSUR_KIRLETILMIS_MIKTAR_SIFIRDAN_KUCUK_OLAMAZ
  'ENTITY JAMMED AMOUNT CANNOT BE LOWER THAN ZERO' = -2147482777, // UNSUR_KARISTIRILMIS_MIKTAR_SIFIRDAN_KUCUK_OLAMAZ
  'CANNOT MOVE DUE TO VISIBILITY COEFFICIENT BEING ZERO' = -2147482776, // AYDINLIK_CARPANININ_SIFIR_OLMASI_NEDENIYLE_INTIKAL_EDILEMIYOR
  'CANNOT MOVE DUE TO TACTICAL MOVE COEFFICIENT BEING ZERO' = -2147482775, // TAKTIK_INTIKAL_CARPANININ_SIFIR_OLMASI_NEDENIYLE_INTIKAL_EDILEMIYOR
  'CANNOT MOVE DUE TO COVERT MOVE COEFFICIENT BEING ZERO' = -2147482774, // GIZLI_INTIKAL_CARPANININ_SIFIR_OLMASI_NEDENIYLE_INTIKAL_EDILEMIYOR
  'CANNOT MOVE DUE TO TERRAIN WEATHER MOVEMENT COEFFICIENT BEING ZERO' = -2147482773, // ARAZI_HAVA_DURUMU_CARPANININ_SIFIR_OLMASI_NEDENIYLE_INTIKAL_EDILEMIYOR
  'CANNOT MOVE DUE TO ROAD WEATHER MOVEMENT COEFFICIENT BEING ZERO' = 2147482772, // YOL_HAVA_DURUMU_CARPANININ_SIFIR_OLMASI_NEDENIYLE_INTIKAL_EDILEMIYOR
  'CANNOT MOVE DUE TO INCLINE COEFFICIENT BEING ZERO' = -2147482771, // EGIM_CARPANININ_SIFIR_OLMASI_NEDENIYLE_INTIKAL_EDILEMIYOR
  'AGENT TO TOWING AND AGENT TO TOWING CANNOT BE THE SAME' = -2147482770, // CEKEN_VE_CEKILEN_ETMEN_AYNI_OLAMAZ
  'PAYLOAD AMOUNT IS INVALID' = -2147482769, // GIRILEN YUK MIKTARI GECERSIZ
  'WEAPON IS NOT PRESENT' = -2147482768, // SILAH_BULUNAMADI
  'COULD NOT FIND A NAVALCRAFT IN THE AGENT TO BE LIFTED' = -2147482767, // TASINACAK_ETMENDE_DENIZ_ARACI_BULUNAMADI
  'THERE CAN ONLY BE ONE TYPE OF AIRCRAFT IN AN AIR AGENT' = -2147482766, // HAVA_ETMENINDE_YALNIZ_BIR_TUR_HAVA_ARACI_OLABILIR
  'POW AGENT CANNOT BE HANDED OVER TO ITSELF' = -2147482765, // TESLIM_EDILEN_ETMENIN_KENDISI_TESLIM_ALAN_ETMEN_OLAMAZ
  'PRISONER OF WAR BROKE FREE' = -2147482764, // TESLIM_ALMA_YETERLILIGINE_SAHIP_OLUNMAMASI_SEBEBIYLE_ESIRLER_SERBEST_KALDI
  'AGENT CANNOT CAPTURE ITSELF' = -2147482763, // ETMEN_KENDINI_ESIR_ALAMAZ
  'GAME HISTORY REQUEST FAILED' = -2147482762, // GAME_HISTORY_ISTEGI_BASARISIZ
  'COMMAND CONTROL TYPE NOT FOUND' = -214782761, // EMIR_KONTROL_TIPI_BULUNAMADI
  'AGENT TO BE MERGED HAS TO BE ON THE SAME SIDE' = -214782760, // ETMEN_BIRLESILECEK_ETMENLE_AYNI_TARAFTA_OLMALI
  'AGENT UPDATE FAILED' = -214782759, // ETMEN_GUNCELLEME_BASARISIZ
  'NODE NAME MUST BE UNIQUE' = -214782758, // DUGUM_ISMI_ESSIZ_OLMALI
  'AGENT CONTROLLER INFO IS MISSING' = -214782757, // ETMEN_KONTROLCU_BILGISI_BULUNAMADI
  'AGENT CONTROLLER INFO IS MISTAKEN' = -214782756, // ETMEN_KONTROLCU_BILGISI_HATALI
  'AGENT NOT FOUND' = -214782755, // ETMEN_BULUNAMADI
  'TEMPERATURE CATEGORIES IS NOT ORDERED' = -2147482754, // SICAKLIK_BOLGELERI_SIRALI_DEGIL
  'BUILDING ID NOT FOUND OR MISTAKEN' = -2147482753, // BINA_ID_BULUNAMADI_VEYA_HATALI
  'BUILDING CORNER POINTS NOT FOUND OR MISTAKEN' = -2147482752, // BINA_KOSE_NOKTALARI_BULUNAMADI_VEYA_HATALI
  'BUILDING IS OUT OF TERRAIN' = -2147482751, // BINA_ARAZI_DISINDA
  'BUILDING DATA IS MISSING' = -2147482750, // BINA_VERILERI_EKSIK
  'EARTHQUAKE MATRIX IS MISTAKEN' = -2147482749, // DEPREM_MATRISI_HATALI
  'GAMEID THAT REQUESTED IN SUBSCRIPTION IS NOT RUNNING ON SURFER' = -2147482748, // ABONELIK_ISTEKTE_BELIRTILEN_OYUNID_SURFERDA_KOSULMUYOR
  'SUBSCRIPTION REQUESTED ONLY COMMAND RESPONSE BUT SENT MORE THAN ONE TYPE OF SUBSCRIPTION AS PARAMETER' = -2147482747, // ABONELIK_SADECE_EMIR_CEVABI_ISTENDI_AMA_BIRDEN_FAZLA_TUR_ABONELIK_PARAMETRE_OLARAK_GONDERILDI
  'SUBSCRIPTION SENT ONE TYPE OF SUBSCRIPTION AS PARAMETER WHILE REQUESTED UPDATES OF AGENTS THAT RELATED TO THE COMMAND' = -2147482746, // ABONELIK_EMIRLE_ILISKILI_ETMENLERIN_GUNCELLEMELERI_ISTENIRKEN_TEK_TUR_ABONELIK_PARAMETRE_OLARAK_GONDERILDI
  'SUBSCRIPTION SUBMESSAGE TYPE IS UNDEFINED' = -2147482745, // ABONELIK_MESAJ_ALT_TIPI_BELIRSIZ
  'ERROR OCCURED WHILE PROCESSING SUBSCRIPTION CONTENT' = -2147482744, // ABONELIK_ICERIGI_ISLENIRKEN_HATA_MEYDANA_GELDI
  'AN ERROR OCCURED WHILE REQUEST OF SUBSCRIPTION' = -2147482743, // ABONELIK_ISTEGINDE_BIR_HATA_MEYDANA_GELDI,
  'SUBSCRIPTION REQUESTED AGENT SUBSCRIPTION ONLY FOR COMMAND RESPONSE' = -2147482742, // ABONELIK_SADECE_EMIR_CEVABI_ISTEGINDE_ETMEN_ABONELIGI_ISTENDI
  'SUBSCRIPTION TYPE UNDEFINED' = -2147482741, // ABONELIK_TIPI_BELIRSIZ,
  'RUN ID IS MISSING' = -2147482740, // RUN_ID_BOS_GELDI
  'AAR ID IS MISSING' = -2147482739, // AAR_ID_BOS_GELDI
  'CANNOT ASSIGN CONTROLLER TO PLAYER' = -2147482738, // GAME_HISTORY_OYUNCU_ICIN_HERSEYI_GOREN_ETMEN_ID_ATILAMAZ
  'AGENT ID NOT ASSIGNED FOR THE PLAYER' = -2147482737, // GAME_HISTORY_OYUNCU_ICIN_ETMEN_ID_ATANMAMIS
  'AGENT ID IS MISTAKEN FOR AGENT ID FIELD' = -2147482736, // GAME_HISTORY_OYUNCU_ICIN_ETMEN_ID_ALANI_HATALI
  'CLIENT ROLE CANNOT BE UNDEFINED' = -2147482735, // GAME_HISTORY_ISTEMCI_ROLU_TANIMSIZ_OLAMAZ
  'AGENT ID FIELD IS MISTAKEN FOR THE ROLE WHICH IS NOT A PLAYER' = -2147482734, // GAME_HISTORY_OYUNCU_DISINDA_ROL_ICIN_ETMEN_ID_ALANI_HATALI
  'GAME STATISTICS REQUEST UNSUCCESFUL' = -2147482733, // OYUN_EMIR_STATISTIGI_ISTEGI_BASARISIZ
  'AGENT THAT REQUIRES MAINTAINANCE IS NOT AT RENDEZVOUS LOCATION' = -2147482732, // BAKIM_TALEP_EDEN_ETMEN_RANDEVU_KONUMUNDA_DEGIL
  'MAINTAINANCE UNSUCCESFUL' = -2147482731, // BAKIM_BASARISIZ
  'MAINTAINANCE CONVOY AGENT NOT FOUND' = -2147482730, // BAKIM_KONVOY_ETMENI_BULUNAMADI
  'AGENT TO DISEMBARK CANNOT ASSIGN ITSELF' = -2147482729, // INDIRILECEK_ETMEN_KENDISI_OLAMAZ
  'AGENT TO CARRY NOT FOUND' = -2147482728, // TASIYACAK_ETMEN_BULUNUMADI
  'AGENT TO CARRY HAS INSUFFICIENT CAPACITY' = -2147482727, // TASIYACAK_ETMENDE_YETERLI_KAPASITE_YOK
  'LAND EMBARK CANNOT CHOOSE POW' = -2147482726, // KARA_TASIMADA_HARP_ESIRI_SECILEMEZ
  'AGENT THAT WILL BE DISEMBARKED CANNOT BE LIFTING' = -2147482725, // INDIRILECEK_ETMEN_TASINMIYOR
  'POSTURE OF AGENT TO BE EMBARKED NOT SUITABLE TO BE LIFTING' = -2147482724, // BINDIRILECEK_ETMEN_FAALIYETI_TASINMAYA_UYGUN_DEGIL
  'SUPPLY INGRESS ROUTE NOT FOUND' = -2147482723, // IKMAL_GIDIS_ROTASI_BULUNAMADI
  'SUPPLY EGRESS ROUTE NOT FOUND' = -2147482722, // IKMAL_GERI_DONUS_ROTASI_BULUNAMADI
  'SUPPLIER AGENT INSUFFICIENT VEHICLE OR SUPPLY' = -2147482721, // IKMALDEN_SORUMLU_ETMENDE_YETERLI_ARAC_YADA_IKMAL_YOK
  'SUPPLIER AGENT ALREADY EXECUTING A COMMAND' = -2147482720, // IKMALDEN_SORUMLU_ETMENIN_ICRA_ETTIGI_BASKA_BIR_EMIR_VAR
  'MERGE TARGET NOT FOUND' = -2147482719, // BIRLESME_HEDEFI_BULUNUMADI
  'AGENT PROTOTYPE SYMBOL IS WRONG' = -2147482718, // ETMEN_TURU_SEMBOLU_HATALI
  'SEED VALUE IS WRONG' = -2147482717, // SEED_DEGERI_HATALI
  'MISSION CANCELLED DUE TO THE HIGHER AGENT HAVING NOT ENOUGH ENTITIES/SUPPLIES' = -2147482716, // ANA_ETMENDE_YETERLI_YUK_KALMADIGI_ICIN_GOREV_IPTAL_EDILDI
  'COMMAND NOT ACCEPTED DUE TO LOADING IS IN PROGRESS' = -2147482715,
  'MOVE TOWING CAPACITY EXCESS' = -2147482714, // INTIKAL_CEKME_KAPASITESI_ASIMI
  'ENTITY TO ACTIVATE/DEACTIVATE NOT FOUND' = -2147482713, // ACILACAK_KAPANACAK_UNSUR_BULUNAMADI
  'ENTITY TO ACTIVATE/DEACTIVATE AMOUNT INSUFFICIENT' = -2147482712, // ACILACAK_KAPANACAK_UNSUR_MIKTARI_YETERSIZ
  'MAINTENANCE INTERVAL CANNOT BE LESS THAN ONE DAY' = -2147482711, // BAKIM_ARALIGI_BIR_GUNDEN_AZ_OLAMAZ
  'GAME ID IS WRONG' = -2147482710, // VT_ID_HATALI
  'WEAPON ARMOR/AMPHIBIOUS SENSOR IS WRONG' = -2147482709, // SILAH_ZIRH_AMFIBI_SENSOR_HATALI
  'SENSING PARAMETERS IS WRONG' = -2147482708, // ALGILAMA_PARAMETRELERI_HATALI
  'DETECTABILITY PARAMETERS IS WRONG' = -2147482707, // TESPIT_ETME_PARAMETRELERI_HATALI
  'DETECTION RANGE IS WRONG' = -2147482706, // TESPIT_MENZILI_HATALI
  'VISIBILITY CONDITIONS PARAMETERS IS WRONG' = -2147482705, // GORUS_KOSULLARI_PARAMETRESI_HATALI
  'SYSTEM CATEGORY IS WRONG' = -2147482704, // TMK_KATEGORISI_HATALI,
  'MAINTENANCE PARAMETERS INVALID' = -2147482703, // BAKIM_PARAMETRELERI_HATALI
  'WEIGHT VALUE INVALID' = -2147482702, // AGIRLIK_DEGERI_HATALI
  'UNIT COST VALUE INVALID' = -2147482701, // BIRIM_MALIYET_DEGERI_HATALI
  'FLOOD INDEX VALUE INVALID' = -2147482700, // SEL_INDEKS_DEGERI_HATALI
  'FIRE INDEX VALUE INVALID' = -2147482699, // YANGIN_INDEKS_DEGERI_HATALI
  'ID VALUE NOT UNIQUE' = -2147482698, // ID_DEGERI_ESSIZ_DEGIL
  'SYSTEM SHORT NAME NOT UNIQUE' = -2147482697, // TMK_KISA_ISMI_ESSIZ_DEGIL
  'AMMUNITION ID INVALID' = -2147482696, // MUHIMMAT_TURU_ID_HATALI
  'AMMUNITION EFFECT FREQUENCY INVALID' = -2147482695, // MUHIMMAT_TURU_ETKI_SIKLIGI_HATALI
  'AMMUNITION CRUISE ALTITUDE INVALID' = -2147482694, // MUHIMMAT_TURU_SEYIR_IRTIFASI_HATALI
  'AMMUNITION ARMOR EFFECTIVENESS INVALID' = -2147482693, // MUHIMMAT_TURU_ZIRH_ETKILIGI_HATALI
  'AMMUNITION ARMOR THICKNESS INVALID' = -2147482692, // MUHIMMAT_TURU_ZIRH_KALINLIGI_HATALI
  'AMMUNITION DETECTABILITY INVALID' = -2147482691, // MUHIMMAT_TURU_ALGILANABILIRLIK_HATALI
  'AMMUNITION GUIDANCE SYSTEM INVALID' = -2147482690, // MUHIMMAT_TURU_GUDUM_SISTEMI_HATALI
  'AMMUNITION BALLISTIC PROPERTIES INVALID' = -2147482689, // MUHIMMAT_TURU_BALISTIK_OZELLIKLERI_HATALI
  'AMMUNITION HIT PROBABILITY PARAMETERS INVALID' = -2147482688, // MUHIMMAT_TURU_VURMA_OLASILIGI_PARAMATRELERI_HATALI
  'AMMUNITION NEUTRALIZATION PROBABILITY INVALID' = -2147482687, // MUHIMMAT_TURU_ETKISIZ_KILMA_OLASILIGI_HATALI
  'AMMUNITION CONTAMINATION PARAMETERS INVALID' = -2147482686, // MUHIMMAT_TURU_KIRLETME_PARAMETRELERI_HATALI
  'AMMUNITION ILLUMINATION PARAMETERS INVALID' = -2147482685, // MUHIMMAT_TURU_AYDINLATMA_PARAMETRELERI_HATALI
  'AMMUNITION BLINDING PARAMETERS INVALID' = -2147482684, // MUHIMMAT_TURU_KORELTME_PARAMETRELERI_HATALI
  'AMMUNITION PASSIVE GUIDANCE PARAMETERS INVALID' = -2147482683, // MUHIMMAT_TURU_PASIF_GUDUM_PARAMETRELERI_HATALI
  'AMMUNITION SHORT NAME NOT UNIQUE' = -2147482682, // MUHIMMAT_TURU_KISA_ISIM_ESSIZ_DEGIL
  'SYSTEM AMMO INDEX ID VALUE INVALID' = -2147482681, // TMK_MUHIMMAT_INDEX_ID_DEGERI_HATALI
  'SYSTEM AMMO INDEX DEFAULT ID VALUE INVALID' = -2147482680, // TMK_MUHIMMAT_INDEX_DEFAULT_ID_DEGERI_HATALI
  'SYSTEM AMMO INDEX ALTERNATIVE ID VALUE INVALID' = -2147482679, // TMK_MUHIMMAT_INDEX_ALTERNATIF_ID_DEGERI_HATALI
  'SYSTEM AMMO INDEX ALTERNATIVE INDEX ID VALUE INVALID' = -2147482678, // TMK_MUHIMMAT_INDEX_ALTERNATIF_INDEKS_ID_DEGERI_HATALI
  'SYSTEM AMMO INDEX ALTERNATIVE AMMUNITION ID VALUE INVALID' = -2147482677, // TMK_MUHIMMAT_INDEX_ALTERNATIF_MUHIMMAT_ID_DEGERI_HATALI
  'SIDE CIVILIAN INFO INVALID' = -2147482676, // TARAF_SIVIL_BILGISI_HATALI
  'SIDE SHORT NAME NOT UNIQUE' = -2147482675, // TARAF_KISA_ISMI_ESSIZ_DEGIL
  'AGENT FACTION ATTACK LIMIT NOT VALID' = -2147482674, // ETMEN_SINIFI_TAARUZ_LIMITI_UYGUN_DEGIL
  'AGENT FACTION DEFEND LIMIT NOT VALID' = -2147482673, // ETMEN_SINIFI_SAVUNMA_LIMITI_UYGUN_DEGIL
  'AGENT FACTION CIVILIAN INFO INVALID' = -2147482672, // ETMEN_SINIFI_SIVIL_BILGISI_HATALI
  'AGENT FACTION SHORT NAME NOT UNIQUE' = -2147482671, // ETMEN_SINIFI_KISA_ISIM_ESSIZ_DEGIL
  'AIRCRAFT ID VALUE INVALID' = -2147482670, // HAVA_ARACI_ID_DEGERI_HATALI
  'AIRCRAFT CATEGORY INVALID' = -2147482669, // HAVA_ARACI_KATEGORISI_HATALI
  'AIRCRAFT DETECTABILITY INVALID' = -2147482668, // HAVA_ARACI_ALGILANABILIRLIGI_HATALI
  'AIRCRAFT CBRN PERMEABILITY INVALID' = -2147482667, // HAVA_ARACI_KBRN_GECIRGENLIGI_HATALI
  'AIRCRAFT PREP TIME INVALID' = -2147482666, // HAVA_ARACI_HAZIRLANMA_SURESI_HATALI
  'AIRCRAFT TAKEOFF TIME INVALID' = -2147482665, // HAVA_ARACI_KALKIS_SURESI_HATALI
  'AIRCRAFT MAX ALTITUDE INVALID' = -2147482664, // HAVA_ARACI_AZAMI_IRTIFASI_HATALI
  'AIRCRAFT CRUISE ALTITUDE INVALID' = -2147482663, // HAVA_ARACI_SEYIR_IRTIFASI_HATALI
  'AIRCRAFT SUPPLY ALTITUDE INVALID' = -2147482662, // HAVA_ARACI_IKMAL_IRTIFASI_HATALI
  'AIRCRAFT MAX SPEED INVALID' = -2147482661, // HAVA_ARACI_AZAMI_HIZ_HATALI
  'AIRCRAFT CRUISE SPEED INVALID' = -2147482660, // HAVA_ARACI_SEYIR_HIZI_HATALI
  'AIRCRAFT MIN SPEED INVALID' = -2147482659, // HAVA_ARACI_ASGARI_HIZ_HATALI
  'AIRCRAFT LANDING RUNWAY DISTANCE INVALID' = -2147482658, // HAVA_ARACI_INIS_PIST_MESAFESI_HATALI
  'AIRCRAFT TAKEOFF RUNWAY DISTANCE INVALID' = -2147482657, // HAVA_ARACI_KALKIS_PIST_MESAFESI_HATALI
  'AIRCRAFT MAX FLIGHT DURATION INVALID' = -2147482656, // HAVA_ARACI_AZAMI_UCUS_SURESI_HATALI
  'AIRCRAFT CONTROL RANGE INVALID' = -2147482655, // HAVA_ARACI_KONTROL_MESAFESI_HATALI
  'AIRCRAFT FUEL CONSUMPTION FUNCTION INVALID' = -2147482654, // HAVA_ARACI_YAKIT_TUKETIM_FONKSIYONU_HATALI
  'AIRCRAFT REFUEL START TIME INVALID' = -2147482653, // HAVA_ARACI_YAKIT_IKMAL_BASLAMA_SURESI_HATALI
  'AIRCRAFT CARRYING CAPACITY INVALID' = -2147482652, // HAVA_ARACI_TASIMA_KAPASITESI_HATALI
  'AIRCRAFT LOAD UNLOAD TIME INVALID' = -2147482651, // HAVA_ARACI_YUKLEME_BOSALTMA_SURESI_HATALI
  'AIRCRAFT FALL PROBABILITY INVALID' = -2147482650, // HAVA_ARACI_DUSME_IHTIMALI_HATALI
  'AIRCRAFT CREW SURVIVAL PROBABILITY INVALID' = -2147482649, // HAVA_ARACI_MURETTABAT_HAYATTA_KALMA_OLASILIGI_HATALI
  'AIRCRAFT MAINTENANCE PARAMETER INVALID' = -2147482648, // HAVA_ARACI_BAKIM_PARAMETRESI_HATALI
  'SHORT NAME CANNOT BE CHANGED' = -2147482647, // KISA_ISIM_DEGISTIRILEMEZ
  'NAVALCRAFT ID VALUE INVALID' = -2147482646, // DENIZ_ARACI_ID_DEGERI_HATALI
  'NAVALCRAFT CATEGORY INVALID' = -2147482645, // DENIZ_ARACI_KATEGORISI_HATALI
  'NAVALCRAFT DETECTABILITY INVALID' = -2147482644, // DENIZ_ARACI_ALGILANABILIRLIGI_HATALI
  'NAVALCRAFT CBRN PERMEABILITY INVALID' = -2147482643, // DENIZ_ARACI_KBRN_GECIRGENLIGI_HATALI
  'NAVALCRAFT MAX BOFOR INVALID' = -2147482642, // DENIZ_ARACI_MAX_BOFOR_HATALI
  'NAVALCRAFT WATER PIPE LENGTH INVALID' = -2147482641, // DENIZ_ARACI_SU_HATTI_BOYU_HATALI
  'NAVALCRAFT FULL LENGTH INVALID' = -2147482640, // DENIZ_ARACI_TAM_BOY_HATALI
  'NAVALCRAFT WATER PIPE WIDTH INVALID' = -2147482639, // DENIZ_ARACI_SU_HATTI_GENISLIGI_HATALI
  'NAVALCRAFT FULL WIDTH INVALID' = -2147482638, // DENIZ_ARACI_TAM_GENISLIK_HATALI
  'NAVALCRAFT WATER TOWING INVALID' = -2147482637, // DENIZ_ARACI_SU_CEKIMI_HATALI
  'NAVALCRAFT ABOVE SEA HEIGHT INVALID' = -2147482636, // DENIZ_ARACI_SU_USTU_YUKSEKLIGI_HATALI
  'NAVALCRAFT RUNWAY LENGTH INVALID' = -2147482635, // DENIZ_ARACI_PIST_UZUNLUGU_HATALI
  'NAVALCRAFT RUNWAY WIDTH INVALID' = -2147482634, // DENIZ_ARACI_PIST_GENISLIGI_HATALI
  'NAVALCRAFT DOCK WIDTH INVALID' = -2147482633, // DENIZ_ARACI_HAVUZ_GENISLIGI_HATALI
  'NAVALCRAFT DOCK LENGTH INVALID' = -2147482632, // DENIZ_ARACI_HAVUZ_UZUNLUGU_HATALI
  'NAVALCRAFT DOCK DEPTH INVALID' = -2147482631, // DENIZ_ARACI_HAVUZ_DERINLIGI_HATALI
  'NAVALCRAFT AIRCRAFT PARKING CAPACITY INVALID' = -2147482630, // DENIZ_ARACI_HAVA_ARACI_PARK_KAPASITESI_HATALI
  'NAVALCRAFT MAX SPEED INVALID' = -2147482629, // DENIZ_ARACI_EN_YUKSEK_HIZI_HATALI
  'NAVALCRAFT CRUISE SPEED INVALID' = -2147482628, // DENIZ_ARACI_SEYIR_HIZI_HATALI
  'NAVALCRAFT MAX DEPTH INVALID' = -2147482627, // DENIZ_ARACI_MAX_DERINLIK_HATALI
  'NAVALCRAFT COMPARTMENT AMOUNT INVALID' = -2147482626, // DENIZ_ARACI_KONPARTIMAN_SAYISI_HATALI
  'NAVALCRAFT COMPARTMENT AMOUNT TO SINK INVALID' = -2147482625, // DENIZ_ARACI_BATMASI_ICIN_KONPARTIMAN_SAYISI_HATALI
  'NAVALCRAFT SINKING SPEED INVALID' = -2147482624, // DENIZ_ARACI_BATMASI_HIZI_HATALI
  'NAVALCRAFT SINKING PARAMETER INVALID' = -2147482623, // DENIZ_ARACI_BATMA_PARAMETRESI_HATALI
  'NAVALCRAFT SINKING INDEX ID INVALID' = -2147482622, // DENIZ_ARACI_BATMA_INDEX_ID_HATALI
  'NAVALCRAFT FREE WEIGHT INVALID' = -2147482621, // DENIZ_ARACI_BOS_AGIRLIK_HATALI
  'NAVALCRAFT AVERAGE UNIT COST INVALID' = -2147482620, // DENIZ_ARACI_ORTALAMA_BIRIM_MALIYETI_HATALI
  'NAVALCRAFT MEAN TIME SUPPLY IN SEA INVALID' = -2147482619, // DENIZ_ARACI_ORTALAMA_DENIZDE_IKMAL_SURESI_HATALI
  'NAVALCRAFT MEAN TIME SUPPLY IN PORT INVALID' = -2147482618, // DENIZ_ARACI_ORTALAMA_LIMANDA_IKMAL_SURESI_HATALI
  'NAVALCRAFT CONTROL RANGE INVALID' = -2147482617, // DENIZ_ARACI_KONTROL_MESAFESI_HATALI
  'NAVALCRAFT MAINTENANCE PARAMETER INVALID' = -2147482616, // DENIZ_ARACI_BAKIM_PARAMETRESI_HATALI
  'NAVALCRAFT LOAD/UNLOAD TIME INVALID' = -2147482615, // DENIZ_ARACI_YUKLEME_BOSALTMA_SURESI_HATALI
  'NAVALCRAFT CARRYING CAPACITY INVALID' = -2147482614, // DENIZ_ARACI_TASIMA_KAPASITESI_HATALI
  'NAVALCRAFT SHORT NAME NOT UNIQUE' = -2147482613, // DENIZ_ARACI_KISA_ISIM_ESSIZ_DEGIL
  'NAVALCRAFT SHORT NAME CANNOT BE CHANGED' = -2147482612, // DENIZ_ARACI_KISA_ISIM_DEGISTIRILEMEZ
  'SPACECRAFT ID INVALID' = -2147482611, // UZAY_ARACI_ID_HATALI
  'SPACECRAFT CATEGORY INVALID' = -2147482610, // UZAY_ARACI_KATEGORISI_HATALI
  'SPACECRAFT DETECTABILITY INVALID' = -2147482609, // UZAY_ARACI_ALGILANABILIRLIGI_HATALI
  'SPACECRAFT MISSION PREP TIME INVALID' = -2147482608, // UZAY_ARACI_GOREVE_HAZIRLANMA_SURESI_HATALI
  'SPACECRAFT EARTH CONTROL MAX DISTANCE INVALID' = -2147482607, // UZAY_ARACI_YER_KONTROL_MAX_MESAFE_HATALI
  'SPACECRAFT WEIGHT INVALID' = -2147482606, // UZAY_ARACI_AGIRLIGI_HATALI
  'SPACECRAFT CRASH PROBABILITY INVALID' = -2147482605, // UZAY_ARACI_DUSME_OLASILIGI_HATALI
  'SPACECRAFT PASSENGER SURVIVAL PROBABILITY INVALID' = -2147482604, // UZAY_ARACI_YOLCU_HAYATTA_KALMA_OLASILIGI_HATALI
  'SPACECRAFT UNIT COST INVALID' = -2147482603, // UZAY_ARACI_BIRIM_MALIYET_HATALI
  'SPACECRAFT CRUISE SPEED INVALID' = -2147482602, // UZAY_ARACI_SEYIR_HIZI_HATALI
  'OBSTACLE ID INVALID' = -2147482601, // INSAN_YAPIMI_ENGEL_ID_HATALI
  'OBSTACLE CATEGORY INVALID' = -2147482600, // INSAN_YAPIMI_ENGEL_KATEGORISI_HATALI
  'OBSTACLE EFFECT FREQUENCY INVALID' = -2147482599, // INSAN_YAPIMI_ENGEL_ETKI_OLASILIGI_HATALI
  'OBSTACLE NEUTRALIZATION PROBABILITY INVALID' = -2147482598, // INSAN_YAPIMI_ENGEL_ETKISIZ_KILMA_OLASILIGI_HATALI
  'OBSTACLE EFFECT TO FEED RATE INVALID' = -2147482597, // INSAN_YAPIMI_ENGEL_ILERLEME_HIZINA_ETKISI_HATALI
  'OBSTACLE DETECTABILITY INVALID' = -2147482596, // INSAN_YAPIMI_ENGEL_ALGILANABILIRLIGI_HATALI
  'OBSTACLE DETECTION PARAMETER INVALID' = -2147482595, // INSAN_YAPIMI_ENGEL_TESPIT_PARAMETRESI_HATALI
  'OBSTACLE VOLUME INVALID' = -2147482594, // INSAN_YAPIMI_ENGEL_HACIM_HATALI
  'OBSTACLE WEIGHT INVALID' = -2147482593, // INSAN_YAPIMI_ENGEL_AGIRLIGI_HATALI
  'OBSTACLE HOURS TO LAY OBSTACLE INVALID' = -2147482592, // INSAN_YAPIMI_ENGEL_DOSENMESI_ICIN_IHTIYAC_DUYULAN_SAAT_HATALI
  'OBSTACLE AVERAGE UNIT COST INVALID' = -2147482591, // INSAN_YAPIMI_ENGEL_ORTALAMA_BIRIM_MALIYET_HATALI
  'OBSTACLE HOURS TO CLEAR OBSTACLE INVALID' = -2147482590, // INSAN_YAPIMI_ENGEL_TEMIZLENMESI_ICIN_IHTIYAC_DUYULAN_SAAT_HATALI
  'OBSTACLE CLEAR UNIT COST INVALID' = -2147482589, // INSAN_YAPIMI_ENGEL_TEMIZLENME_BIRIM_MALIYET_HATALI
  'COMMUNICATION DEVICE ID INVALID' = -2147482588, // MUHAREBE_CIHAZI_ID_HATALI
  'COMMUNICATION DEVICE CATEGORY INVALID' = -2147482587, // MUHAREBE_CIHAZI_KATEGORISI_HATALI
  'COMMUNICATION DEVICE FREQUENCY MAX LIMIT INVALID' = -2147482586, // MUHAREBE_CIHAZI_FREKANS_UST_SINIR_HATALI
  'COMMUNICATION DEVICE FREQUENCY MIN LIMIT INVALID' = -2147482585, // MUHAREBE_CIHAZI_FREKANS_ALT_SINIR_HATALI
  'COMMUNICATION DEVICE CHANNEL BANDWITH INVALID' = -2147482584, // MUHAREBE_CIHAZI_KANAL_BANT_GENISLIGI_HATALI
  'COMMUNICATION DEVICE LINE AMOUNT INVALID' = -2147482583, // MUHAREBE_CIHAZI_HAT_SAYISI_HATALI
  'COMMUNICATION DEVICE CARRIER PROTOCOL INVALID' = -2147482582, // MUHAREBE_CIHAZI_TASIYICI_PROTOKOL_HATALI
  'COMMUNICATION DEVICE DATA CONTROL SET INVALID' = -2147482581, // MUHAREBE_CIHAZI_VERI_KONTROL_KUMESI_HATALI
  'COMMUNICATION DEVICE LINK INVALID' = -2147482580, // MUHAREBE_CIHAZI_LINK_HATALI
  'COMMUNICATION DEVICE RANGE INVALID' = -2147482579, // MUHAREBE_CIHAZI_MENZIL_HATALI
  'COMMUNICATION DEVICE OUTPUT POWER INVALID' = -2147482578, // MUHAREBE_CIHAZI_CIKIS_GUCU_HATALI
  'COMMUNICATION DEVICE DELAY INVALID' = -2147482577, // MUHAREBE_CIHAZI_GECIKME_HATALI
  'COMMUNICATION DEVICE CAPACITY INVALID' = -2147482576, // MUHAREBE_CIHAZI_KAPASITE_HATALI
  'COMMUNICATION DEVICE MAINTENANCE PARAMETERS INVALID' = -2147482575, // MUHAREBE_CIHAZI_BAKIM_PARAMETRELERI_HATALI
  'COMMUNICATION DEVICE WEIGHT INVALID' = -2147482574, // MUHAREBE_CIHAZI_AGIRLIGI_HATALI
  'COMMUNICATION DEVICE VOLUME INVALID' = -2147482573, // MUHAREBE_CIHAZI_HACMI_HATALI
  'COMMUNICATION DEVICE AVERAGE UNIT COST INVALID' = -2147482572, // MUHAREBE_CIHAZI_ORTALAMA_BIRIM_MALIYET_HATALI
  'AGENT PROTOTYPE ID INVALID' = -2147482571, // ETMEN_TURU_ID_HATALI
  'AGENT PROTOTYPE AGENT FACTION ID INVALID' = -2147482570, // ETMEN_TURU_ETMEN_SINIF_ID_HATALI
  'AGENT PROTOTYPE SYMBOL INVALID' = -2147482569, // ETMEN_TURU_SEMBOL_HATALI
  'AGENT PROTOTYPE SIZE INVALID' = -2147482568, // ETMEN_TURU_BUYUKLUGU_HATALI01
  'AGENT PROTOTYPE SIDC INVALID' = -2147482567, // ETMEN_TURU_SIDC_HATALI
  'AGENT PROTOTYPE ATTRIBUTE INVALID' = -2147482566, // ETMEN_TURU_NITELIGI_HATALI
  'AGENT PROTOTYPE OBSTACLE CLEARING ACTIVITY INVALID' = -2147482565, // ETMEN_TURU_ENGEL_HARBI_ETKINLIGI_HATALI
  'AGENT PROTOTYPE BUILDING CLEARING ACTIVITY INVALID' = -2147482564, // ETMEN_TURU_BINA_TEMIZLEME_ETKINLIGI_HATALI
  'AGENT PROTOTYPE MOVING START TIME INVALID' = -2147482563, // ETMEN_TURU_INTIKAL_BASLAMA_SURESI_HATALI
  'AGENT PROTOTYPE MOVING END TIME INVALID' = -2147482562, // ETMEN_TURU_INTIKAL_BITIRME_SURESI_HATALI
  'AGENT PROTOTYPE MOVING ACTIVITIES INVALID' = -2147482561, // ETMEN_TURU_INTIKALE_ETKINLIKLERI_HATALI
  'AGENT PROTOTYPE ACTIVITY INVALID' = -2147482560, // ETMEN_TURU_ETKINLIGI_HATALI
  'AGENT PROTOTYPE VOLUME INVALID' = -2147482559, // ETMEN_TURU_HACIM_HATALI
  'AGENT PROTOTYPE SUPPLY STATUS NOT FOUND' = -2147482558, // ETMEN_TURU_IKMAL_DURUMLARI_BULUNMUYOR
  'AGENT PROTOTYPE ORDNANCE STATUS NOT FOUND' = -2147482557, // ETMEN_TURU_TMK_DURUMLARI_BULUNMUYOR
  'AGENT PROTOTYPE NAVALCRAFT NOT FOUND' = -2147482556, // ETMEN_TURU_DENIZ_ARACLARI_BULUNMUYOR
  'AGENT PROTOTYPE OBSTACLES NOT FOUND' = -2147482555, // ETMEN_TURU_ENGELLER_BULUNMUYOR
  'AGENT PROTOTYPE AIRCRAFTS NOT FOUND' = -2147482554, // ETMEN_TURU_HAVA_ARACLARI_BULUNMUYOR
  'AGENT PROTOTYPE COMBAT DEVICES NOT FOUND' = -2147482553, // ETMEN_TURU_MUHAREBE_CIHAZLARI_BULUNMUYOR
  'AGENT PROTOTYPE SPACECRAFTS NOT FOUND' = -2147482552, // ETMEN_TURU_UZAY_ARACLARI_BULUNMUYOR
  'SUPPLY ID VALUE INVALID' = -2147482551, // IKMAL_ID_DEGERI_HATALI
  'SUPPLY FUEL CATEGORY ID VALUE INVALID' = -2147482550, // IKMAL_YANICI_KATEGORISI_ID_DEGERI_HATALI
  'SUPPLY COMBUSTION DURATION INVALID' = -2147482549, // IKMAL_YANMA_SURESI_HATALI
  'SUPPLY MAGIC CATEGORY INVALID' = -2147482548, // IKMAL_MAGIC_KATEGORI_HATALI
  'SUPPLY HIGHER CATEGORY INVALID' = -2147482547, // IKMAL_UST_KATEGORISI_HATALI
  'SUPPLY UNIT INVALID' = -2147482546, // IKMAL_BIRIMI_HATALI
  'SUPPLY WEIGHT FACTOR INVALID' = -2147482545, // IKMAL_AGIRLIK_CARPANI_HATALI
  'SUPPLY AVERAGE UNIT COST INVALID' = -2147482544, // IKMAL_ORTALAMA_BIRIM_MALIYETI_HATALI
  'SUPPLY SHORT NAME NOT UNIQUE' = -2147482543, // IKMAL_KISA_ISMI_ESSIZ_DEGIL
  'SUPPLY INFINITE LOOP EXISTS' = -2147482542, // IKMAL_SONSUZ_DONGU_VAR
  'SUPPLY SHORT NAME CANNOT BE CHANGED' = -2147482541, // IKMAL_KISA_ISMI_DEGISTIRILEMEZ
  'SUPPLY CASUALTY INDEX ID INVALID' = -2147482540, // IKMAL_ZAYIAT_INDEKS_ID_HATALI
  'SUPPLY CASUALTY INDEX STATIC ID INVALID' = -2147482539, // IKMAL_ZAYIAT_INDEKS_STATIC_ID_HATALI
  'PAYLOAD ID INVALID' = -2147482538, // FAYDALI_YUK_ID_HATALI
  'AGENT AGENT PROTOTYPE ID INVALID' = -2147482537, // ETMEN_ETMEN_TURU_ID_HATALI
  'AGENT SPEED VALUE INVALID' = -2147482536, // ETMEN_HIZ_DEGERI_HATALI
  'AGENT BEARING VALUE INVALID' = -2147482535, // ETMEN_ISTIKAMET_DEGERI_HATALI
  'AGENT SUBPOSTURE INVALID' = -2147482534, // ETMEN_FAATLIYETI_HATALI
  'AGENT HUMAN CASUALTY RATE INVALID' = -2147482533, // ETMEN_INSAN_ZAYIAT_ORANI_HATALI
  'AGENT AUTONOMOUS CASUALTY RATE INVALID' = -2147482532, // ETMEN_OTONOM_ZAYIAT_ORANI_HATALI
  'AGENT ORBIT TYPE INVALID' = -2147482531, // ETMEN_ORBIT_TYPE_HATALI
  'AGENT SIMULATION CREATION STATUS INVALID' = -2147482530, // ETMEN_SIMULASYONDA_YARATILMA_DURUMU_HATALI
  'AGENT MAP ACTIVE STATUS INVALID' = -2147482529, // ETMEN_MAP_ACTIVE_DURUMU_HATALI
  'AGENT MAP WAIT TIME INVALID' = -2147482528, // ETMEN_MAP_BEKLEME_SURESI_HATALI
  'AGENT IN AIR WAITING INFORMATION INVALID' = -2147482527, // ETMEN_HAVADA_BEKLIYOR_MU_BILGISI_HATALI
  'AGENT ATTACHMENT ID VALUE INVALID' = -2147482526, // ETMEN_EKLENTI_ID_DEGERI_HATALI
  'SPACE AGENT PARAMETERS INVALID' = -2147482525, // UZAY_ETMENI_PARAMETLERI_HATALI
  'AGENT SHORT NAME CANNOT BE CHANGED' = -2147482524, // ETMEN_KISA_ISMI_DEGISTIRILEMEZ
  'RUNTIME COMMAND NOT READY' = -2147482523, // RUNTIME_EMRI_HAZIR_DEGILDIR
  'TERRAIN TYPE INVALID' = -2147482522, // ARAZI_TIPI_HATALI
  'TERRAIN ALTITUDE INVALID' = -2147482521, // ARAZI_YUKSEKLIK_HATALI
  'MAGIC SUPPLY AMOUNT INVALID' = -2147482520, // MAGIC_IKMAL_SAYISI_HATALI
  'TERRAIN BATCH VALUE WRONG' = -2147482519, // ARAZI_BATCH_DEGERI_HATALI
  'TERRAIN X LIMIT WRONG' = -2147482518, // ARAZI_X_LIMIT_DEGERI_HATALI
  'TERRAIN Y LIMIT WRONG' = -2147482517, // ARAZI_Y_LIMIT_DEGERI_HATALI
  'TERRAIN X VALUE WRONG' = -2147482516, // ARAZI_X_DEGERI_HATALI
  'TERRAIN Y VALUE WRONG' = -2147482515, // ARAZI_Y_DEGERI_HATALI
  'MAGIC SUPPLY CANNOT BE MODIFIED' = -2147482514, // MAGIC_IKMAL_DUZENLENEMEZ
  'WEATHER CELLS DATA WRONG' = -2147482513, // HAVA_HUCRELERI_BILGISI_HATALI
  'CANNOT LOAD DATABASE BECAUSE OF ANOTHER LOADING PROCESS' = -2147482512, // BASKA_VERITABANI_YUKLENIYOR_VT_YUKLENEMEDI
  'CIVILIAN SIDE IS NOT FOUND' = -2147482511, // SIVIL_TARAF_MEVCUT_DEGIL
  'AGENT IS NOT CIVILLIAN' = -2147482510, // ETMEN_SIVIL_TARAFTA_DEGIL
  'AIRPORT ICAO INFORMATION INVALID' = -2147482509, // HAVA_ALANI_ICAO_BILGISI_HATALI
  'AIRPORT IATA INFORMATION INVALID' = -2147482508, // HAVA_ALANI_IATA_BILGISI_HATALI
  'AIRPORT PASSENGER CAPACITY INFORMATION INVALID' = -2147482507, // HAVA_ALANI_YOLCU_KAPASITESI_BILGISI_HATALI
  'AIRPORT CARGO CAPACITY INFORMATION INVALID' = -2147482506, // HAVA_ALANI_YUK_KAPASITESI_BILGISI_HATALI
  'AIRPORT DEICING CAPACITY INFORMATION INVALID' = -2147482505, // HAVA_ALANI_DEICING_KAPASITESI_BILGISI_HATALI
  'AIRPORT DEPARTURE DELAY SUMMER INFORMATION INVALID' = -2147482504, // HAVA_ALANI_KALKIS_GECIKME_YAZ_BILGISI_HATALI
  'AIRPORT ARRIVAL DELAY SUMMER INFORMATION INVALID' = -2147482503, // HAVA_ALANI_INIS_GECIKME_YAZ_BILGISI_HATALI
  'AIRPORT DEPARTURE DELAY WINTER INFORMATION INVALID' = -2147482502, // HAVA_ALANI_KALKIS_GECIKME_KIS_BILGISI_HATALI
  'AIRPORT ARRIVAL DELAY WINTER INFORMATION INVALID' = -2147482501, // HAVA_ALANI_INIS_GECIKME_KIS_BILGISI_HATALI
  'AIRPORT HANGAR CAPACITY INFORMATION INVALID' = -2147482500, // HAVA_ALANI_HANGAR_KAPASITESI_BILGISI_HATALI
  'AIRPORT SHELTER CAPACITY INFORMATION INVALID' = -2147482499, // HAVA_ALANI_SHELTER_KAPASITESI_BILGISI_HATALI
  'AIRPORT APRON CAPACITY INFORMATION INVALID' = -2147482498, // HAVA_ALANI_APRON_KAPASITESI_BILGISI_HATALI
  'AIRPORT SURROUNDINGS INFORMATION INVALID' = -2147482497, // HAVA_ALANI_CEVRESI_BILGISI_HATALI
  'THE REQUIRED TMK OF THE TMK CANNOT BE ITSELF' = -2147482496, // TMK_NIN_GEREKLI_TMKSI_KENDISI_OLAMAZ
  'THE VOLUME VALUE OF THE AGENT CANNOT BE ZERO OR NEGATIVE' = -2147482495, // ETMENIN_HACIM_DEGERI_SIFIR_YADA_EKSI_GIRILEMEZ
  'AGENT PROTOTYPE VOLUME VALUE CANNOT BE ZERO OR NEGATIVE' = -2147482494, // ETMEN_TURU_HACIM_DEGERI_SIFIR_YADA_EKSI_GIRILEMEZ
  'AIRPORT LOCATION NOT SELECTED' = -2147482493, // HAVA_ALANI_KONUMU_SECILMEMISTIR
  'AIRPORT AREA NOT SELECTED' = -2147482492, // HAVA_ALANI_BOLGESI_SECILMEMISTIR
  'AIRPORT OUT OF TERRAIN' = -2147482491, // HAVA_ALANI_ARAZI_DISINDADIR
  'AIRPORT ICAO CANNOT BE CHANGED' = -2147482490, // HAVA_ALANI_ICAO_DEGISTIRILEMEZ
  'RUNWAY BEARING INVALID' = -2147482489, // PIST_ISTIKAMETI_HATALIDIR
  'RUNWAY MATERIAL INVALID' = -2147482488, // PIST_MALZEMESI_HATALIDIR
  'RUNWAY WIDTH INVALID' = -2147482487, // PIST_GENISLIGI_HATALIDIR
  'RUNWAY LENGTH INVALID' = -2147482486, // PIST_UZUNLUGU_HATALIDIR
  'RUNWAY BIDIRECTIONAL INFORMATION INVALID' = -2147482485, // PIST_CIFT_TARAFLI_BILGISI_HATALIDIR
  'RUNWAY COORDINATES INVALID' = -2147482484, // PIST_KOORDINATLARI_HATALIDIR
  'RUNWAY OUT OF TERRAIN' = -2147482483, // PIST_ARAZI_DISINDADIR
  'RUNWAY OUT OF AIRPORT' = -2147482482, // PIST_HAVA_ALANI_DISINDADIR
  'PORT NOT FOUND' = -2147482481, // LIMAN_BULUNAMADI
  'PORT DOCK DEPTH INVALID' = -2147482480, // LIMAN_RIHTIM_DERINLIGI_DEGERI_HATALIDIR
  'PORT DOCK LENGTH INVALID' = -2147482479, // LIMAN_RIHTIM_UZUNLUGU_DEGERI_HATALIDIR
  'PORT CONTAINER CAPACITY INVALID' = -2147482478, // LIMAN_KONTEYNER_KAPASITESI_DEGERI_HATALIDIR
  'PORT CARGO CAPACITY INVALID' = -2147482477, // LIMAN_KARGO_KAPASITESI_DEGERI_HATALIDIR
  'PORT RORO CAPACITY INVALID' = -2147482476, // LIMAN_RORO_KAPASITESI_DEGERI_HATALIDIR
  'PORT PASSENGER CAPACITY INVALID' = -2147482475, // LIMAN_YOLCU_KAPASITESI_DEGERI_HATALIDIR
  'PORT LAND LOCATION INVALID' = -2147482474, // LIMAN_KARA_KONUMU_HATALIDIR
  'PORT SEA LOCATION INVALID' = -2147482473, // LIMAN_DENIZ_KONUMU_HATALIDIR
  'PORT SURROUNDINGS INFORMATION INVALID' = -2147482472, // LIMAN_CEVRE_BILGISI_HATALIDIR
  'PORT SHORT NAME NOT UNIQUE' = -2147482471, // LIMAN_KISA_ISMI_ESSIZ_DEGILDIR
  'PORT SHORT NAME CANNOT BE CHANGED' = -2147482470, // LIMAN_KISA_ISMI_DEGISTIRILEMEZ
  'AMMUNITION SHORT NAME IS WRONG' = -2147482469, // MUHIMMAT_KISA_ISMI_HATALI
  'AMMUNITION LONG NAME IS WRONG' = -2147482468, // MUHIMMAT_UZUN_ISMI_HATALI
  'AGENT PROTOTYPE CBRN DECONTAMINATION ACTIVITY IS WRONG' = -2147482467, // ETMEN_TURU_KBRN_TEMIZLEME_ETKINLIGI_HATALI
  'AGENT PROTOTYPE IS NOT COMPETENT TO DECONTAMINATION' = -2147482466, // ETMEN_TURU_KBRN_TEMIZLEME_YETKINLIGINE_SAHIP_DEGIL
  'CBRN HALF LIFE TIME CANNOT BE 0 OR NEGATIVE' = -2147482465, // KIRLETME_YARI_OMRU_SIFIR_VEYA_EKSI_GIRILEMEZ
  'AMMUNITION IS NOT CBRN' = -2147482464, // MUHIMMAT_KBRN_ETKILI_DEGIL
  'COMMAND NAME IS NOT STRING' = -2147482463, // EMIR_ISMI_STRING_FORMATINDA_DEGIL
  'COMMAND NAME LIMIT EXCEED' = -2147482462, // EMIR_ISMI_SIZE_ASILDI
  'COMMAND NAME IS NOT FOUND' = -2147482461, // EMIR_ISMI_BULUNAMADI
  'SUPPLY CANNOT BE FOUND IN THE OBSTACLE AGENT PROTOTYPE' = -2147482460, // ENGEL_ETMENI_PROTOTIPINDE_IKMAL_BULUNUMAZ
  'THERE IS NO OBSTACLE IN OBSTACLE AGENT' = -2147482459, // ENGEL_ETMENI_PROTOTIPINDE_ENGEL_BULUNMUYOR
  'THE OBSTACLE AGENT PROTOTYPE MAY NOT INCLUDE ELEMENTS OTHER THAN OBSTACLE' = -2147482458, // ENGEL_ETMENI_PROTOTIPI_ENGEL_DISINDA_UNSUR_ICEREMEZ
  'THE LAND OBSTACLE AGENT PROTOTYPE CANNOT CONTAIN MORE THAN ONE TYPE OF OBSTACLE' = -2147482457, // KARAYA_AIT_ENGEL_ETMENI_PROTOTIPINDE_BIRDEN_FAZLA_ENGEL_TURU_BULUNAMAZ
  'CONTROL OF AGENT IS BELONGS TO ANOTHER SIMULATION SYSTEM' = -2147482456, // ETMEN_KONTROLU_BASKA_SIMULASYON_SISTEMINE_AIT

  'AGENT DOES NOT HAVE A SEARCH AND RESCUE DEVICE' = -6999999, // ARAMA_KURTARMA_CIHAZI_BULUNAMADI
  'SEARCH AND RESCUE COMMAND LOCATION IS INCORRECT' = -6999998, // ARAMA_KURTARMA_KONUMU_HATALI
  'SEARCH AND RESCUE COMMAND RADIUS IS INCORRECT' = -6999997, // ARAMA_KURTARMA_YARICAPI_HATALI
  'SEARCH AND RESCUE COMMAND LOCATION IS OUT OF THEATRE' = -6999996, // ARAMA_KURTARMA_KONUMU_ARAZI_DISINDA
  'SEARCH AND RESCUE COMMAND AREA COULD NOT BE REACHED' = -6999995, // ARAMA_KURTARMA_BOLGESINE_ULASILAMADI
  'SEARCH AND RESCUE COMMAND BUILDING COULD NOT BE REACHED' = -6999994, // ARAMA_KURTARMA_BINASINA_ULASILAMADI
  'SEARCH AND RESCUE REQUIRED SYSTEM DOES NOT EXIST' = -6999993, // ARAMA_KURTARMA_ICIN_GEREKLI_TMK_MEVCUT_DEGIL
  'AGENT DOES NOT HAVE SEARCH AND RESCUE DEVICE REQUIREMENTS' = -6999992, // ARAMA_KURTARMA_ETMEN_ARAMA_KURTARMA_ICIN_GEREKLI_CIHAZIN_GEREKLILIKLERI_MEVCUT_DEGIL

  'EARTHQUAKE CENTER IS OUT OF THEATRE' = -6998999, // DEPREM_EMRI_ICINDE_DEPREM_MERKEZI_HARITA_DISINDA
  'RANGE NOT FOUND IN EARTHQUAKE COMMAND' = -6998998, // DEPREM_EMRI_ICINDE_RANGE_BULUNAMADI
  'RANGE NOT A NUMBER IN THE EARTHQUAKE COMMAND' = -6998997, // DEPREM_EMRI_ICINDEKI_RANGE_SAYI_DEGIL
  'RANGE CANNOT BE LOWER THAN ZERO IN THE EARTHQUAKE COMMAND' = -6998996, // DEPREM_EMRI_ICINDEKI_RANGE_SIFIRDAN_KUCUK_OLMAMALIDIR
  'EARTHQUAKE INTENSITY NOT FOUND IN THE EARTHQUAKE COMMAND' = -6998995, // DEPREM_EMRI_ICINDE_DEPREM_SIDDETI_BULUNAMADI
  'EARTHQUAKE INTENSITY IS NOT A NUMBER IN THE EARTHQUAKE COMMAND' = -6998994, // DEPREM_EMRI_ICINDEKI_DEPREM_SIDDETI_SAYI_DEGIL
  'EARTHQUAKE INTENSITY CANNOT BE LOWER THAN ZERO IN THE EARTHQUAKE COMMAND' = -6998993, // DEPREM_EMRI_ICINDEKI_DEPREM_SIDDETI_SIFIRDAN_KUCUK_OLMAMALIDIR
  'EARTHQUAKE DEPTH NOT FOUND IN THE EARTHQUAKE COMMAND' = -6998992, // DEPREM_EMRI_ICINDE_DEPREM_DERINLIGI_BULUNAMADI
  'EARTHQUAKE DEPTH IS NOT A NUMBER IN THE EARTHQUAKE COMMAND' = -6998991, // DEPREM_EMRI_ICINDEKI_DEPREM_DERINLIGI_SAYI_DEGIL
  'EARTHQUAKE DEPTH CANNOT BE LOWER THAN ZERO IN THE EARTHQUAKE COMMAND' = -6998990, // DEPREM_EMRI_ICINDEKI_DEPREM_DERINLIGI_SIFIRDAN_KUCUK_OLMAMALIDIR
  'DURATION NOT FOUND IN THE EARTHQUAKE COMMAND' = -6998989, // DEPREM_EMRI_ICINDE_SURE_BULUNAMADI
  'DURATION IS NOT A NUMBER IN THE EARTHQUAKE COMMAND' = -6998988, // DEPREM_EMRI_ICINDEKI_SURE_SAYI_DEGIL
  'DURATION CANNOT BE LOWER THAN ZERO IN THE EARTHQUAKE COMMAND' = -6998987, // DEPREM_EMRI_ICINDEKI_SURE_SIFIRDAN_KUCUK_OLMAMALIDIR
  'EARTHQUAKE COMMAND SHOCKTIME NOT FOUND' = -6998986, // DEPREM_EMRI_ICINDEKI_DEPREM_UYGULAMA_ZAMANI_BULUNAMADI
  'EARTHQUAKE COMMAND SHOCKTIME IS NOT A NUMBER' = -6998985, // DEPREM_EMRI_ICINDEKI_DEPREM_UYGULAMA_ZAMANI_SAYI_DEGIL

  'MARITIME-AIR POLLUTION START POSITION MISSING OR INCORRECT' = -6997999, // DENIZ_HAVA_KIRLILIGI_BASLANGIC_KONUMU_EKSIK_VEYA_HATALI,
  'MARITIME-AIR POLLUTION POLLUTANT IS INSUFFICIENT' = -6997998, // DENIZ_HAVA_KIRLILIGI_KIRLETME_EKSIK
  'MARITIME-AIR POLLUTION POLLUTANT HALF-LIFE TIME IS WRONG' = -6997997, // DENIZ_HAVA_KIRLILIGI_KIRLETME_YARI_OMUR_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION LIVING TOUCH IS WRONG' = -6997996, // DENIZ_HAVA_KIRLILIGI_KIRLETME_CANLI_BULASI_TEMAS_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION LIVING TOUCH INHALE IS WRONG' = -6997995, // DENIZ_HAVA_KIRLILIGI_KIRLETME_CANLI_BULASI_SOLUNUM_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION LIVING TOUCH INTESTING IS WRONG' = -6997994, // DENIZ_HAVA_KIRLILIGI_KIRLETME_CANLI_BULASI_YEME_ICME_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION LIVING EFFECT IS WRONG' = -6997993, // DENIZ_HAVA_KIRLILIGI_KIRLETME_CANLI_ETKI_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION LIVING TOUCH TIME IS WRONG' = -6997992, //  DENIZ_HAVA_KIRLILIGI_KIRLETME_CANLI_BULASI_SURESI_EKSIK_VEYA_HATALI

  'MARITIME-AIR POLLUTION POLLUTANT VEHICLE SENSOR EQUIPMENT CONTAMINATION MISSING OR INVALID' = -6997991, // DENIZ_HAVA_KIRLILIGI_KIRLETME_ARAC_SENSOR_TECHIZAT_BULASISI_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION POLLUTANT SOIL CONTAMINATION MISSING OR INVALID' = -6997990, // DENIZ_HAVA_KIRLILIGI_KIRLETME_TOPRAK_BULASISI_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION POLLUTANT AIR CONTAMINATION MISSING OR INVALID' = -6997989, // DENIZ_HAVA_KIRLILIGI_KIRLETME_HAVA_BULASISI_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION POLLUTANT WATER CONTAMINATION MISSING OR INVALID' = -6997988, // DENIZ_HAVA_KIRLILIGI_KIRLETME_SU_BULASISI_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION POLLUTANT VERTICAL AXIS SPEED MISSING OR INVALID' = -6997987, // DENIZ_HAVA_KIRLILIGI_KIRLETME_DUSEY_EKSENDE_HIZ_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION POLLUTANT EMISSION SPEED MISSING OR INVALID' = -6997986, // DENIZ_HAVA_KIRLILIGI_KIRLETME_SALINIM_HIZI_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION POLLUTANT EMISSION SPEED CANNOT BE ZERO OR NEGATIVE' = -6997985, // DENIZ_HAVA_KIRLILIGI_KIRLETME_SALINIM_HIZI_SIFIR_VEYA_EKSI_OLAMAZ
  'MARITIME-AIR POLLUTION POLLUTANT EMISSION DURATION MISSING OR INVALID' = -6997984, // DENIZ_HAVA_KIRLILIGI_KIRLETME_SALINMA_SURESI_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION POLLUTANT COLOR VALUE MISSING OR INVALID ' = -6997983, // DENIZ_HAVA_KIRLILIGI_KIRLETME_RENK_DEGERI_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION POLLUTANT TRANSPARENCY VALUE MISSING OR INVALID' = -6997982, // DENIZ_HAVA_KIRLILIGI_KIRLETME_SAYDAMLIK_DEGERI_EKSIK_VEYA_HATALI
  'MARITIME-AIR POLLUTION START POSITION CANNOT BE OUTSIDE LAND' = -6997981, // DENIZ_HAVA_KIRLILIGI_BASLANGIC_KONUMU_ARAZI_DISINDA_OLAMAZ
  'MARITIME-AIR POLLUTION CLEANUP SUPPLY NOT FOUND' = -6997980, // DENIZ_HAVA_KIRLILIGI_TEMIZLIK_IKMAL_BULUNAMADI
  'MARITIME-AIR POLLUTION PROTECTION SUPPLY NOT FOUND' = -6997979, // DENIZ_HAVA_KIRLILIGI_KORUNMA_IKMAL_BULUNAMADI
  'MARITIME-AIR POLLUTION START POSITION CANNOT BE OUTSIDE AIR TABLE' = -6997978, // DENIZ_HAVA_KIRLILIGI_BASLANGIC_KONUMU_HAVA_TABLOSU_DISINDA_OLAMAZ
  'MARITIME-AIR POLLUTION START RADIUS INVALID' = -6997977, // DENIZ_HAVA_KIRLILIGI_BASLANGIC_YARICAP_HATALI
  'MARITIME-AIR POLLUTION START CIRCLE HEIGHT INVALID' = -6997976, // DENIZ_HAVA_KIRLILIGI_BASLANGIC_CEMBER_YUKSEKLIGI_HATALI
  'SEA AIR POLLUTION HALF-LIFE CANNOT BE ZERO OR NEGATIVE' = -6997975, // DENIZ_HAVA_KIRLILIGI_YARI_OMUR_SIFIR_VEYA_EKSI_OLAMAZ
  'POLLUTION NAME IS NOT UNIQUE' = -6997974, // DENIZ_HAVA_KIRLILIGI_KISA_ISMI_ESSIZ_DEGIL
  'THERE ARE NO SURFACES WHERE CONTAMINATION CAN SPREAD DUE TO INFECTION RATE' = -6997973, // BULASI_ORANLARINDAN_DOLAYI_KIRLILIGIN_BULASABILECEGI_YUZEY_YOK

  'FLOOD COMMAND FLOOD TYPE NOT FOUND' = -6996999, // SEL_EMRI_SEL_TIPI_BULUNAMADI
  'FLOOD COMMAND FLOOD REGION LATITUDE INFO NOT FOUND' = -6996998, // SEL_EMRI_SEL_BOLGESI_ENLEM_BILGISI_BULUNAMADI
  'FLOOD COMMAND FLOOD REGION LONGITUDE INFO NOT FOUND' = -6996997, // SEL_EMRI_SEL_BOLGESI_BOYLAM_BILGISI_BULUNAMADI
  'FLOOD COMMAND FLOOD REGION NOT POLYGON' = -6996996, // SEL_EMRI_SEL_BOLGESI_POLIGON_DEGIL
  'FLOOD COMMAND FLOOD TERRAIN COVERAGE RATIO NOT NUMERIC' = -6996995, // SEL_EMRI_SEL_ARAZI_KAPLAMA_ORANI_SAYI_DEGIL
  'FLOOD COMMAND FLOOD TIME TO REACH CELL NOT INTEGER' = -6996994, // SEL_EMRI_SEL_KAREYE_ULASMA_ZAMANI_DOGAL_SAYI_DEGIL
  'FLOOD COMMAND FLOOD ANGLE VALUE NOT NUMERIC' = -6996993, // SEL_EMRI_SEL_ACI_DEGERI_SAYI_DEGIL
  'FLOOD COMMAND AVERAGE SPEED IN CELL NOT NUMERIC' = -6996992, // SEL_EMRI_KAREDE_ORTALAMA_HIZ_SAYI_DEGIL
  'FLOOD COMMAND MAXIMUM ALTITUDE NOT NUMERIC' = -6996991, // SEL_EMRI_MAKSIMUM_YUKSEKLIK_SAYI_DEGIL
  'FLOOD COMMAND MAXIMUM ALTITUDE TIME TO REACH NOT NUMERIC' = -6996990, // SEL_EMRI_MAKSIMUM_YUKSEKLIK_ULASMA_SURESI_SAYI_DEGIL
  'FLOOD COMMAND DESCENT RATE NOT NUMERIC' = -6996989, // SEL_EMRI_ALCALMA_HIZI_SAYI_DEGIL
  'FLOOD MATRIX IS WRONG' = -6996988, // SEL_MATRISI_HATALI
  'FLOOOD IS OUT OF TERRAIN' = -6996987, // SEL_BOLGESI_ARAZI_DISINDA

  'AGENT IS NOT UNDER THE COMMAND OF CONTROLLER THAT COMMAND' = -7001000, // ETMEN_EMRI_VEREN_KONTROLCUNUN_KOMUTASINDA_DEGIL
  'CGA CLIENT CANNOT GIVE CONTROL COMMAND' = -7000999, // CGA_ISTEMCI_KONTROL_EMRI_VEREMEZ
  'CGA CLIENT CANNOT GIVE BULK COMMAND' = -7000998, // CGA_ISTEMCI_TOPLU_EMIR_VEREMEZ

  // OLUMSUZ INTEROPERABILITY = -7'005'000 ~ -7'010'000
  'AN ERROR OCCURED WHEN ATO IMPORT MESSAGE CONVERTING TO XML' = -7010000, // ATO_IMPORT_MESAJI_XML_CEVRILIRKEN_HATA_ILE_KARSILASILDI
  'UPLOADED FILE IS NOT AN ATO FILE' = -7009999, // ATO_IMPORT_ICIN_YUKLENEN_DOSYA_ATO_DOSYASI_DEGIL

  'AGENT TO HANDOVER MUST BE MARITIME OR LAND UNIT' = -3999999, // ESIR_TESLIM_EDILECEK_ETMEN_DENIZ_VEYA_KARA_ETMENI_OLMALI
  'AGENT TO HANDOVER HAS NOT PROPER POSTURE' = -3999998, // ESIR_TESLIM_EDILECEK_ETMENIN_FAALIYETI_UYGUN_DEGIL
  'AGENT TO DELIVER SUPPLY MUST BE MARITIME OR LAND UNIT' = -3999997, // IKMAL_TESLIM_EDECEK_ETMEN_DENIZ_VEYA_KARA_ETMENI_DEGIL
  'AGENT TO BE SUPPLIED NOT FOUND IN MARITIME' = -3999996, // DENIZDE_IKMAL_ALACAK_ETMEN_BULUNAMADI
  'AGENT TO SUPPLY NOT FOUND IN MARITIME' = -3999995, // DENIZDE_IKMAL_VERECEK_ETMEN_BULUNAMADI
  'AGENT TO BE SEARCHED OR BOARD NOT FOUND' = -3999994, // CIKMA_ARAMA_YAPILACAK_ETMEN_BULUNAMADI
  'AGENT TO BE EMBARKED NOT FOUND' = -3999993, // BINILECEK_ETMEN_BULUNAMADI
  'AGENT TO BE TOWED NOT FOUND' = -3999992, // CEKILECEK_ETMEN_BULUNAMADI
  'MARITIME SUPPLY CONVOY AGENT NOT FOUND' = -3999991, // DENIZDE_IKMAL_KONVOY_ETMEN_BULUNAMADI
  'MARITIME AGENT TO BE DELIVERED SUPPLY IS SURVIVOR' = -3999990, // IKMAL_TESLIM_EDECEK_DENIZ_ETMENI_KAZAZEDE
  'MARITIME DOCK AGENT TO EMBARK SINKING OR INEFFECTIVE' = -3999989, //  DENIZ_DOCK_BINECEK_ETMEN_BATIYOR_YA_DA_ETKISIZ
  'MARITIME TOWING AGENT TO TOW SINKING OR INEFFECTIVE' = -3999988, // DENIZ_CEKME_CEKECEK_ETMEN_ETKISIZ_VEYA_BATIYOR
  'AGENT CANNOT EXECUTE THIS ENGAGEMENT UNDER THE SEA' = 3999987, // ETMEN_SU_ALTINDA_BU_ANGAJMANA_GIREMEZ
  'FORMATION NAME MUST BE UNIQUE' = -3999986, // AYNI_KISA_ISIMLI_BIRDEN_FAZLA_NIZAM_OLAMAZ
  'MARITIME PATROL CANNOT EXECUTE FOR DESIRED DEPTH' = -3999985, // DENIZ_KARAKOL_ISTENILEN_DERINLIKTE_ICRA_EDILEMEZ

  'MAINTENANCE REQUESTING AGENT NOT FOUND' = -2999999, // BAKIM_TALEP_EDEN_ETMEN_BULUNAMADI
  'MAINTENANCE SERVICE PROVIDER AGENT NOT FOUND' = -2999998, // BAKIM_SERVISI_VERECEK_ETMEN_BULUNAMADI
  'MAINTENANCE TO BE MERGED AGENT NOT FOUND' = -2999997, // BAKIM_BIRLESILECEK_ETMEN_BULUNAMADI
  'MAINTENANCE REQUESTING AGENT NOT ACTIVE' = -2999996, // BAKIM_TALEP_EDEN_ETMEN_AKTIF_DEGIL
  'MAINTENANCE SERVICE PROVIDER AGENT NOT ACTIVE' = -2999995, // BAKIM_SERVISI_VERECEK_ETMEN_AKTIF_DEGIL
  'MAINTENANCE SERVICE PROVIDER AGENT NOT AT RENDEZVOUS LOCATION' = -2999994, // BAKIM_SERVISI_VERECEK_ETMEN_RANDEVU_KONUMUNDA_DEGIL
  'MAINTENANCE SERVICE PROVIDER AGENT CANNOT BE SAME AS REQUESTING' = -2999993, // BAKIM_SERVISI_VERECEK_ETMEN_ILE_TALEP_EDEN_AYNI_OLAMAZ
  'MAINTENANCE DELIVERY MODE INVALID' = -2999992, // BAKIM_TESLIM_SEKLI_HATALI
  'MAINTENANCE REQUESTED SYSTEM LIST INVALID' = -2999991, // BAKIM_ISTENEN_TMK_LISTESI_HATALI
  'MAINTENANCE REQUESTED COMM DEVICE LIST INVALID' = -2999990, // BAKIM_ISTENEN_MUHABERE_CIHAZI_LISTESI_HATALI
  'MAINTENANCE REQUESTED SYSTEM NOT FOUND ON AGENT' = -2999989, // BAKIMI_ISTENEN_TMK_ETMENDE_BULUNMUYOR
  'MAINTENANCE REQUESTED SYSTEM QUANTITY INVALID' = -2999988, // BAKIM_ISTENEN_TMK_MIKTARI_HATALI
  'MAINTENANCE REQUESTED COMM DEVICE NOT FOUND ON AGENT' = -2999987, // BAKIMI_ISTENEN_MUHABERE_CIHAZI_ETMENDE_BULUNMUYOR
  'MAINTENANCE REQUESTED COMM DEVICE QUANTITY INVALID' = -2999986, // BAKIM_ISTENEN_MUHABERE_CIHAZI_MIKTARI_HATALI
  'ON MEDICAL EVACUATION ORDER EXCEPT LIVING SYSTEM CANNOT BE SELECTED' = -2999985, // SIHHI_TAHLIYE_EMRINDE_CANLI_DISINDA_TMK_SECILEMEZ
  'ON RECOVER COMMAND LIVING TMK CANNOT BE SELECTED' = -2999984, // BAKIM_EMRINDE_CANLI_TMK_SECILEMEZ
  'RECOVER COMMAND NO DAMAGED ENTITIES IN THE SELECTED SYSTEMS OR COMMUNICATION DEVICES' = -2999983, // BAKIM_EMRINDE_SECILEN_TMK_VEYA_MUHABERE_CIHAZLARI_ICINDE_HASARLI_OLAN_BULUNMUYOR
  'MEDICAL EVACUATION COMMAND NO WOUNDED ENTITIES IN THE SELECTED LIVINGS' = -2999982, // SIHHI_TAHLIYE_EMRINDE_SECILEN_CANLILAR_ICINDE_YARALI_OLAN_BULUNMUYOR
  'CONVOY WHICH WILL CARRY THE ENTITIES THAT DESIRE RECOVER WAS NOT DISPATCHED' = -2999981, // BAKIM_ISTENEN_UNSURLARI_TASIYACAK_KONVOY_CIKARTILAMADI
  'AGENT TO DESIRE RECOVER INEFFECTIVE' = -2999980, // BAKIM_TALEP_EDEN_ETMEN_ETKISIZ
  'MAINTENANCE AGENT INEFFECTIVE' = -2999979, // BAKIM_SERVISI_VERECEK_ETMEN_ETKISIZ
  'MAINTENANCE_REQUESTING_AGENT_NOT_ELIGIBLE_FOR_ORDER_RECEIPT' = -2999978, // BAKIM_TALEP_EDEN_ETMEN_EMIR_ALMAYA_UYGUN_DEGIL
  'MAINTENANCE_PROVIDING_AGENT_NOT_ELIGIBLE_FOR_ORDER_RECEIPT' = -2999977, // BAKIM_SERVISI_VERECEK_ETMEN_EMIR_ALMAYA_UYGUN_DEGIL
  'MAINTENANCE_PROVIDING_AGENT_EXECUTING_ANOTHER_ORDER' = -2999976, // BAKIM_SERVISI_VERECEK_ETMEN_BASKA_EMRI_ICRA_EDIYOR

  'SUPPLY AGENT TO BE MERGED NOT FOUND' = -2998999, // IKMAL_BIRLESILECEK_ETMEN_BULUNAMADI
  'AGENT TO BE SUPPLIED NOT ACTIVE' = -2998998, // IKMAL_ALACAK_ETMEN_AKTIF_DEGIL
  'AGENT TO BE SUPPLIER NOT ACTIVE' = -2998997, // IKMAL_VERECEK_ETMEN_AKTIF_DEGIL
  'SUPPLIER AGENT NOT ON RENDEZVOUS LOCATION' = -2998996, // IKMAL_VEREN_ETMEN_RANDEVU_KONUMUNDA_DEGIL
  'AGENT TO BE SUPPLIED INEFFECTIVE' = -2998995, // IKMAL_ALACAK_ETMEN_ETKISIZ
  'SUPPLIER AGENT INEFFECTIVE' = -2998994, // IKMAL_VERECEK_ETMEN_ETKISIZ
  'SUPPLY PROVIDING AGENT IN TRANSIT' = -2998993, // IKMAL_VERECEK_ETMEN_TASINIYOR
  'SUPPLY PROVIDING AGENT PRISONER OF WAR' = -2998992, // IKMAL_VERECEK_ETMEN_HARP_ESIRI
  'SUPPLY PROVIDING AGENT NOT ELIGIBLE FOR ORDER RECEIPT' = -2998991, // IKMAL_VERECEK_ETMEN_EMIR_ALMAYA_UYGUN_DEGIL
  'SUPPLY RECEIVING AGENT NOT ELIGIBLE FOR ORDER RECEIPT' = -2998990, // IKMAL_ALACAK_ETMEN_EMIR_ALMAYA_UYGUN_DEGIL
  'SUPPLY PROVIDING AGENT EXECUTING ANOTHER ORDER' = -2998989, // IKMAL_VERECEK_ETMEN_BASKA_EMRI_ICRA_EDIYOR

  'INSUFFICIENT SUPPLY TO TARGETED CONTAMINATION' = -2997999, // HEDEFLENEN_KIRLILIGI_TEMIZLEYECEK_YETERLI_IKMAL_YOK,
  'CBRN AGENT TARGET LIMITATION IS NOT ENTERED OR WRONG' = -2997998, // KBRN_AJANI_HEDEF_SINIRLAMASI_GIRILMEMIS_YADA_HATALI
  'TARGET TYPE IS NOT ENTERED OR WRONG' = -2997997, // HEDEF_TIPI_GIRILMEMIS_YADA_HATALI
  'AREA TO DECONTAMINATE IS NOT ENTERED OR WRONG' = -2997996, // TEMIZLENECEK_BOLGE_GIRILMEMIS_YADA_HATALI
  'AREA TO DECONTAMINATE IS OUT OF TERRAIN' = -2997995, // TEMIZLENECEK_BOLGE_ARAZI_DISINDA
  'AREA TO DECONTAMINATE RADIUS IS NOT ENTERED' = -2997994, // TEMIZLENECEK_BOLGE_YARICAPI_GIRILMEDI
  'AGENT TO DECONTAMINATE IS NOT ENTERED OR WRONG' = -2997993, // TEMIZLENECEK_ETMEN_GIRILMEMIS_YADA_HATALI
  'AGENT TO DECONTAMINATE NOT FOUND' = -2997992, // TEMIZLENECEK_ETMEN_BULUNUMADI
  'AGENT TARGET LIMITATION IS NOT ENTERED OR WRONG' = -2997991, // ETMEN_HEDEF_SINIRLAMASI_GIRILMEMIS_YADA_HATALI
  'AGENT TO DECONTAMINATE IS NOT AT RENDEZVOUS LOCATION' = -2997990, // TEMIZLENECEK_ETMEN_RANDEVU_KONUMUNDA_DEGIL
  'AGENT TO BE DECONTAMINATE IS NOT ACTIVE' = -2997989, // TEMIZLENECEK_ETMEN_AKTIF_DEGIL

  'CLEAR OBSTACLE CANNOT FOUND CLEAR OBSTACLE AGENT' = -2996999, // ENGEL_TEMIZLE_ENGEL_ETMENI_BULUNAMADI

  'AIRCRAFT NOT FOUND' = -4999999, // HAVA_ARACI_BULUNAMADI
  'AIR LIFT AGENT TO BE LIFTED IS ABOVE THE SEA LEVEL' = -4999998, // HAVA_TASIMA_TASINACAK_ETMEN_DENIZ_SEVIYESI_ALTINDA
  'AIR LIFT AGENT TO BE DISEMBARKED IS ABOVE THE SEA LEVEL' = -4999997, // HAVA_TASIMA_INDIRME_YAPILACAK_ETMEN_DENIZ_SEVIYESI_ALTINDA
  'AIRCRAFT AMOUNT WRONG' = -4999996, // HAVA_ARACI_ADET_DEGERI_HATALI
  'SIDE MISSIONS NOT CLEAR' = -4999995, // YAN_GOREVLER_ANLASILMADI
  'AIR SUBMISSION MISSION ROUTE NOT ON THE SEA' = -4999994, // HAVA_ALT_GOREV_GOREV_ROTASI_DENIZDE_DEGIL
  'AIR SUBMISSION MISSION COMAO FINISH TIME NOT FOUND' = -4999993, // HAVA_ALT_GOREV_COMAO_BITIS_ZAMANI_BULUNAMADI
  'AIR MISSION EXECUTION TIME NOT YET ARRIVED' = -4999992, // HAVA_GOREVI_ICRA_ZAMANI_HENUZ_GELMEDI
  'LOW AIR MISSION CONTROL AREA IS NOT OVER THE SEA' = -4999991, // HAVA_ALT_GOREV_KONTROL_BOLGESI_DENIZ_USTUNDE_DEGIL
  'AIR MISSION REFUEL GIVER MISSION NOT FOUND' = -4999990, // HAVA_GOREVI_IKMAL_VERECEK_HAVA_GOREVI_BULUNAMADI
  'AIR AUTO COMAO AGENT THAT HAS DESIRED PAYLOAD NOT FOUND' = -4999989, // HAVA_OTO_COMAO_ISTENEN_FAYDALI_YUKE_SAHIP_UYGUN_ETMEN_BULUNAMADI
  'AIR AUTO COMAO AGENT THAT HAS DESIRED AIRCRAFT NOT FOUND' = -4999988, // HAVA_OTO_COMAO_ISTENEN_HAVA_ARACINA_SAHIP_UYGUN_ETMEN_BULUNAMADI
  'AIR LANDING CANNOT BE ON WATER' = -4999987, // HAVA_INIS_SUYA_GERCEKLESTIRILEMEZ

  'SPACE ORBIT TYPE IS NOT CLEAR' = -5999999, // UZAY_YORUNGE_TIPI_ANLASILMADI
  'SPACE ROTATION IS NOT CLEAR' = -5999998, // UZAY_ROTASYON_ANLASILMADI
  'SPACE BEARING IS NOT CLEAR' = -5999997, // UZAY_BEARING_ANLASILMADI
  'SPACE APOAPSIS LENGTH IS NOT CLEAR' = -5999996, // UZAY_APOAPSIS_UZUNLUGU_ANLASILMADI
  'SPACE AGENT LOCATION IS WRONG' = -5999995, // UZAY_ETMENI_KONUMU_HATALI
}

export enum EEmirTuru {
  EMPTY = 0,
  SUPPLY = 1,
  MOVEMENT = commandConstants.LAND_MOVE.backendId,
  SENSE = 3,
  ATTACK = commandConstants.ATTACK.backendId,
  DEFENSE = commandConstants.DEFEND.backendId,
  RETREAT = commandConstants.WITHDRAW.backendId,
  'DIRECT FIRE' = commandConstants.DIRECT_FIRE.backendId,
  'INDIRECT FIRE' = commandConstants.INDIRECT_FIRE.backendId,
  'AGENT DELETE' = commandConstants.DELETE.backendId,
  'CHANGE OPERATING AGENT' = 10,
  'AGENT DIVIDE ENTITY' = commandConstants.DIVIDE.backendId,
  'AGENT MERGE ENTITY' = 12,
  'AIR MISSION CREATION' = commandConstants.AIR_MISSION.backendId,
  'MOVE TO FORMATION POSITIONS' = 14,
  TELEPORT = commandConstants.TELEPORT.backendId,
  'ENGAGEMENT RULE' = commandConstants.LAND_ENGAGEMENT.backendId,
  'UPDATE ORDER OF COMMAND QUEUE' = 17,
  'CANCEL EXECUTED COMMAND' = 18,
  'SET FORMATION' = commandConstants.FORMATION.backendId,
  'DETACH FORMATION' = 20,
  'LAY MINE' = commandConstants.LAY_SEA_MINES.backendId,
  'SWEEP MINE' = commandConstants.SWEEP_SEA_MINES.backendId,
  'MARITIME TOWING' = commandConstants.MARITIME_TOWING.backendId,
  'NAVAL FIRE' = commandConstants.NAVAL_FIRE_SUPPORT.backendId,
  ROCKET = 24, // Bu bir kullanıcı emri değildir.
  'STOP' = commandConstants.LAND_STOP.backendId,
  'CONTINUE' = commandConstants.LAND_CONTINUE.backendId,
  'MAGIC SUPPLY' = commandConstants.MAGIC_SUPPLY.backendId,
  'LAND SUPPLY' = commandConstants.SUPPLY.backendId,
  'AUTOMATIC RESUPPLY' = 29,
  'AIR DEFENSE' = commandConstants.AIR_DEFENSE.backendId,
  'TORPEDO ENGAGEMENT' = commandConstants.TORPEDO.backendId,
  'SURFACE-TO-SURFACE MISSILE' = commandConstants.FIRE_SSM.backendId,
  'MARITIME LIFT' = commandConstants.MARITIME_LIFT.backendId,
  'GAME LOADED' = commandConstants.GAME_LOADED.backendId,
  'MARITIME EMBARKMENT' = commandConstants.MARITIME_EMBARKATION.backendId,
  'MARITIME DISEMBARKEMENT' = commandConstants.MARITIME_DISEMBARKATION.backendId,
  'LAY OBSTACLE' = commandConstants.LAY_OBSTACLE.backendId,
  'REMOVE OBSTACLE' = commandConstants.CLEAR_OBSTACLE.backendId,
  'CBRN ATTACK' = commandConstants.CBRN_ATTACK.backendId,
  'COMMUNICATION ESTABLISH' = commandConstants.COMMUNICATION_REMOVE_FROM_BL.backendId,
  'COMMUNICATION REMOVE' = commandConstants.COMMUNICATION_ADD_TO_BL.backendId,
  'FILL UP AGENT' = 42, // 42 ETMEN_TAMAMLA
  'CANCEL COMMAND' = 43, // 43 EMIR_IPTAL
  'CREATE MARITIME AGENT' = 44, // 44 DENIZ_ETMENI_OLUSTUR
  'MARITIME PATROL' = commandConstants.MARITIME_PATROL.backendId,
  'DEPTH CHARGE' = commandConstants.DEPTH_CHARGE.backendId,
  'CRUISE MISSILE FIRE' = 47, // SEYIR_FUZESI_ATESLE = 47,
  'MARITIME BOARDING' = commandConstants.MARITIME_BOARDING.backendId /** < DENIZ_CIKMA_ARAMA */,
  'MARITIME DOCK' = commandConstants.MARITIME_DOCK.backendId /** < DENIZ_DOCK */,
  'MARITIME UNDOCK' = commandConstants.MARITIME_UNDOCK.backendId /** < DENIZ_UNDOCK */,
  'AIR MISSION EXECUTION' = 51 /** < HAVA_GOREVI */,
  'MARITIME SUPPLY' = commandConstants.MARITIME_SUPPLY.backendId /** < DENIZDE_IKMAL */,
  'MARITIME TOW' = commandConstants.MARITIME_TOWING.backendId /** < DENIZ_CEKME */,
  'BUILD INFRASTRUCTURE' = commandConstants.BUILD_INFRASTRUCTURE.backendId,
  'FUEL LEAKING' = commandConstants.FUEL_LEAKING.backendId,
  'SURRENDER' = commandConstants.SURRENDER.backendId,
  'CAPTURE POW' = commandConstants.CAPTURE_POW.backendId,
  'HANDOVER POW' = commandConstants.LAND_HANDOVER_POW.backendId,
  'RELEASE POW' = commandConstants.RELEASE.backendId,
  'CHANGE MOVE SPEED' = commandConstants.LAND_SET_MOVE_SPEED.backendId,
  'MARITIME HANDOVER POW' = commandConstants.MARITIME_HANDOVER_POW.backendId,
  'UPDATE AGENT SUPPLIES AND ENTITIES' = commandConstants.CHANGE_CURRENT.backendId,
  'JAM' = commandConstants.LAND_JAM.backendId,
  'BULK TELEPORT' = commandConstants.BULK_TELEPORT.backendId,
  'AMBUSH' = commandConstants.LAND_AMBUSH.backendId,
  'RAID' = commandConstants.LAND_RAID.backendId,
  'CHANGE VOLUME' = commandConstants.CHANGE_VOLUME.backendId,
  'BULK MOVE' = commandConstants.LAND_BULK_MOVE.backendId,
  'BULK DEFEND' = commandConstants.BULK_DEFEND.backendId,
  'BULK ATTACK' = commandConstants.BULK_ATTACK.backendId,
  'BULK ENGAGEMENT' = commandConstants.LAND_BULK_ENGAGEMENT.backendId,
  'BULK WITHDRAW' = commandConstants.BULK_WITHDRAW.backendId,
  'BULK SURRENDER' = commandConstants.BULK_SURRENDER.backendId,
  'BULK SET MOVE' = commandConstants.LAND_BULK_SET_MOVE_SPEED.backendId,
  'BULK AMBUSH' = commandConstants.LAND_BULK_AMBUSH.backendId,
  'BULK MAGIC SUPPLY' = commandConstants.MAGIC_BULK_SUPPLY.backendId,
  'BULK UNMAGIC SUPPLY' = commandConstants.BULK_UNMAGIC_SUPPLY.backendId,
  'BULK DELETE' = commandConstants.BULK_DELETE.backendId,
  'BULK TOGGLE AIS' = commandConstants.BULK_TOGGLE_AIS.backendId,

  'LAND EMBARKMENT' = commandConstants.LAND_EMBARKMENT.backendId,
  'LAND DISEMBARKMENT' = commandConstants.LAND_DISEMBARKMENT.backendId,

  'CLEAR BUILDING' = commandConstants.LAND_CLEAR_BUILDING.backendId,
  'CBRN DECONTAMINTION' = commandConstants.CBRN_DECONTAMINATION.backendId,
  'REMOVE FROM MANIFEST' = commandConstants.LAND_REMOVE_FROM_MANIFEST.backendId,

  'LAND MAINTENANCE' = 84,
  'LAND MEDICAL EVACUATION' = 85,

  'TOGGLE ENTITY' = 90,
  'BULK TOGGLE ENTITY' = 91,

  'AIR LAND ATTACK COMAO' = 92,
  'PATROL COMAO' = 93,
  'EARLY WARNING COMAO' = 94,
  'GIVE FUEL SUPPLY COMAO' = 95,

  'LAND AUTO RECOVER' = 96,
  'LAND AUTO MEDICAL EVACUATION' = 97,
  'MPA COMAO' = 98,

  'CREATE AGENT' = commandConstants.CREATE_AGENT.backendId,
  'CREATE AGENT PROTOTYPE' = commandConstants.CREATE_AGENT_PROTOTYPE.backendId,
  'TPFDD' = commandConstants.TPFDD.backendId,
  'TIME START' = 128,
  'TIME PAUSE' = 129, // conflit with commandContants.FIRE_SSM.backendId
  'TIME STOP' = 130,
  'SIMULATION SPEED' = commandConstants.SIMULATION_SPEED.backendId,
  'SAVE CHECKPOINT' = commandConstants.SAVE_CHECKPOINT.backendId,
  'LOAD CHECKPOINT' = commandConstants.LOAD_CHECKPOINT.backendId,
  'TOGGLE AIS' = commandConstants.TOGGLE_AIS.backendId,
  'DELETE CHECKPOINT' = 135,
  'CHANGE SIDE RELATION' = 136,
  'UPDATE_AGENT' = 137,
  'CHANGE AGENT CONTROLLER' = 138,
  'MAGIC CRASH SINK' = 139,
  'CHANGE LANDING TYPE' = 140,
  'TOGGLE SURVIVOR' = 141,

  'AIR SUB-MISSION MOVE' = commandConstants.AIR_MOVE.backendId,
  'AIR SUB-MISSION GIVE REFUEL' = commandConstants.AIR_REFUEL_GIVER.backendId,
  'AIR SUB-MISSION TAKE REFUEL' = commandConstants.AIR_REFUEL_TAKER.backendId,
  'AIR SUB-MISSION AIR GROUND ATTACK' = commandConstants.AIR_GROUND_ATTACK.backendId,
  'AIR SUB-MISSION CAS' = 154,
  'AIR SUB-MISSION CCA' = 155,
  'AIR SUB-MISSION TASMO' = 165,
  'AIR SUB-MISSION AIR LIFT' = commandConstants.AIR_LIFT.backendId,
  'AIR SUB-MISSION AIR RECON' = commandConstants.AIR_RECONNAISANCE.backendId,
  'COMPOSITE AIR OPERATION' = 158,
  'AIR SUB-MISSION CAP' = commandConstants.AIR_CAP.backendId,
  'AIR SUB-MISSION ESCORT' = commandConstants.AIR_ESCORT.backendId,
  'AIR SUB-MISSION INTERCEPT' = commandConstants.AIR_INTERCEPT.backendId,
  'AIR SUB-MISSION SEAD' = commandConstants.AIR_SEAD.backendId,
  'AIR SUB-MISSION AWACS' = commandConstants.AIR_EWACS.backendId,
  'AIR SUB-MISSION S&R' = commandConstants.AIR_SNR.backendId,
  /*   'AIR SUB-MISSION MERGE' = commandConstants.AIR_MERGE.backendId,
  'AIR SUB-MISSION DIVIDE' = commandConstants.AIR_DIVIDE.backendId, */
  'CREATE COMAO' = 168, // KOMPOZIT_HAVA_HAREKATI_OLUSTUR
  'UPDATE COMAO' = 169, // KOMPOZIT_HAVA_HAREKATI_GUNCELLE
  'REMOVE COMAO' = 170, // KOMPOZIT_HAVA_HAREKATI_SIL

  'SPACE ORBIT MOVE' = 171,

  'CLEAR_HLA_AGENTS' = 172,
  'CLEAR AIS AGENTS' = 173,
  'AIR SUB-MISSION MPA' = 174,

  'EARTHQUAKE' = commandConstants.EARTHQUAKE.backendId,
  'FLOOD' = 201,
  'SEARCH AND RESCUE' = 202,

  'NOTIFICATION' = 255,

  'RUNTIME CRUD COMMAND' = 1000,
  'SPREAD POLLUTION' = 89,
} // End Emir enum

export enum CRUDEmirTuru {
  BOS = 0,
  TMK_EKLE, // SYSTEM
  TMK_DUZENLE,
  MUHIMMAT_TURU_EKLE, // AMMUNATION
  MUHIMMAT_TURU_DUZENLE,
  MUHIMMAT_INDEKS_EKLE, // AMMUNATION INDEKS
  MUHIMMAT_INDEKS_DUZENLE,
  HAVA_ARACI_EKLE, // AIRCRAFT
  HAVA_ARACI_DUZENLE,
  DENIZ_ARACI_EKLE, // NAVALCRAFT
  DENIZ_ARACI_DUZENLE,
  UZAY_ARACI_EKLE, // SPACECRAFT
  UZAY_ARACI_DUZENLE,
  INSAN_YAPIMI_ENGEL_EKLE, // OBSTACLE
  INSAN_YAPIMI_ENGEL_DUZENLE,
  MUHABERE_CIHAZI_EKLE, // COMM. DEVICE
  MUHABERE_CIHAZI_DUZENLE,
  ETMEN_SINIFI_EKLE, // FACTION
  ETMEN_SINIFI_DUZENLE,
  ETMEN_TURU_EKLE, // AGENT PROTOTYPE
  ETMEN_TURU_DUZENLE,
  ETMEN_EKLE, // AGENT
  ETMEN_DUZENLE,
  IKMAL_EKLE, // SUPPLY
  IKMAL_DUZENLE,
  IKMAL_CURUME_INDEKS_EKLE, // SUPPLY ALTINDAKI SEY
  IKMAL_CURUME_INDEKS_DUZENLE,
  FAYDALI_YUK_EKLE, // PAYLOAD
  FAYDALI_YUK_DUZENLE,
  ARAZI_KARESI_DUZENLE,
  HAVA_2D_3D_DUZENLE,
  ETMEN_SEMBOLU_DUZENLE,
  HAVA_ALANI_EKLE,
  HAVA_ALANI_DUZENLE,
  PIST_EKLE,
  PIST_DUZENLE,
  LIMAN_EKLE,
  LIMAN_DUZENLE,
}

export enum EHedefOncelik {
  HUMAN = 1,
  VEHICLE = 2,
  WEAPON = 3,
  SENSOR = 4,
}

// Land and maritime are also used
export enum ETimeOptions {
  ASAP = 1,
  'START TIME' = 2,
  'TAKE OFF TIME' = 2, // BASLANGIC ZAMANI
  'COMMAND CHAIN' = 3,
  // 'FINISH TIME' = 4,
  'TIME AT TARGET' = 4, // BITIS ZAMANI - yakın hava desteği, hava kara tarruzu vs.
  'TIME OF ARRIVAL' = 4, // BITIS ZAMANI - İntikal, geri çekilme, savunma, taşıma  vs
  COMAO = 5,
  // 'UYGULANAN_EMRI_IPTAL_ET_VE_BU_EMRI_HEMEN_UYGULA' = 6,
}

export enum ETimeOptionsCOMAO {
  ASAP = 1,
  'TAKE OFF TIME' = 2, // BASLANGIC ZAMANI
  'TIME OF ARRIVAL' = 4, // BITIS ZAMANI - İntikal, geri çekilme, savunma, taşıma  vs
}

export enum EIkmalTipleri {
  'PRODUCTION AND SUPPLY LINE' = 1,
  'PIPELINE AND FACILITY' = 2,
  'FROM ANOTHER AGENT' = 3,
}
export enum EIkmalGonderimSekli {
  IKMAL_GONDEREN_ETMEN_GIDER = 1,
  IKMAL_GONDEREN_ETMEN_KONVOY_GONDERIR,
  IKMAL_ALAN_ETMEN_GIDER,
  IKMAL_ALAN_ETMEN_KONVOY_GONDERIR,
}

export enum EUygulamaSekli {
  // PARALEL = 1,
  SIRALI = 2,
  'ONCEKI EMIRLERI IPTAL ET',
}
export enum EuygulamaForMergeAndDivide {
  // PARALEL = 1,
  SIRALI = 2,
  'ONCEKI EMIRLERI IPTAL ET',
  CONTINUE,
}

export enum EHavadanIntikalTuru {
  'BOS' = 0,
  'TAKTIK HAVA INTIKAL' = 1, // Piste ihtiyac duyan hava araclari // (AIRPORT TO AIRPORT)
  'HAVA INDIRME', // Tum hava araclari, etmen parasutle atlayabilmeli // (KONUM TO KONUM)
  'HAVA HUCUM', // Dikey inis yapabilen hava araclari                // (KONUM TO KONUM)
  'IDARI HAVA INTIKAL PISTTEN', // Piste ihtiyac duyan hava araclari // (AIRPORT TO AIRPORT)
  'IDARI INTIKAL DIKEY', // Dikey kalkis yapabilen hava araclari // (KONUM TO KONUM)
  // İdari hava intikal pistten -> arac piste itiyac duyuyorsa, duymuyorsa -> idare intikal dikey (aynı anda gözükemezler)
}

export enum EBakimTeslimSekli {
  'Empty' = 0,
  'Maintainer Agent Dispatches Convoy' = 1,
  'Maintainer Agent Goes' = 2,
  'Agent to be Maintained Dispatches Convoy' = 3,
  'Agent to be Maintained Goes' = 4,
}

export enum EMedicTeslimSekli {
  'Empty' = 0,
  'Medic Agent Dispatches Convoy' = 1,
  'Medic Agent Goes' = 2,
  'Agent to be Treated Dispatches Convoy' = 3,
  'Agent to be Treated Goes' = 4,
}

export enum EEntityType {
  EMPTY,
  SYSTEM,
  NAVALCRAFT,
  AIRCRAFT,
  SPACECRAFT,
  OBSTACLE,
  COMMDEVICE,
}

export enum EAirHedefTipi {
  'Location' = 1,
  'Agent' = 2,
}

export enum EDenizdeIndirmeTuru {
  LIMANDAN = 1,
  ETMEN,
  KONUM,
}

export enum EDenizdeBindirmeTuru {
  LIMANDAN = 1,
  ETMEN,
  KONUM,
}

export enum EDenizdeTasiyiciEtmeninDurumu {
  'KONUMDA_KAL',
  'KONUMA_GIT',
  'LIMAN',
}

export enum EAtisTipi {
  GOREREK = 1,
  GORMEYEREK,
  DENIZTOPCUSU,
  TORPIDO,
  SATIHSATIHROKETFUZE,
  KARAHAVAFUZE,
  KARAKARAFUZE,
  KBRNATIS,
  DEPTH_CHARGE,
  FIRE_NAV_MISSILE,
}

export enum EAtisHedefTipi {
  COORDINATE = 1,
  AGENT = 2,
}

export enum EWeightUnit {
  'Metric' = 1,
  'US' = 2,
}

export enum PendingStatusEnums {
  ETEMAP = 1,
  UPLOAD_QUADS,
  UPLOAD_TERRAIN,
  UPLOAD_WEATHER_DATA,
  UPLOAD_DATABASE,
  UPLOAD_METADATA,
  AXIOS_CONFIG,
  SEND_COMMANDS,
  APPLY_GROUP_COMMANDS,
  GAME_LOADING,
  LOADING_CP,
  LOADING_RUNS,
  LOADING_AGENTS,
  LOADING_SPACE,
  EXPORT_DATABASE,
  UPLOAD_COMMANDS,
  USER_MANUAL,
  CHANGING_DATABASE,
  WB_STATUS,
  GENERATE_TERRAIN_DATA,
  GENERATE_HEIGHT_AND_TERRAIN,
  TERRAIN_EXPORT,
  TERRAIN_IMPORT,
  QUAD_EXPORT,
  LOSS_ANALYSIS,
}

export enum EIstemci2DOlayTipi {
  BOS = 0,
  SILINTI = 1,
  BIRLESTI = 2,
  DEPREM = 3,
}

export enum EAlgiDurumu {
  'Not Detected or Identified' = 0,
  'Detected' = 1,
  'Prototype Identified' = 2,
  'Side Identified' = 3,
  'Prototype and Side Identified' = 4,
  'Identity Identified' = 5,
  'Contact Loss' = 6,
  'Self' = 7,
}

export enum EHavaTasimaIndirmeTuru {
  KONUM = 0,
  ETMEN = 1,
}

export enum EHavaTasimaBindirmeTuru {
  KONUM = 0,
  ETMEN = 1,
}

export enum EStorageOptions {
  REDIS_ONLY = 1,
  POSTGRES_ONLY = 2,
  BOTH = 3,
}
